import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  DateTime: any;
  Json: any;
  Tenant: any;
  Upload: any;
};

export type AddItemsReturn = {
  __typename?: 'AddItemsReturn';
  addItemsReturn?: Maybe<Array<Scalars['String']>>;
};

export type AddNoteInput = {
  modelId?: InputMaybe<Scalars['String']>;
  modelName?: InputMaybe<NoteModel>;
  note?: InputMaybe<Scalars['String']>;
  recipient?: InputMaybe<Scalars['String']>;
  sender?: InputMaybe<Scalars['String']>;
  sentAt?: InputMaybe<Scalars['DateTime']>;
  subject?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<NoteType>;
};

export type AddProviderRegionInput = {
  providerId: Scalars['String'];
  regionId: Scalars['String'];
};

export type Address = {
  __typename?: 'Address';
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  county?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<Broker>;
  id?: Maybe<Scalars['String']>;
  latitude?: Maybe<Scalars['Float']>;
  line1?: Maybe<Scalars['String']>;
  line2?: Maybe<Scalars['String']>;
  locationLabel?: Maybe<Scalars['String']>;
  longitude?: Maybe<Scalars['Float']>;
  name?: Maybe<Scalars['String']>;
  newCity?: Maybe<Scalars['String']>;
  newCountry?: Maybe<Scalars['String']>;
  newPostcode?: Maybe<Scalars['String']>;
  postcode?: Maybe<Scalars['String']>;
  streetName?: Maybe<Scalars['String']>;
  streetNumber?: Maybe<Scalars['String']>;
  streetNumberName?: Maybe<Scalars['String']>;
  suburb?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedBy?: Maybe<Broker>;
};

export type Amenity = {
  __typename?: 'Amenity';
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<Broker>;
  deal?: Maybe<Deal>;
  id: Scalars['String'];
  name: Scalars['String'];
  office?: Maybe<Office>;
  property?: Maybe<Property>;
  tenant: Scalars['Tenant'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedBy?: Maybe<Broker>;
};

export type AmenityInput = {
  cursor?: InputMaybe<Scalars['String']>;
  items?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  orderBy?: InputMaybe<Scalars['String']>;
  orderDirection?: InputMaybe<OrderDirection>;
};

export type AmneityListing = {
  __typename?: 'AmneityListing';
  data: Array<Amenity>;
  next?: Maybe<Scalars['String']>;
  previous?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['Int']>;
};

export enum Availability {
  Available = 'AVAILABLE',
  Comingsoon = 'COMINGSOON',
  Let = 'LET',
  Unavailable = 'UNAVAILABLE',
  Underoffer = 'UNDEROFFER',
  Unknown = 'UNKNOWN'
}

export type AvailabilityDashboardType = {
  __typename?: 'AvailabilityDashboardType';
  createdAt?: Maybe<Scalars['DateTime']>;
  createdOffices?: Maybe<Scalars['Int']>;
  createdProperties?: Maybe<Scalars['String']>;
  outdatedOffices?: Maybe<Scalars['Int']>;
  providerName?: Maybe<Scalars['String']>;
  updatedOffices?: Maybe<Scalars['Int']>;
};

export type AvailibilityInput = {
  available?: InputMaybe<Availability>;
  id?: InputMaybe<Scalars['String']>;
};

export type Bounds = {
  neLat?: InputMaybe<Scalars['Float']>;
  neLng?: InputMaybe<Scalars['Float']>;
  swLat?: InputMaybe<Scalars['Float']>;
  swLng?: InputMaybe<Scalars['Float']>;
};

export type BrochureData = {
  name: Scalars['String'];
  url: Scalars['String'];
};

export type BrochureDataToReturn = {
  __typename?: 'BrochureDataToReturn';
  name: Scalars['String'];
  url: Scalars['String'];
};

export type Broker = {
  __typename?: 'Broker';
  bookingLink?: Maybe<Scalars['String']>;
  brokerImage?: Maybe<Media>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<Broker>;
  email: Scalars['String'];
  externalRef?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isActive: Scalars['Boolean'];
  lastName?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  role: Roles;
  tenant?: Maybe<Scalars['Tenant']>;
  tenantId?: Maybe<Scalars['String']>;
  tokenCount?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedBy?: Maybe<Broker>;
};

export type BrokerToAddInput = {
  externalRef: Scalars['String'];
  secondaryBroker: SecondaryBroker;
};

export type BrokerToCreateInput = {
  email: Scalars['String'];
  firstName?: InputMaybe<Scalars['String']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  role: Roles;
};

export type BrokerToUpdateInput = {
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  isActive?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<Roles>;
};

export type BudgetRange = {
  __typename?: 'BudgetRange';
  from: Scalars['Int'];
  to: Scalars['Int'];
};

export type BudgetRangeWithProperties = {
  __typename?: 'BudgetRangeWithProperties';
  propertiesCount: Scalars['Int'];
  range: BudgetRange;
};

export enum BudgetSelection {
  Max = 'MAX',
  Na = 'NA',
  Range = 'RANGE'
}

export type Client = {
  __typename?: 'Client';
  address?: Maybe<Array<Maybe<Address>>>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<Broker>;
  deal: Array<Deal>;
  externalRef?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  tenant: Scalars['Tenant'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedBy?: Maybe<Broker>;
  website?: Maybe<Scalars['String']>;
};

export type ClientDeal = {
  __typename?: 'ClientDeal';
  broker: Broker;
  deal: Deal;
  otherProperties: Array<OtherProperty>;
  properties: Array<Property>;
  secondaryBroker?: Maybe<Broker>;
};

export enum ClientInfo {
  All = 'ALL',
  Client = 'CLIENT',
  Contact = 'CONTACT',
  None = 'NONE'
}

export type ClientListing = {
  __typename?: 'ClientListing';
  data?: Maybe<Array<Maybe<Client>>>;
  next?: Maybe<Scalars['String']>;
  previous?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['Int']>;
};

export enum ClientOrderBy {
  Name = 'name',
  Website = 'website'
}

export type ClientProperty = {
  __typename?: 'ClientProperty';
  broker: Broker;
  deal: Deal;
  property: Property;
};

export type ClientsInput = {
  cursor?: InputMaybe<Scalars['String']>;
  items?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  orderBy?: InputMaybe<Scalars['String']>;
};

export type Contact = {
  __typename?: 'Contact';
  contact?: Maybe<Array<Maybe<Contact>>>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<Broker>;
  deal?: Maybe<Array<Maybe<Deal>>>;
  email?: Maybe<Scalars['String']>;
  externalRef?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isActive?: Maybe<Scalars['Boolean']>;
  isSeed?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  property?: Maybe<Array<Maybe<Property>>>;
  provider?: Maybe<Array<Maybe<ContactToProvider>>>;
  providerRegion?: Maybe<Array<Maybe<ProviderRegion>>>;
  seedContact?: Maybe<Contact>;
  seedContactId?: Maybe<Scalars['String']>;
  tenant: Scalars['Tenant'];
  tenantId?: Maybe<Scalars['String']>;
  tokenCount?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedBy?: Maybe<Broker>;
};

export type ContactToProvider = {
  __typename?: 'ContactToProvider';
  contact: Contact;
  contactId: Scalars['String'];
  contactType: ProviderContactType;
  provider: Provider;
  providerId: Scalars['String'];
};

export type CreateAddress = {
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  county?: InputMaybe<Scalars['String']>;
  latitude?: InputMaybe<Scalars['Float']>;
  line1?: InputMaybe<Scalars['String']>;
  line2?: InputMaybe<Scalars['String']>;
  longitude?: InputMaybe<Scalars['Float']>;
  name?: InputMaybe<Scalars['String']>;
  postcode?: InputMaybe<Scalars['String']>;
  suburb?: InputMaybe<Scalars['String']>;
};

export type CreateNotificationInput = {
  message: Scalars['String'];
  recipientId: Scalars['String'];
  subject: Scalars['String'];
};

export type Currency = {
  __typename?: 'Currency';
  code: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
  providerRegion?: Maybe<Array<Maybe<ProviderRegion>>>;
  region?: Maybe<Array<Maybe<Region>>>;
  symbol: Scalars['String'];
};

export type Deal = {
  __typename?: 'Deal';
  amenity: Array<Amenity>;
  budget?: Maybe<Scalars['Float']>;
  canFavourite?: Maybe<Scalars['Boolean']>;
  client: Client;
  contact: Contact;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<Broker>;
  currentAddress?: Maybe<Address>;
  desks?: Maybe<Scalars['Float']>;
  endAddressId?: Maybe<Scalars['String']>;
  externalRef?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  leadBroker: Broker;
  location?: Maybe<Scalars['String']>;
  locationNames: Array<Scalars['String']>;
  name: Scalars['String'];
  note: Array<Note>;
  providerRegion?: Maybe<Scalars['String']>;
  providerRegistration: Array<ProviderRegistration>;
  schedule: Schedule;
  secondaryBroker?: Maybe<Broker>;
  showAvailableFrom?: Maybe<Scalars['Boolean']>;
  showMatchingToggle?: Maybe<Scalars['Boolean']>;
  showProviderFilter?: Maybe<Scalars['Boolean']>;
  size?: Maybe<Scalars['Float']>;
  sizeUnit: SizeUnit;
  startAddressId?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  tenant: Scalars['Tenant'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedBy?: Maybe<Broker>;
};

export type DealListing = {
  __typename?: 'DealListing';
  data: Array<Deal>;
  next: Scalars['String'];
  previous: Scalars['String'];
  total: Scalars['Int'];
};

export type DealOutput = {
  __typename?: 'DealOutput';
  deal: Deal;
  orderedProperties: Array<ScheduleProperty>;
};

export type DealViewingOutput = {
  __typename?: 'DealViewingOutput';
  deal: Deal;
};

export type DealsInput = {
  brokerId?: InputMaybe<Scalars['String']>;
  cursor?: InputMaybe<Scalars['String']>;
  items?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  orderBy?: InputMaybe<Scalars['String']>;
};

export type FavouriteUpdate = {
  __typename?: 'FavouriteUpdate';
  favouriteCount: Scalars['Int'];
  id: Scalars['String'];
  status: ScheduleOfficeStatus;
};

export type FileTitles = {
  filename?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type FindOfficeFiltersInput = {
  amenity?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  availableFrom?: InputMaybe<Scalars['DateTime']>;
  budget?: InputMaybe<Range>;
  desks?: InputMaybe<Range>;
  fittedType?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  location?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  minimumTerm?: InputMaybe<Range>;
  minimumTermUnit?: InputMaybe<TermUnit>;
  officeType?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  provider?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  radius?: InputMaybe<Scalars['Float']>;
  radiusFrom?: InputMaybe<RadiusPoint>;
  region?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  searchString?: InputMaybe<Scalars['String']>;
  showDisposals?: InputMaybe<Scalars['Boolean']>;
  showUnavailable?: InputMaybe<Scalars['Boolean']>;
  singleFloor?: InputMaybe<Scalars['Boolean']>;
  size?: InputMaybe<Range>;
  sizeUnit?: InputMaybe<SizeUnit>;
};

export type FindOfficePropertyFiltersInput = {
  amenity?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  availableFrom?: InputMaybe<Scalars['DateTime']>;
  budget?: InputMaybe<Range>;
  desks?: InputMaybe<Range>;
  location?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  minimumTerm?: InputMaybe<Range>;
  minimumTermUnit?: InputMaybe<TermUnit>;
  officeType?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  propertyId?: InputMaybe<Scalars['String']>;
  provider?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  radius?: InputMaybe<Scalars['Float']>;
  radiusFrom?: InputMaybe<RadiusPoint>;
  region?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  searchString?: InputMaybe<Scalars['String']>;
  showDisposals?: InputMaybe<Scalars['Boolean']>;
  showUnavailable?: InputMaybe<Scalars['Boolean']>;
  singleFloor?: InputMaybe<Scalars['Boolean']>;
  size?: InputMaybe<Range>;
  sizeUnit?: InputMaybe<SizeUnit>;
};

export enum Fitted {
  Fitted = 'FITTED',
  Nonfitted = 'NONFITTED',
  Unknown = 'UNKNOWN'
}

export type FloorplanData = {
  type: Scalars['String'];
  url: Scalars['String'];
};

export type FloorplanDataToReturn = {
  __typename?: 'FloorplanDataToReturn';
  type: Scalars['String'];
  url: Scalars['String'];
};

export type HeyLead = {
  __typename?: 'HeyLead';
  budgetFrom?: Maybe<Scalars['Float']>;
  budgetTo?: Maybe<Scalars['Float']>;
  comment?: Maybe<Scalars['String']>;
  companyEmail: Scalars['String'];
  companyName?: Maybe<Scalars['String']>;
  companyPhone?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  desksFrom?: Maybe<Scalars['Int']>;
  desksTo?: Maybe<Scalars['Int']>;
  fullName: Scalars['String'];
  id: Scalars['String'];
  locations?: Maybe<Array<Maybe<Scalars['String']>>>;
  selectedOffices?: Maybe<Scalars['Json']>;
  sessionId?: Maybe<Scalars['String']>;
};

export type HeyLeadCreateInput = {
  budgetFrom?: InputMaybe<Scalars['Float']>;
  budgetOption?: InputMaybe<Scalars['String']>;
  budgetTo?: InputMaybe<Scalars['Float']>;
  comment?: InputMaybe<Scalars['String']>;
  companyEmail: Scalars['String'];
  companyName?: InputMaybe<Scalars['String']>;
  companyPhone?: InputMaybe<Scalars['String']>;
  desksFrom?: InputMaybe<Scalars['Int']>;
  desksTo?: InputMaybe<Scalars['Int']>;
  fullName: Scalars['String'];
  locations?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  selectedOffices?: InputMaybe<Scalars['Json']>;
  sessionId?: InputMaybe<Scalars['String']>;
};

export type HeyListing = {
  __typename?: 'HeyListing';
  companyEmail: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  fullName: Scalars['String'];
  id: Scalars['String'];
  message?: Maybe<Scalars['String']>;
  sessionId?: Maybe<Scalars['String']>;
};

export type HeyListingCreateInput = {
  companyEmail: Scalars['String'];
  fullName: Scalars['String'];
  message?: InputMaybe<Scalars['String']>;
  sessionId?: InputMaybe<Scalars['String']>;
};

export type HeySearch = {
  __typename?: 'HeySearch';
  amenities?: Maybe<Array<Maybe<Scalars['String']>>>;
  budgetFrom?: Maybe<Scalars['Int']>;
  budgetOption?: Maybe<Scalars['String']>;
  budgetTo?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  locations?: Maybe<Array<Maybe<Scalars['String']>>>;
  sessionId?: Maybe<Scalars['String']>;
  showUnavailable?: Maybe<Scalars['Boolean']>;
  sizeFrom?: Maybe<Scalars['Int']>;
  sizeOption?: Maybe<Scalars['String']>;
  sizeTo?: Maybe<Scalars['Int']>;
};

export type IdsReturn = {
  __typename?: 'IdsReturn';
  result?: Maybe<Scalars['String']>;
};

export type Instruction = {
  __typename?: 'Instruction';
  broker: Array<Broker>;
  id: Scalars['String'];
};

export type InstructionInput = {
  broker: Array<InputMaybe<Scalars['String']>>;
};

export type ItemOffice = {
  available: Availability;
  estate: Scalars['String'];
  fitted: Fitted;
  name: Scalars['String'];
  property: Scalars['String'];
  ratesPay: Scalars['String'];
  rentSqft: Scalars['String'];
  service: Scalars['String'];
  sqft: Scalars['String'];
  sqm: Scalars['String'];
  totalMonth: Scalars['String'];
};

export type ItemOfficeToReturn = {
  __typename?: 'ItemOfficeToReturn';
  available: Availability;
  estate: Scalars['String'];
  fitted: Fitted;
  name: Scalars['String'];
  property: Scalars['String'];
  ratesPay: Scalars['String'];
  rentSqft: Scalars['String'];
  service: Scalars['String'];
  sqft: Scalars['String'];
  sqm: Scalars['String'];
  totalMonth: Scalars['String'];
};

export type ItemsToReturn = {
  __typename?: 'ItemsToReturn';
  address: Scalars['String'];
  ameneties?: Maybe<Array<Scalars['String']>>;
  brouchure?: Maybe<Array<BrochureDataToReturn>>;
  description?: Maybe<Scalars['String']>;
  floorplan?: Maybe<Array<FloorplanDataToReturn>>;
  images?: Maybe<Array<Scalars['String']>>;
  lat: Scalars['String'];
  leaseType: PropertyType;
  lng: Scalars['String'];
  name: Scalars['String'];
  offices?: Maybe<Array<ItemOfficeToReturn>>;
};

export type ItemstoAdd = {
  input?: InputMaybe<Array<ItemstoAddInput>>;
};

export type ItemstoAddInput = {
  address: Scalars['String'];
  ameneties?: InputMaybe<Array<Scalars['String']>>;
  brouchure?: InputMaybe<Array<BrochureData>>;
  description?: InputMaybe<Scalars['String']>;
  floorplan?: InputMaybe<Array<FloorplanData>>;
  images?: InputMaybe<Array<Scalars['String']>>;
  lat: Scalars['String'];
  leaseType: PropertyType;
  lng: Scalars['String'];
  name: Scalars['String'];
  offices?: InputMaybe<Array<ItemOffice>>;
};

export type Landmark = {
  __typename?: 'Landmark';
  address?: Maybe<Address>;
  addressId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<Broker>;
  createdById?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  distance?: Maybe<Scalars['Float']>;
  distanceText?: Maybe<Scalars['String']>;
  duration?: Maybe<Scalars['Float']>;
  durationText?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  image?: Maybe<Array<Maybe<Media>>>;
  isActive?: Maybe<Scalars['Boolean']>;
  isSeed?: Maybe<Scalars['Boolean']>;
  landmark?: Maybe<Array<Maybe<Landmark>>>;
  name: Scalars['String'];
  property?: Maybe<Property>;
  propertyId?: Maybe<Scalars['String']>;
  seedLandmark?: Maybe<Landmark>;
  seedLandmarkId?: Maybe<Scalars['String']>;
  tenant: Scalars['Tenant'];
  tenantId: Scalars['String'];
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedBy?: Maybe<Broker>;
  updatedById?: Maybe<Scalars['String']>;
};

export type LandmarkInput = {
  distance: Scalars['Int'];
  distanceText: Scalars['String'];
  duration: Scalars['Int'];
  durationText: Scalars['String'];
  lat: Scalars['Float'];
  lng: Scalars['Float'];
  name: Scalars['String'];
  placeId: Scalars['String'];
  type: Scalars['String'];
};

export enum LeadTimeUnit {
  Month = 'MONTH',
  Week = 'WEEK'
}

export type Me = {
  __typename?: 'Me';
  dealId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  externalRef?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isActive?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  role?: Maybe<Roles>;
  tenant?: Maybe<Scalars['Tenant']>;
  tenantId?: Maybe<Scalars['String']>;
  tokenCount: Scalars['Int'];
};

export type Media = {
  __typename?: 'Media';
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<Broker>;
  encoding?: Maybe<Scalars['String']>;
  filename?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isActive?: Maybe<Scalars['Boolean']>;
  isSeed?: Maybe<Scalars['Boolean']>;
  location: Scalars['String'];
  mimetype?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Int']>;
  seedMedia?: Maybe<Media>;
  seedMediaId?: Maybe<Scalars['String']>;
  tenant?: Maybe<Scalars['Tenant']>;
  tenantId?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedBy?: Maybe<Broker>;
};

export type Mutation = {
  __typename?: 'Mutation';
  addItemsToDatabase?: Maybe<AddItemsReturn>;
  addNote?: Maybe<Note>;
  addProviderContact?: Maybe<ContactToProvider>;
  addProviderRegion?: Maybe<Provider>;
  addSecondaryBroker?: Maybe<Deal>;
  addUser?: Maybe<User>;
  checkScraper?: Maybe<ScraperReturn>;
  createAmenity?: Maybe<Amenity>;
  createBroker?: Maybe<Broker>;
  createHeyLead?: Maybe<HeyLead>;
  createHeyListing?: Maybe<HeyListing>;
  createNotification?: Maybe<Notification>;
  createOffice?: Maybe<Office>;
  createProperty?: Maybe<Property>;
  createProvider?: Maybe<Provider>;
  createProviderContact?: Maybe<ContactToProvider>;
  createProviderRegistration?: Maybe<Array<Maybe<ProviderRegistration>>>;
  createRegion?: Maybe<Region>;
  createScheduleOffices?: Maybe<Array<Maybe<ScheduleOffice>>>;
  createTour: Media;
  deleteOffice?: Maybe<Office>;
  deleteProperty?: Maybe<Property>;
  deleteProvider?: Maybe<Provider>;
  deleteRegion?: Maybe<Region>;
  favouriteScheduleOffice?: Maybe<FavouriteUpdate>;
  invalidateTokens?: Maybe<Scalars['Boolean']>;
  logout?: Maybe<Scalars['Boolean']>;
  notifyBroker?: Maybe<Scalars['Boolean']>;
  outOfDateLeasingSetDormant?: Maybe<Array<Maybe<Office>>>;
  outOfDateNotification?: Maybe<Array<Maybe<Office>>>;
  outOfDateSetUnavailable?: Maybe<Array<Maybe<Office>>>;
  removeProviderContact?: Maybe<ContactToProvider>;
  removeProviderRegion?: Maybe<Provider>;
  removeScheduleOffices?: Maybe<ScheduleOfficesRemoved>;
  retrieveNotes: Array<Note>;
  runScraper?: Maybe<IdsReturn>;
  runScraperoriginal?: Maybe<IdsReturn>;
  runXml?: Maybe<Array<Maybe<Office>>>;
  sendMagicLink: Scalars['String'];
  sendPublicMagicLink: Scalars['String'];
  setAvailability?: Maybe<Office>;
  setNugget?: Maybe<Office>;
  setScheduleOfficeStatus?: Maybe<ScheduleOffice>;
  setViewingMapProperty?: Maybe<Deal>;
  syncScheduleOffice?: Maybe<ScheduleOffice>;
  toggleCanFavourite?: Maybe<Deal>;
  toggleShowAvailableFrom?: Maybe<Deal>;
  toggleShowMatching?: Maybe<Deal>;
  toggleShowProviderFilter?: Maybe<Deal>;
  updateBroker?: Maybe<Broker>;
  updateMediaPosition?: Maybe<Array<Maybe<Media>>>;
  updateMediaTitle?: Maybe<Media>;
  updateNotification: Array<Notification>;
  updateOffice?: Maybe<Office>;
  updateOfficeMedia?: Maybe<Office>;
  updateProperty?: Maybe<Property>;
  updatePropertyMedia?: Maybe<Property>;
  updatePropertyScheduleOrder?: Maybe<Array<Maybe<ScheduleProperty>>>;
  updateProvider?: Maybe<Provider>;
  updateProviderContact?: Maybe<ContactToProvider>;
  updateProviderRegistration?: Maybe<ProviderRegistration>;
  updateRegion?: Maybe<Region>;
  updateScheduleOffice?: Maybe<ScheduleOffice>;
  updateScheduleOfficesStatus?: Maybe<Array<Maybe<ScheduleOffice>>>;
  uploadMedia?: Maybe<Array<Maybe<Media>>>;
};


export type MutationAddItemsToDatabaseArgs = {
  input?: InputMaybe<ItemstoAdd>;
};


export type MutationAddNoteArgs = {
  input?: InputMaybe<AddNoteInput>;
};


export type MutationAddProviderContactArgs = {
  input?: InputMaybe<ProviderContactUpdateInput>;
};


export type MutationAddProviderRegionArgs = {
  input?: InputMaybe<AddProviderRegionInput>;
};


export type MutationAddSecondaryBrokerArgs = {
  input?: InputMaybe<BrokerToAddInput>;
};


export type MutationAddUserArgs = {
  user?: InputMaybe<UserInput>;
};


export type MutationCheckScraperArgs = {
  id?: InputMaybe<Scalars['String']>;
};


export type MutationCreateAmenityArgs = {
  name?: InputMaybe<Scalars['String']>;
};


export type MutationCreateBrokerArgs = {
  input?: InputMaybe<BrokerToCreateInput>;
};


export type MutationCreateHeyLeadArgs = {
  input: HeyLeadCreateInput;
};


export type MutationCreateHeyListingArgs = {
  input: HeyListingCreateInput;
};


export type MutationCreateNotificationArgs = {
  input?: InputMaybe<CreateNotificationInput>;
};


export type MutationCreateOfficeArgs = {
  input?: InputMaybe<OfficeCreateInput>;
};


export type MutationCreatePropertyArgs = {
  input?: InputMaybe<PropertyToCreateInput>;
};


export type MutationCreateProviderArgs = {
  input?: InputMaybe<ProviderCreateInput>;
};


export type MutationCreateProviderContactArgs = {
  input?: InputMaybe<ProviderContactCreateInput>;
};


export type MutationCreateProviderRegistrationArgs = {
  input?: InputMaybe<ProviderRegistrationInput>;
};


export type MutationCreateRegionArgs = {
  input?: InputMaybe<RegionCreateInput>;
};


export type MutationCreateScheduleOfficesArgs = {
  input?: InputMaybe<Array<InputMaybe<ScheduleOfficeCreateInput>>>;
};


export type MutationCreateTourArgs = {
  location?: InputMaybe<Scalars['String']>;
};


export type MutationDeleteOfficeArgs = {
  input?: InputMaybe<OfficeDeleteInput>;
};


export type MutationDeletePropertyArgs = {
  input?: InputMaybe<PropertyToDeleteInput>;
};


export type MutationDeleteProviderArgs = {
  input?: InputMaybe<ProviderDeleteInput>;
};


export type MutationDeleteRegionArgs = {
  id?: InputMaybe<Scalars['String']>;
};


export type MutationFavouriteScheduleOfficeArgs = {
  id?: InputMaybe<Scalars['String']>;
};


export type MutationNotifyBrokerArgs = {
  dealId?: InputMaybe<Scalars['String']>;
};


export type MutationRemoveProviderContactArgs = {
  input?: InputMaybe<ProviderContactUpdateInput>;
};


export type MutationRemoveProviderRegionArgs = {
  input?: InputMaybe<RemoveProviderRegionInput>;
};


export type MutationRemoveScheduleOfficesArgs = {
  input?: InputMaybe<ScheduleOfficeRemoveInput>;
};


export type MutationRetrieveNotesArgs = {
  dealId?: InputMaybe<Scalars['String']>;
};


export type MutationRunScraperArgs = {
  input?: InputMaybe<ScraperInput>;
};


export type MutationRunScraperoriginalArgs = {
  input?: InputMaybe<ScraperInput>;
};


export type MutationSendMagicLinkArgs = {
  email: Scalars['String'];
  tenantName: Scalars['String'];
};


export type MutationSendPublicMagicLinkArgs = {
  dealId: Scalars['String'];
  email: Scalars['String'];
};


export type MutationSetAvailabilityArgs = {
  input?: InputMaybe<AvailibilityInput>;
};


export type MutationSetNuggetArgs = {
  input?: InputMaybe<NuggetInput>;
};


export type MutationSetScheduleOfficeStatusArgs = {
  input?: InputMaybe<SetScheduleOfficeStatusInput>;
};


export type MutationSetViewingMapPropertyArgs = {
  input?: InputMaybe<SetViewingMapPropertyId>;
};


export type MutationSyncScheduleOfficeArgs = {
  input?: InputMaybe<SyncOfficeInput>;
};


export type MutationToggleCanFavouriteArgs = {
  input?: InputMaybe<ToggleCanFavouriteFromInput>;
};


export type MutationToggleShowAvailableFromArgs = {
  input?: InputMaybe<ToggleShowAvailableFromInput>;
};


export type MutationToggleShowMatchingArgs = {
  input?: InputMaybe<ToggleShowMatchingFromInput>;
};


export type MutationToggleShowProviderFilterArgs = {
  input?: InputMaybe<ToggleShowProviderFilterInput>;
};


export type MutationUpdateBrokerArgs = {
  input?: InputMaybe<BrokerToUpdateInput>;
};


export type MutationUpdateMediaPositionArgs = {
  input?: InputMaybe<UpdatePosition>;
};


export type MutationUpdateMediaTitleArgs = {
  input?: InputMaybe<TitleUpdate>;
};


export type MutationUpdateNotificationArgs = {
  input?: InputMaybe<UpdateNotificationInput>;
};


export type MutationUpdateOfficeArgs = {
  input?: InputMaybe<OfficeUpdateInput>;
};


export type MutationUpdateOfficeMediaArgs = {
  input?: InputMaybe<OfficeMediaToUpdateInput>;
};


export type MutationUpdatePropertyArgs = {
  input?: InputMaybe<PropertyToUpdateInput>;
};


export type MutationUpdatePropertyMediaArgs = {
  input?: InputMaybe<PropertyMediaToUpdateInput>;
};


export type MutationUpdatePropertyScheduleOrderArgs = {
  input?: InputMaybe<UpdatePropertyScheduleOrderInput>;
};


export type MutationUpdateProviderArgs = {
  input?: InputMaybe<ProviderUpdateInput>;
};


export type MutationUpdateProviderContactArgs = {
  input?: InputMaybe<ProviderContactUpdateInput>;
};


export type MutationUpdateProviderRegistrationArgs = {
  input?: InputMaybe<ProviderRegistrationUpdate>;
};


export type MutationUpdateRegionArgs = {
  input?: InputMaybe<RegionUpdateInput>;
};


export type MutationUpdateScheduleOfficeArgs = {
  input?: InputMaybe<ScheduleOfficeUpdateInput>;
};


export type MutationUpdateScheduleOfficesStatusArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<ScheduleOfficeStatus>;
  statusDetail?: InputMaybe<Scalars['String']>;
};


export type MutationUploadMediaArgs = {
  input?: InputMaybe<UploadMediaInput>;
};

export type NearbyPlaces = {
  __typename?: 'NearbyPlaces';
  distance: Scalars['Int'];
  distanceText: Scalars['String'];
  duration: Scalars['Int'];
  durationText: Scalars['String'];
  lat: Scalars['Float'];
  lng: Scalars['Float'];
  name: Scalars['String'];
  placeId: Scalars['String'];
  position: Scalars['Int'];
};

export type Note = {
  __typename?: 'Note';
  createdAt: Scalars['DateTime'];
  createdBy: Broker;
  deal?: Maybe<Deal>;
  dealId?: Maybe<Scalars['String']>;
  externalRef?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  note: Scalars['String'];
  office?: Maybe<Office>;
  officeId?: Maybe<Scalars['String']>;
  property?: Maybe<Property>;
  propertyId?: Maybe<Scalars['String']>;
  providerRegistration?: Maybe<ProviderRegistration>;
  providerRegistrationId?: Maybe<Scalars['String']>;
  recipient?: Maybe<Scalars['String']>;
  scheduleOffice?: Maybe<ScheduleOffice>;
  scheduleOfficeId?: Maybe<Scalars['String']>;
  sender?: Maybe<Scalars['String']>;
  sentAt?: Maybe<Scalars['DateTime']>;
  subject?: Maybe<Scalars['String']>;
  tenant: Scalars['Tenant'];
  tenantId: Scalars['String'];
  type?: Maybe<NoteType>;
  updatedAt: Scalars['DateTime'];
  updatedBy: Broker;
};

export enum NoteModel {
  Deal = 'DEAL',
  Office = 'OFFICE',
  Property = 'PROPERTY',
  ScheduleOffice = 'SCHEDULE_OFFICE'
}

export enum NoteType {
  Call = 'CALL',
  Email = 'EMAIL',
  Meeting = 'MEETING',
  Note = 'NOTE',
  Task = 'TASK'
}

export type Notification = {
  __typename?: 'Notification';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  readAt?: Maybe<Scalars['DateTime']>;
  recipient?: Maybe<Broker>;
  recipientId?: Maybe<Scalars['String']>;
  subject?: Maybe<Scalars['String']>;
  tenant?: Maybe<Scalars['Tenant']>;
  tenantId?: Maybe<Scalars['String']>;
};

export type NuggetInput = {
  id?: InputMaybe<Scalars['String']>;
  isNugget?: InputMaybe<Scalars['Boolean']>;
};

export type Office = {
  __typename?: 'Office';
  amenity: Array<Amenity>;
  available: Availability;
  availableFrom?: Maybe<Scalars['DateTime']>;
  availableUntil?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<Broker>;
  description?: Maybe<Scalars['String']>;
  desks?: Maybe<Scalars['Int']>;
  disposalComments?: Maybe<Scalars['String']>;
  estateCharge?: Maybe<Scalars['Float']>;
  featureImage?: Maybe<Media>;
  fitted: Fitted;
  floor?: Maybe<Scalars['Int']>;
  floorplan: Array<Media>;
  groundRent?: Maybe<Scalars['Float']>;
  id: Scalars['String'];
  image: Array<Media>;
  instructedOffice: Scalars['Boolean'];
  leadTime?: Maybe<Scalars['Int']>;
  leadTimeUnit?: Maybe<LeadTimeUnit>;
  minimumTerm?: Maybe<Scalars['Int']>;
  minimumTermUnit: TermUnit;
  name: Scalars['String'];
  note?: Maybe<Array<Maybe<Note>>>;
  nuggetedAt?: Maybe<Scalars['DateTime']>;
  nuggetedBy?: Maybe<Broker>;
  nuggetedById?: Maybe<Scalars['String']>;
  officeType: OfficeType;
  price?: Maybe<Scalars['Float']>;
  property: Property;
  propertyId: Scalars['String'];
  rates?: Maybe<Scalars['Float']>;
  show?: Maybe<Scalars['Boolean']>;
  size?: Maybe<Scalars['Int']>;
  sizeUnit: SizeUnit;
  tenant: Scalars['Tenant'];
  tenantId: Scalars['String'];
  totalCost?: Maybe<Scalars['Float']>;
  tour: Array<Media>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedBy?: Maybe<Broker>;
};

export type OfficeCreateInput = {
  amenities?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  available?: InputMaybe<Availability>;
  availableFrom?: InputMaybe<Scalars['DateTime']>;
  availableUntil?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  desks?: InputMaybe<Scalars['Int']>;
  disposalComments?: InputMaybe<Scalars['String']>;
  estateCharge?: InputMaybe<Scalars['Float']>;
  featureImageId?: InputMaybe<Scalars['String']>;
  fitted: Fitted;
  floor?: InputMaybe<Scalars['Int']>;
  floorplanIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  groundRent?: InputMaybe<Scalars['Float']>;
  imageIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  instructedOffice?: InputMaybe<Scalars['Boolean']>;
  leadTime?: InputMaybe<Scalars['Int']>;
  leadTimeUnit?: InputMaybe<LeadTimeUnit>;
  minimumTerm?: InputMaybe<Scalars['Int']>;
  minimumTermUnit: TermUnit;
  name?: InputMaybe<Scalars['String']>;
  note?: InputMaybe<Scalars['String']>;
  officeType: OfficeType;
  price?: InputMaybe<Scalars['Float']>;
  propertyId: Scalars['String'];
  rates?: InputMaybe<Scalars['Float']>;
  size?: InputMaybe<Scalars['Int']>;
  sizeUnit?: InputMaybe<SizeUnit>;
  totalCost?: InputMaybe<Scalars['Float']>;
  tourIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type OfficeDeleteInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type OfficeFiltersInput = {
  amenity?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  availableFrom?: InputMaybe<Scalars['DateTime']>;
  bounds?: InputMaybe<Bounds>;
  budget?: InputMaybe<Range>;
  desks?: InputMaybe<Range>;
  location?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  minimumTerm?: InputMaybe<Range>;
  minimumTermUnit?: InputMaybe<TermUnit>;
  officeType?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  provider?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  radius?: InputMaybe<Scalars['Float']>;
  radiusFrom?: InputMaybe<RadiusPoint>;
  region?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  searchString?: InputMaybe<Scalars['String']>;
  sessionId?: InputMaybe<Scalars['String']>;
  showDisposals?: InputMaybe<Scalars['Boolean']>;
  showUnavailable?: InputMaybe<Scalars['Boolean']>;
  size?: InputMaybe<Range>;
  sizeUnit?: InputMaybe<SizeUnit>;
};

export type OfficeInput = {
  amenity?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  availability?: InputMaybe<Scalars['Boolean']>;
  availableFrom?: InputMaybe<Scalars['DateTime']>;
  budget?: InputMaybe<Range>;
  cursor?: InputMaybe<Scalars['String']>;
  desks?: InputMaybe<Range>;
  instruction?: InputMaybe<Scalars['Boolean']>;
  items?: InputMaybe<Scalars['Int']>;
  location?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  minimumTerm?: InputMaybe<Range>;
  name?: InputMaybe<Scalars['String']>;
  nuggets?: InputMaybe<Scalars['Boolean']>;
  officeType?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  orderDirection?: InputMaybe<OrderDirection>;
  provider?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  region?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  showUnavailable?: InputMaybe<Scalars['Boolean']>;
  singleFloor?: InputMaybe<Scalars['Boolean']>;
  size?: InputMaybe<Range>;
  sizeUnit?: InputMaybe<SizeUnit>;
};

export type OfficeListing = {
  __typename?: 'OfficeListing';
  data: Array<Office>;
  next?: Maybe<Scalars['String']>;
  previous?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['Int']>;
};

export type OfficeMediaToUpdateInput = {
  floorplanIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['String']>;
  imageIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  tourIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type OfficeReturn = {
  __typename?: 'OfficeReturn';
  loggedIn?: Maybe<Scalars['String']>;
  returnOffice?: Maybe<Array<ItemsToReturn>>;
};

export type OfficeSearchBudgetInput = {
  budgetOption?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<OfficeFiltersInput>;
  unselectedProviders?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type OfficeSearchData = {
  __typename?: 'OfficeSearchData';
  amenities: Array<PartialAmenity>;
  providers: Array<PartialProvider>;
  regions: Array<PartialRegion>;
};

export type OfficeSearchDataBudget = {
  __typename?: 'OfficeSearchDataBudget';
  avgPrice?: Maybe<Scalars['Int']>;
  data: Array<BudgetRangeWithProperties>;
  max?: Maybe<Scalars['Int']>;
  min?: Maybe<Scalars['Int']>;
};

export type OfficeSearchDataProviders = {
  __typename?: 'OfficeSearchDataProviders';
  providers: Array<PartialProvider>;
};

export type OfficeSearchProperties = {
  __typename?: 'OfficeSearchProperties';
  properties: Array<Property>;
};

export type OfficeSearchProperty = {
  __typename?: 'OfficeSearchProperty';
  property?: Maybe<Property>;
};

export enum OfficeType {
  Assignment = 'ASSIGNMENT',
  Hotdesk = 'HOTDESK',
  Lease = 'LEASE',
  Managed = 'MANAGED',
  Purchase = 'PURCHASE',
  Serviced = 'SERVICED',
  Sublease = 'SUBLEASE'
}

export type OfficeUpdateInput = {
  amenities?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  available?: InputMaybe<Availability>;
  availableFrom?: InputMaybe<Scalars['DateTime']>;
  availableUntil?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  desks?: InputMaybe<Scalars['Int']>;
  disposalComments?: InputMaybe<Scalars['String']>;
  estateCharge?: InputMaybe<Scalars['Float']>;
  featureImageId?: InputMaybe<Scalars['String']>;
  fitted?: InputMaybe<Fitted>;
  floor?: InputMaybe<Scalars['Int']>;
  floorplanIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  groundRent?: InputMaybe<Scalars['Float']>;
  id?: InputMaybe<Scalars['String']>;
  imageIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  instructedOffice?: InputMaybe<Scalars['Boolean']>;
  isNugget?: InputMaybe<Scalars['Boolean']>;
  leadTime?: InputMaybe<Scalars['Int']>;
  leadTimeUnit?: InputMaybe<LeadTimeUnit>;
  minimumTerm?: InputMaybe<Scalars['Int']>;
  minimumTermUnit?: InputMaybe<TermUnit>;
  name?: InputMaybe<Scalars['String']>;
  note?: InputMaybe<Scalars['String']>;
  officeType?: InputMaybe<OfficeType>;
  price?: InputMaybe<Scalars['Float']>;
  rates?: InputMaybe<Scalars['Float']>;
  size?: InputMaybe<Scalars['Int']>;
  sizeUnit?: InputMaybe<SizeUnit>;
  totalCost?: InputMaybe<Scalars['Float']>;
  tourIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export enum OrderDirection {
  Asc = 'asc',
  Desc = 'desc'
}

export type OtherProperty = {
  __typename?: 'OtherProperty';
  address: Address;
  featureImage?: Maybe<Media>;
  hasAvailableOffices?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  name: Scalars['String'];
  region: Region;
};

export type PartialAmenity = {
  __typename?: 'PartialAmenity';
  id: Scalars['String'];
  name: Scalars['String'];
};

export type PartialContact = {
  __typename?: 'PartialContact';
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type PartialProvider = {
  __typename?: 'PartialProvider';
  id: Scalars['String'];
  name: Scalars['String'];
  officeCount?: Maybe<Scalars['Int']>;
  propertiesCount?: Maybe<Scalars['Int']>;
  providerRegion?: Maybe<Array<ProviderRegion>>;
};

export type PartialRegion = {
  __typename?: 'PartialRegion';
  id: Scalars['String'];
  name: Scalars['String'];
  parentRegionId?: Maybe<Scalars['String']>;
};

export type Place = {
  __typename?: 'Place';
  distance: Scalars['Int'];
  distanceText: Scalars['String'];
  duration: Scalars['Int'];
  durationText: Scalars['String'];
  lat: Scalars['Float'];
  lng: Scalars['Float'];
  name: Scalars['String'];
  placeId: Scalars['String'];
};

export type PlaceRating = {
  __typename?: 'PlaceRating';
  rating?: Maybe<Scalars['Float']>;
};

export type PlaceRatingInput = {
  placeId: Scalars['String'];
};

export type Property = {
  __typename?: 'Property';
  address: Address;
  addressId: Scalars['String'];
  amenity: Array<Amenity>;
  availableOfficeCount?: Maybe<Scalars['Int']>;
  brochure: Array<Media>;
  contact?: Maybe<Array<Contact>>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<Broker>;
  description?: Maybe<Scalars['String']>;
  featureImage?: Maybe<Media>;
  filteredMinTotalCost?: Maybe<Scalars['Int']>;
  filteredOfficeCount?: Maybe<Scalars['Int']>;
  floorplan: Array<Media>;
  id: Scalars['String'];
  image: Array<Media>;
  instruction?: Maybe<Instruction>;
  isActive?: Maybe<Scalars['Boolean']>;
  isSeed?: Maybe<Scalars['Boolean']>;
  landmark: Array<Landmark>;
  maxDesks?: Maybe<Scalars['Int']>;
  maxSize?: Maybe<Scalars['Int']>;
  minTermDays?: Maybe<Scalars['Int']>;
  minTotalCost?: Maybe<Scalars['Float']>;
  name: Scalars['String'];
  note: Array<Note>;
  office: Array<Office>;
  officeCount?: Maybe<Scalars['Int']>;
  particular: Array<Media>;
  position?: Maybe<Scalars['Int']>;
  property?: Maybe<Array<Maybe<Property>>>;
  propertyType: PropertyType;
  provider: Provider;
  providerId: Scalars['String'];
  providerRegion: ProviderRegion;
  region: Region;
  scheduleOffice: Array<ScheduleOffice>;
  seedProperty?: Maybe<Property>;
  seedPropertyId?: Maybe<Scalars['String']>;
  serviceType: ServiceType;
  shortDescription?: Maybe<Scalars['String']>;
  show?: Maybe<Scalars['Boolean']>;
  tenant: Scalars['Tenant'];
  tenantId: Scalars['String'];
  tour: Array<Media>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedBy?: Maybe<Broker>;
  wholeBuildingOnly?: Maybe<Scalars['Boolean']>;
};

export type PropertyCreateData = {
  __typename?: 'PropertyCreateData';
  contacts: Array<PropertyCreateDataContact>;
  providers: Array<PropertyCreateDataProvider>;
};

export type PropertyCreateDataContact = {
  __typename?: 'PropertyCreateDataContact';
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  lastName?: Maybe<Scalars['String']>;
};

export type PropertyCreateDataProvider = {
  __typename?: 'PropertyCreateDataProvider';
  id: Scalars['String'];
  name: Scalars['String'];
  providerRegion: Array<ProviderRegion>;
};

export type PropertyImages = {
  __typename?: 'PropertyImages';
  brochures: Array<Media>;
  floorplans: Array<Media>;
  images: Array<Media>;
  particulars: Array<Media>;
};

export type PropertyInput = {
  cursor?: InputMaybe<Scalars['String']>;
  instruction?: InputMaybe<Scalars['Boolean']>;
  items?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  orderBy?: InputMaybe<Scalars['String']>;
  orderDirection?: InputMaybe<OrderDirection>;
};

export type PropertyListing = {
  __typename?: 'PropertyListing';
  data?: Maybe<Array<Maybe<Property>>>;
  next?: Maybe<Scalars['String']>;
  previous?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['Int']>;
};

export type PropertyMediaToUpdateInput = {
  brochureIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  floorplanIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['String']>;
  imageIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  particularIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  tourIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PropertyToCreateInput = {
  address: CreateAddress;
  amenities?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  brochureIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contactId?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  featureImageId?: InputMaybe<Scalars['String']>;
  floorplanIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  imageIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  instruction?: InputMaybe<InstructionInput>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  landmarks?: InputMaybe<Array<InputMaybe<LandmarkInput>>>;
  name: Scalars['String'];
  note?: InputMaybe<Scalars['String']>;
  particularIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  propertyType: PropertyType;
  providerId: Scalars['String'];
  providerRegionId: Scalars['String'];
  region?: InputMaybe<Scalars['String']>;
  serviceType: ServiceType;
  shortDescription?: InputMaybe<Scalars['String']>;
  tourIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  wholeBuildingOnly?: InputMaybe<Scalars['Boolean']>;
};

export type PropertyToDeleteInput = {
  id: Scalars['String'];
};

export type PropertyToUpdateInput = {
  address?: InputMaybe<CreateAddress>;
  amenities?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  brochureIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contactId?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  featureImageId?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  instruction?: InputMaybe<InstructionInput>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  landmarks?: InputMaybe<Array<InputMaybe<LandmarkInput>>>;
  name: Scalars['String'];
  particularIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  propertyType?: InputMaybe<PropertyType>;
  providerId?: InputMaybe<Scalars['String']>;
  providerRegionId?: InputMaybe<Scalars['String']>;
  region?: InputMaybe<Scalars['String']>;
  serviceType?: InputMaybe<ServiceType>;
  shortDescription?: InputMaybe<Scalars['String']>;
  tourIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  wholeBuildingOnly?: InputMaybe<Scalars['Boolean']>;
};

export enum PropertyType {
  Flexible = 'FLEXIBLE',
  Lease = 'LEASE',
  Managed = 'MANAGED',
  Purchase = 'PURCHASE'
}

export type Provider = {
  __typename?: 'Provider';
  address?: Maybe<Address>;
  addressId?: Maybe<Scalars['String']>;
  alwaysAvailable: Scalars['Boolean'];
  contactCount?: Maybe<Scalars['Int']>;
  contactNumber?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<Broker>;
  defaultOfficeType?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  headquarters?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isActive?: Maybe<Scalars['Boolean']>;
  isSeed?: Maybe<Scalars['Boolean']>;
  logo?: Maybe<Media>;
  logoId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  nameSearch?: Maybe<Scalars['String']>;
  officeAvailableCount?: Maybe<Scalars['Int']>;
  officeCount?: Maybe<Scalars['Int']>;
  property?: Maybe<Array<Property>>;
  propertyCount?: Maybe<Scalars['Int']>;
  provider?: Maybe<Array<Maybe<Provider>>>;
  providerContact: Array<ContactToProvider>;
  providerRegion?: Maybe<Array<ProviderRegion>>;
  providerRegistration?: Maybe<Array<ProviderRegistration>>;
  seedProvider?: Maybe<Provider>;
  seedProviderId?: Maybe<Scalars['String']>;
  tenant: Scalars['Tenant'];
  tenantId: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedBy?: Maybe<Broker>;
  website?: Maybe<Scalars['String']>;
};

export type ProviderContactCreateInput = {
  contactType: ProviderContactType;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  providerId: Scalars['String'];
};

export enum ProviderContactType {
  Other = 'OTHER',
  Register = 'REGISTER'
}

export type ProviderContactUpdateInput = {
  contactId: Scalars['String'];
  contactType: ProviderContactType;
  providerId: Scalars['String'];
};

export type ProviderCreateDataType = {
  __typename?: 'ProviderCreateDataType';
  contacts: Array<PartialContact>;
  regions: Array<RegionItem>;
};

export type ProviderCreateInput = {
  address: CreateAddress;
  alwaysAvailable?: InputMaybe<Scalars['Boolean']>;
  contactIds: Array<InputMaybe<Scalars['String']>>;
  contactNumber?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  headquarters?: InputMaybe<Scalars['String']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  logoId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  regionId?: InputMaybe<Scalars['String']>;
  website?: InputMaybe<Scalars['String']>;
};

export type ProviderDeleteInput = {
  id: Scalars['String'];
};

export type ProviderInput = {
  cursor?: InputMaybe<Scalars['String']>;
  items?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  orderBy?: InputMaybe<Scalars['String']>;
  orderDirection?: InputMaybe<OrderDirection>;
};

export type ProviderListing = {
  __typename?: 'ProviderListing';
  data: Array<Provider>;
  next: Scalars['String'];
  previous: Scalars['String'];
  total: Scalars['Int'];
};

export type ProviderRegion = {
  __typename?: 'ProviderRegion';
  contact?: Maybe<Array<Maybe<Contact>>>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<Broker>;
  createdById?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isSeed?: Maybe<Scalars['Boolean']>;
  property?: Maybe<Array<Maybe<Property>>>;
  provider?: Maybe<Provider>;
  providerId?: Maybe<Scalars['String']>;
  region: Region;
  regionId: Scalars['String'];
  tenant?: Maybe<Scalars['Tenant']>;
  tenantId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedBy?: Maybe<Broker>;
  updatedById?: Maybe<Scalars['String']>;
};

export type ProviderRegisterData = {
  __typename?: 'ProviderRegisterData';
  amenities: Array<PartialAmenity>;
  providers: Array<PartialProvider>;
};

export type ProviderRegistration = {
  __typename?: 'ProviderRegistration';
  amenity: Array<Amenity>;
  budgetFrom?: Maybe<Scalars['Int']>;
  budgetTo?: Maybe<Scalars['Int']>;
  clientInfo: ClientInfo;
  createdAt: Scalars['DateTime'];
  createdBy: Broker;
  createdById: Scalars['String'];
  deal: Deal;
  dealId: Scalars['String'];
  desks?: Maybe<Scalars['Int']>;
  flexibleDate?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  location: Scalars['String'];
  note: Array<Note>;
  provider: Provider;
  providerId: Scalars['String'];
  sentAt?: Maybe<Scalars['Boolean']>;
  size?: Maybe<Scalars['Int']>;
  sizeUnit: SizeUnit;
  status: RegistrationStatus;
  targetDate?: Maybe<Scalars['DateTime']>;
  tenant: Scalars['Tenant'];
  tenantId: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  updatedBy: Broker;
  updatedById: Scalars['String'];
};

export type ProviderRegistrationInput = {
  amenityIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  budgetFrom?: InputMaybe<Scalars['Int']>;
  budgetSelection: BudgetSelection;
  budgetTo?: InputMaybe<Scalars['Int']>;
  clientInfo: ClientInfo;
  clientName?: InputMaybe<Scalars['String']>;
  contactName?: InputMaybe<Scalars['String']>;
  dealId: Scalars['String'];
  desks?: InputMaybe<Scalars['Int']>;
  flexibleDate: Scalars['Boolean'];
  location?: InputMaybe<Scalars['String']>;
  note?: InputMaybe<Scalars['String']>;
  providerIds: Array<Scalars['String']>;
  size?: InputMaybe<Scalars['Int']>;
  sizeUnit?: InputMaybe<SizeUnit>;
  targetDate?: InputMaybe<Scalars['DateTime']>;
};

export type ProviderRegistrationUpdate = {
  id: Scalars['String'];
  status: RegistrationStatus;
};

export type ProviderUpdateInput = {
  address?: InputMaybe<CreateAddress>;
  alwaysAvailable?: InputMaybe<Scalars['Boolean']>;
  contactIds: Array<Scalars['String']>;
  contactNumber?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  headquarters?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  isActive?: InputMaybe<Scalars['Boolean']>;
  logoId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  website?: InputMaybe<Scalars['String']>;
};

export type PublicFilterPropertiesInput = {
  amenity?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  availableFrom?: InputMaybe<Scalars['DateTime']>;
  bounds?: InputMaybe<Bounds>;
  budget?: InputMaybe<Range>;
  desks?: InputMaybe<Range>;
  location?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  minimumTerm?: InputMaybe<Range>;
  minimumTermUnit?: InputMaybe<TermUnit>;
  officeType?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  provider?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  radius?: InputMaybe<Scalars['Float']>;
  radiusFrom?: InputMaybe<RadiusPoint>;
  region?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  searchString?: InputMaybe<Scalars['String']>;
  sessionId?: InputMaybe<Scalars['String']>;
  showDisposals?: InputMaybe<Scalars['Boolean']>;
  showUnavailable?: InputMaybe<Scalars['Boolean']>;
  size?: InputMaybe<Range>;
  sizeUnit?: InputMaybe<SizeUnit>;
};

export type PublicPropertiesInput = {
  filter?: InputMaybe<PublicFilterPropertiesInput>;
  ids: Array<Scalars['String']>;
};

export type PublicPropertyInput = {
  filter?: InputMaybe<PublicFilterPropertiesInput>;
  id?: InputMaybe<Scalars['String']>;
};

export type Query = {
  __typename?: 'Query';
  amenities?: Maybe<AmneityListing>;
  availabilityDashboardData?: Maybe<Array<Maybe<AvailabilityDashboardType>>>;
  availableProperties: Array<Property>;
  availableProperty?: Maybe<Property>;
  brokers: Array<Broker>;
  client?: Maybe<Client>;
  clientDeal?: Maybe<ClientDeal>;
  clients?: Maybe<ClientListing>;
  connectedDeals?: Maybe<Array<Maybe<Deal>>>;
  contacts: Array<Contact>;
  currencies: Array<Currency>;
  deal?: Maybe<DealOutput>;
  dealList: Array<Deal>;
  dealPublic?: Maybe<Scalars['Boolean']>;
  dealViewings?: Maybe<DealViewingOutput>;
  deals: DealListing;
  dispoDashboard?: Maybe<Array<Maybe<DispoDashboardProperty>>>;
  getBroker?: Maybe<Broker>;
  getUser?: Maybe<Array<Maybe<User>>>;
  me?: Maybe<Me>;
  nearbyPlaces: Array<NearbyPlaces>;
  note?: Maybe<Note>;
  notifications: Array<Notification>;
  office?: Maybe<Office>;
  officeListing?: Maybe<OfficeListing>;
  officeSearchData?: Maybe<OfficeSearchData>;
  officeSearchDataBudget?: Maybe<OfficeSearchDataBudget>;
  officeSearchDataProviders?: Maybe<OfficeSearchDataProviders>;
  officeSearchProperties: OfficeSearchProperties;
  officeSearchProperty: OfficeSearchProperty;
  offices: Array<Office>;
  placeRating?: Maybe<PlaceRating>;
  places: Array<Place>;
  properties?: Maybe<PropertyListing>;
  property: Property;
  propertyCreateData: PropertyCreateData;
  propertyImages?: Maybe<PropertyImages>;
  propertyMedia?: Maybe<Array<Maybe<Media>>>;
  provider?: Maybe<Provider>;
  providerCreateData?: Maybe<ProviderCreateDataType>;
  providerRegion?: Maybe<ProviderRegion>;
  providerRegisterData?: Maybe<ProviderRegisterData>;
  providers?: Maybe<ProviderListing>;
  /** These are used by HeyOffices for displaying the various sets of data */
  publicFilterProperties: Array<Property>;
  publicProperties: Array<Property>;
  publicProperty: Property;
  regions: Array<Region>;
  rentMapData?: Maybe<Array<Maybe<RentMapData>>>;
  rentmapProperties?: Maybe<Array<Maybe<RentMapProperties>>>;
  schedule?: Maybe<Schedule>;
  scheduleOffice?: Maybe<ScheduleOffice>;
};


export type QueryAmenitiesArgs = {
  input?: InputMaybe<AmenityInput>;
};


export type QueryAvailablePropertiesArgs = {
  filter?: InputMaybe<FindOfficeFiltersInput>;
};


export type QueryAvailablePropertyArgs = {
  id: Scalars['String'];
};


export type QueryClientArgs = {
  id: Scalars['String'];
};


export type QueryClientDealArgs = {
  id?: InputMaybe<Scalars['String']>;
  showOtherProperties?: InputMaybe<Scalars['Boolean']>;
};


export type QueryClientsArgs = {
  input?: InputMaybe<ClientsInput>;
};


export type QueryConnectedDealsArgs = {
  officeId?: InputMaybe<Scalars['String']>;
};


export type QueryDealArgs = {
  id?: InputMaybe<Scalars['String']>;
};


export type QueryDealPublicArgs = {
  dealId: Scalars['String'];
};


export type QueryDealViewingsArgs = {
  id?: InputMaybe<Scalars['String']>;
};


export type QueryDealsArgs = {
  input?: InputMaybe<DealsInput>;
};


export type QueryGetBrokerArgs = {
  id?: InputMaybe<Scalars['String']>;
};


export type QueryGetUserArgs = {
  id?: InputMaybe<Scalars['String']>;
};


export type QueryNearbyPlacesArgs = {
  input?: InputMaybe<PlaceInput>;
};


export type QueryNoteArgs = {
  id?: InputMaybe<Scalars['String']>;
};


export type QueryOfficeArgs = {
  id?: InputMaybe<Scalars['String']>;
};


export type QueryOfficeListingArgs = {
  filter?: InputMaybe<OfficeInput>;
};


export type QueryOfficeSearchDataBudgetArgs = {
  input?: InputMaybe<OfficeSearchBudgetInput>;
};


export type QueryOfficeSearchDataProvidersArgs = {
  filter?: InputMaybe<OfficeFiltersInput>;
};


export type QueryOfficeSearchPropertiesArgs = {
  filter?: InputMaybe<FindOfficeFiltersInput>;
};


export type QueryOfficeSearchPropertyArgs = {
  filter?: InputMaybe<FindOfficePropertyFiltersInput>;
};


export type QueryOfficesArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryPlaceRatingArgs = {
  input?: InputMaybe<PlaceRatingInput>;
};


export type QueryPlacesArgs = {
  input?: InputMaybe<PlaceInput>;
};


export type QueryPropertiesArgs = {
  input?: InputMaybe<PropertyInput>;
};


export type QueryPropertyArgs = {
  id?: InputMaybe<Scalars['String']>;
};


export type QueryPropertyImagesArgs = {
  id?: InputMaybe<Scalars['String']>;
};


export type QueryPropertyMediaArgs = {
  id?: InputMaybe<Scalars['String']>;
};


export type QueryProviderArgs = {
  id?: InputMaybe<Scalars['String']>;
};


export type QueryProviderRegionArgs = {
  id?: InputMaybe<Scalars['String']>;
};


export type QueryProvidersArgs = {
  input?: InputMaybe<ProviderInput>;
};


export type QueryPublicFilterPropertiesArgs = {
  filter?: InputMaybe<PublicFilterPropertiesInput>;
};


export type QueryPublicPropertiesArgs = {
  publicPropertiesInput?: InputMaybe<PublicPropertiesInput>;
};


export type QueryPublicPropertyArgs = {
  publicPropertyInput?: InputMaybe<PublicPropertyInput>;
};


export type QueryScheduleArgs = {
  id?: InputMaybe<Scalars['String']>;
};


export type QueryScheduleOfficeArgs = {
  id?: InputMaybe<Scalars['String']>;
};

export type RadiusPoint = {
  lat?: InputMaybe<Scalars['Float']>;
  lng?: InputMaybe<Scalars['Float']>;
};

export type Range = {
  from?: InputMaybe<Scalars['Int']>;
  to?: InputMaybe<Scalars['Int']>;
};

export type Region = {
  __typename?: 'Region';
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<Broker>;
  createdById?: Maybe<Scalars['String']>;
  currency: Currency;
  currencyId: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
  nameSearch: Scalars['String'];
  parentRegion?: Maybe<Region>;
  parentRegionId?: Maybe<Scalars['String']>;
  providerRegion?: Maybe<Array<Maybe<ProviderRegion>>>;
  region?: Maybe<Array<Maybe<Region>>>;
  tenant: Scalars['Tenant'];
  tenantId: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedBy?: Maybe<Broker>;
  updatedById?: Maybe<Scalars['String']>;
};

export type RegionCreateInput = {
  currencyId: Scalars['String'];
  name: Scalars['String'];
  parentRegionId?: InputMaybe<Scalars['String']>;
};

export type RegionItem = {
  __typename?: 'RegionItem';
  id: Scalars['String'];
  name: Scalars['String'];
  parentRegionId?: Maybe<Scalars['String']>;
};

export type RegionUpdateInput = {
  currencyId: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
  parentRegionId?: InputMaybe<Scalars['String']>;
};

export enum RegistrationStatus {
  Accepted = 'ACCEPTED',
  Creating = 'CREATING',
  Override = 'OVERRIDE',
  Rejected = 'REJECTED',
  Sent = 'SENT'
}

export type RemoveProviderRegionInput = {
  providerId: Scalars['String'];
  providerRegionId: Scalars['String'];
};

export type RentMapData = {
  __typename?: 'RentMapData';
  area?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  flexiMax?: Maybe<Scalars['Float']>;
  flexiMin?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['String']>;
  managedMax?: Maybe<Scalars['Float']>;
  managedMin?: Maybe<Scalars['Float']>;
  tradMax?: Maybe<Scalars['Float']>;
  tradMin?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type RentMapProperties = {
  __typename?: 'RentMapProperties';
  properties?: Maybe<Array<Maybe<Property>>>;
  region: Scalars['String'];
};

export enum Roles {
  Admin = 'ADMIN',
  Disposal = 'DISPOSAL',
  Loader = 'LOADER',
  Public = 'PUBLIC',
  Superadmin = 'SUPERADMIN',
  User = 'USER'
}

export type Schedule = {
  __typename?: 'Schedule';
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<Broker>;
  createdById?: Maybe<Scalars['String']>;
  deal: Deal;
  dealId: Scalars['String'];
  favouritesSent: Scalars['Int'];
  id: Scalars['String'];
  note?: Maybe<Array<Maybe<Note>>>;
  scheduleOffice: Array<ScheduleOffice>;
  scheduleProperty: Array<ScheduleProperty>;
  tenant: Scalars['Tenant'];
  tenantId: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedBy?: Maybe<Broker>;
  updatedById?: Maybe<Scalars['String']>;
};

export type ScheduleOffice = {
  __typename?: 'ScheduleOffice';
  amenity: Array<Amenity>;
  available: Availability;
  availableFrom?: Maybe<Scalars['DateTime']>;
  availableUntil?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<Broker>;
  createdById?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  desks?: Maybe<Scalars['Int']>;
  disposalComments?: Maybe<Scalars['String']>;
  estateCharge?: Maybe<Scalars['Float']>;
  featureImage?: Maybe<Media>;
  fitted: Fitted;
  floor?: Maybe<Scalars['Int']>;
  floorplan: Array<Media>;
  groundRent?: Maybe<Scalars['Float']>;
  id: Scalars['String'];
  image: Array<Media>;
  instructedOffice?: Maybe<Scalars['Boolean']>;
  leadTime?: Maybe<Scalars['Int']>;
  leadTimeUnit?: Maybe<LeadTimeUnit>;
  linkedByOffice: Array<ScheduleOffice>;
  linkedToOffice: Array<ScheduleOffice>;
  minimumTerm?: Maybe<Scalars['Int']>;
  minimumTermUnit: TermUnit;
  name: Scalars['String'];
  nameSearch?: Maybe<Scalars['String']>;
  note?: Maybe<Array<Maybe<Note>>>;
  nuggetedAt?: Maybe<Scalars['DateTime']>;
  nuggetedBy?: Maybe<Broker>;
  nuggetedById?: Maybe<Scalars['String']>;
  office: Office;
  officeId: Scalars['String'];
  officeType: OfficeType;
  price?: Maybe<Scalars['Float']>;
  property: Property;
  propertyId: Scalars['String'];
  rates?: Maybe<Scalars['Float']>;
  rentFreePeriod?: Maybe<Scalars['Int']>;
  rentFreePeriodUnit: TermUnit;
  schedule: Schedule;
  scheduleId: Scalars['String'];
  size?: Maybe<Scalars['Int']>;
  sizeUnit: SizeUnit;
  status: ScheduleOfficeStatus;
  statusDetail?: Maybe<Scalars['String']>;
  tenant: Scalars['Tenant'];
  tenantId: Scalars['String'];
  totalCost?: Maybe<Scalars['Float']>;
  tour: Array<Media>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedBy?: Maybe<Broker>;
  updatedById?: Maybe<Scalars['String']>;
};

export type ScheduleOfficeCreateInput = {
  amenities?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  available?: InputMaybe<Availability>;
  availableFrom?: InputMaybe<Scalars['DateTime']>;
  availableUntil?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  desks?: InputMaybe<Scalars['Int']>;
  disposalComments?: InputMaybe<Scalars['String']>;
  estateCharge?: InputMaybe<Scalars['Float']>;
  featureImageId?: InputMaybe<Scalars['String']>;
  fitted?: InputMaybe<Fitted>;
  floor?: InputMaybe<Scalars['Int']>;
  floorplanIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  groundRent?: InputMaybe<Scalars['Float']>;
  imageIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leadTime?: InputMaybe<Scalars['Int']>;
  leadTimeUnit?: InputMaybe<LeadTimeUnit>;
  linkToOffices?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  minimumTerm?: InputMaybe<Scalars['Int']>;
  minimumTermUnit: TermUnit;
  name?: InputMaybe<Scalars['String']>;
  note?: InputMaybe<Scalars['String']>;
  officeId: Scalars['String'];
  officeType: OfficeType;
  price?: InputMaybe<Scalars['Float']>;
  propertyId: Scalars['String'];
  rates?: InputMaybe<Scalars['Float']>;
  scheduleId: Scalars['String'];
  size?: InputMaybe<Scalars['Int']>;
  sizeUnit?: InputMaybe<SizeUnit>;
  totalCost?: InputMaybe<Scalars['Float']>;
  tourIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ScheduleOfficeRemoveInput = {
  id: Array<Scalars['String']>;
};

export enum ScheduleOfficeStatus {
  Favourite = 'FAVOURITE',
  New = 'NEW',
  Offer = 'OFFER',
  Picked = 'PICKED',
  Rejected = 'REJECTED',
  Viewing = 'VIEWING'
}

export type ScheduleOfficeUpdateInput = {
  amenities?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  available?: InputMaybe<Availability>;
  availableFrom?: InputMaybe<Scalars['DateTime']>;
  availableUntil?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  desks?: InputMaybe<Scalars['Int']>;
  disposalComments?: InputMaybe<Scalars['String']>;
  estateCharge?: InputMaybe<Scalars['Float']>;
  featureImageId?: InputMaybe<Scalars['String']>;
  fitted?: InputMaybe<Fitted>;
  floor?: InputMaybe<Scalars['Int']>;
  floorplanIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  groundRent?: InputMaybe<Scalars['Float']>;
  id: Scalars['String'];
  imageIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  instructedOffice?: InputMaybe<Scalars['Boolean']>;
  isNugget?: InputMaybe<Scalars['Boolean']>;
  leadTime?: InputMaybe<Scalars['Int']>;
  leadTimeUnit?: InputMaybe<LeadTimeUnit>;
  minimumTerm?: InputMaybe<Scalars['Int']>;
  minimumTermUnit?: InputMaybe<TermUnit>;
  name?: InputMaybe<Scalars['String']>;
  note?: InputMaybe<Scalars['String']>;
  officeType?: InputMaybe<OfficeType>;
  price?: InputMaybe<Scalars['Float']>;
  rates?: InputMaybe<Scalars['Float']>;
  rentFreePeriod?: InputMaybe<Scalars['Int']>;
  rentFreePeriodUnit?: InputMaybe<TermUnit>;
  size?: InputMaybe<Scalars['Int']>;
  sizeUnit?: InputMaybe<SizeUnit>;
  status?: InputMaybe<ScheduleOfficeStatus>;
  totalCost?: InputMaybe<Scalars['Float']>;
  tourIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ScheduleOfficesRemoved = {
  __typename?: 'ScheduleOfficesRemoved';
  count?: Maybe<Scalars['Int']>;
};

export type ScheduleProperty = {
  __typename?: 'ScheduleProperty';
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<Broker>;
  id: Scalars['String'];
  isActive: Scalars['Boolean'];
  position?: Maybe<Scalars['Int']>;
  property: Property;
  propertyId: Scalars['String'];
  schedule: Schedule;
  scheduleId: Scalars['String'];
  tenant: Scalars['Tenant'];
  tenantId: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedBy?: Maybe<Broker>;
};

export type ScraperInput = {
  password?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
  username?: InputMaybe<Scalars['String']>;
};

export type ScraperReturn = {
  __typename?: 'ScraperReturn';
  completed?: Maybe<Scalars['String']>;
  limitReached?: Maybe<Scalars['Boolean']>;
  progress?: Maybe<Scalars['Int']>;
  result?: Maybe<OfficeReturn>;
};

export type SecondaryBroker = {
  brokerName: Scalars['String'];
};

export enum ServiceType {
  Agreement = 'AGREEMENT',
  Leased = 'LEASED',
  Propco = 'PROPCO'
}

export type SetScheduleOfficeStatusInput = {
  officeId: Scalars['String'];
  status?: InputMaybe<ScheduleOfficeStatus>;
};

export type SetViewingMapPropertyId = {
  addressId: Scalars['String'];
  id: Scalars['String'];
  start: Scalars['Boolean'];
};

export enum SizeUnit {
  SquareFeet = 'SQUARE_FEET',
  SquareMeters = 'SQUARE_METERS'
}

export type SyncOfficeInput = {
  amenity?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  available?: InputMaybe<Availability>;
  availableFrom?: InputMaybe<Scalars['DateTime']>;
  availableUntil?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  desks?: InputMaybe<Scalars['Int']>;
  disposalComments?: InputMaybe<Scalars['String']>;
  estateCharge?: InputMaybe<Scalars['Float']>;
  featureImage?: InputMaybe<Scalars['String']>;
  fitted?: InputMaybe<Fitted>;
  floor?: InputMaybe<Scalars['Int']>;
  floorplan?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  groundRent?: InputMaybe<Scalars['Float']>;
  image?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leadTime?: InputMaybe<Scalars['Int']>;
  leadTimeUnit?: InputMaybe<LeadTimeUnit>;
  masterOfficeId: Scalars['String'];
  minimumTerm?: InputMaybe<Scalars['Int']>;
  minimumTermUnit?: InputMaybe<TermUnit>;
  name?: InputMaybe<Scalars['String']>;
  officeType?: InputMaybe<OfficeType>;
  price?: InputMaybe<Scalars['Float']>;
  rates?: InputMaybe<Scalars['Float']>;
  scheduleOfficeId: Scalars['String'];
  size?: InputMaybe<Scalars['Int']>;
  sizeUnit?: InputMaybe<SizeUnit>;
  totalCost?: InputMaybe<Scalars['Float']>;
  tour?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export enum TermUnit {
  Day = 'DAY',
  Month = 'MONTH',
  Year = 'YEAR'
}

export type TitleUpdate = {
  id?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type ToggleCanFavouriteFromInput = {
  canFavourite?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['String'];
};

export type ToggleShowAvailableFromInput = {
  id: Scalars['String'];
  showAvailableFrom?: InputMaybe<Scalars['Boolean']>;
};

export type ToggleShowMatchingFromInput = {
  id: Scalars['String'];
  showMatchingToggle?: InputMaybe<Scalars['Boolean']>;
};

export type ToggleShowProviderFilterInput = {
  id: Scalars['String'];
  showProviderFilter?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateNotificationInput = {
  notificationIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type UpdatePosition = {
  id?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type UploadMediaInput = {
  files?: InputMaybe<Array<InputMaybe<Scalars['Upload']>>>;
  titles?: InputMaybe<Array<InputMaybe<FileTitles>>>;
  type?: InputMaybe<Scalars['String']>;
};

export type User = {
  __typename?: 'User';
  contact?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type UserInput = {
  contact?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type DispoDashboardProperty = {
  __typename?: 'dispoDashboardProperty';
  deals?: Maybe<Array<Maybe<Deal>>>;
  property: Property;
};

export type PlaceInput = {
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
  placeType?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type UpdatePropertyScheduleOrderInput = {
  scheduleId: Scalars['String'];
  schedulePropertyIds: Array<Scalars['String']>;
};

export type ContactsQueryVariables = Exact<{ [key: string]: never; }>;


export type ContactsQuery = { __typename?: 'Query', contacts: Array<{ __typename?: 'Contact', id: string, name?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null, phone?: string | null }> };

export type PropertyCreateDataQueryVariables = Exact<{ [key: string]: never; }>;


export type PropertyCreateDataQuery = { __typename?: 'Query', propertyCreateData: { __typename?: 'PropertyCreateData', providers: Array<{ __typename?: 'PropertyCreateDataProvider', id: string, name: string, providerRegion: Array<{ __typename?: 'ProviderRegion', id: string, region: { __typename?: 'Region', id: string, name: string } }> }>, contacts: Array<{ __typename?: 'PropertyCreateDataContact', id: string, firstName?: string | null, lastName?: string | null, email?: string | null }> } };

export type CreatePropertyMutationVariables = Exact<{
  input?: InputMaybe<PropertyToCreateInput>;
}>;


export type CreatePropertyMutation = { __typename?: 'Mutation', createProperty?: { __typename?: 'Property', id: string, name: string } | null };

export type PlacesQueryVariables = Exact<{
  input?: InputMaybe<PlaceInput>;
}>;


export type PlacesQuery = { __typename?: 'Query', places: Array<{ __typename?: 'Place', placeId: string, name: string, lat: number, lng: number, distance: number, duration: number, distanceText: string, durationText: string }> };

export type NearbyPlacesQueryVariables = Exact<{
  input?: InputMaybe<PlaceInput>;
}>;


export type NearbyPlacesQuery = { __typename?: 'Query', nearbyPlaces: Array<{ __typename?: 'NearbyPlaces', placeId: string, name: string, lat: number, lng: number, distance: number, duration: number, distanceText: string, durationText: string, position: number }> };

export type PlaceItemFragment = { __typename?: 'Place', placeId: string, name: string, lat: number, lng: number, distance: number, duration: number, distanceText: string, durationText: string };

export type NearbyPlaceItemFragment = { __typename?: 'NearbyPlaces', placeId: string, name: string, lat: number, lng: number, distance: number, duration: number, distanceText: string, durationText: string, position: number };

export type ProviderRegionsQueryVariables = Exact<{ [key: string]: never; }>;


export type ProviderRegionsQuery = { __typename?: 'Query', regions: Array<{ __typename?: 'Region', id: string, name: string, parentRegionId?: string | null }> };

export type RegionItemFragment = { __typename?: 'Region', id: string, name: string, parentRegionId?: string | null };

export type ProviderCreateDataQueryVariables = Exact<{ [key: string]: never; }>;


export type ProviderCreateDataQuery = { __typename?: 'Query', providerCreateData?: { __typename?: 'ProviderCreateDataType', contacts: Array<{ __typename?: 'PartialContact', id?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null }>, regions: Array<{ __typename?: 'RegionItem', id: string, name: string, parentRegionId?: string | null }> } | null };

export type CreateDataRegionFragment = { __typename?: 'RegionItem', id: string, name: string, parentRegionId?: string | null };

export type CreateProviderMutationVariables = Exact<{
  input?: InputMaybe<ProviderCreateInput>;
}>;


export type CreateProviderMutation = { __typename?: 'Mutation', createProvider?: { __typename?: 'Provider', id: string, name: string, isActive?: boolean | null, website?: string | null } | null };

export type CreateTourMutationVariables = Exact<{
  location?: InputMaybe<Scalars['String']>;
}>;


export type CreateTourMutation = { __typename?: 'Mutation', createTour: { __typename?: 'Media', id: string, type?: string | null, location: string } };

export type AmenitiesQueryVariables = Exact<{ [key: string]: never; }>;


export type AmenitiesQuery = { __typename?: 'Query', amenities?: { __typename?: 'AmneityListing', previous?: string | null, next?: string | null, total?: number | null, data: Array<{ __typename?: 'Amenity', id: string, name: string }> } | null };

export type CreateAmenityMutationVariables = Exact<{
  name?: InputMaybe<Scalars['String']>;
}>;


export type CreateAmenityMutation = { __typename?: 'Mutation', createAmenity?: { __typename?: 'Amenity', id: string, name: string } | null };

export type DeleteProviderMutationVariables = Exact<{
  input?: InputMaybe<ProviderDeleteInput>;
}>;


export type DeleteProviderMutation = { __typename?: 'Mutation', deleteProvider?: { __typename?: 'Provider', id: string } | null };

export type DeletePropertyMutationVariables = Exact<{
  input?: InputMaybe<PropertyToDeleteInput>;
}>;


export type DeletePropertyMutation = { __typename?: 'Mutation', deleteProperty?: { __typename?: 'Property', id: string } | null };

export type DeleteOfficeMutationVariables = Exact<{
  input?: InputMaybe<OfficeDeleteInput>;
}>;


export type DeleteOfficeMutation = { __typename?: 'Mutation', deleteOffice?: { __typename?: 'Office', id: string } | null };

export type UploadMediaMutationVariables = Exact<{
  input?: InputMaybe<UploadMediaInput>;
}>;


export type UploadMediaMutation = { __typename?: 'Mutation', uploadMedia?: Array<{ __typename?: 'Media', id: string, title?: string | null, type?: string | null, location: string, filename?: string | null, mimetype?: string | null, encoding?: string | null } | null> | null };

export type UploadedMediaFragment = { __typename?: 'Media', id: string, title?: string | null, type?: string | null, location: string, filename?: string | null, mimetype?: string | null, encoding?: string | null };

export type UpdateMediaPositionMutationVariables = Exact<{
  input?: InputMaybe<UpdatePosition>;
}>;


export type UpdateMediaPositionMutation = { __typename?: 'Mutation', updateMediaPosition?: Array<{ __typename?: 'Media', id: string } | null> | null };

export type UpdateMediaTitleMutationVariables = Exact<{
  input?: InputMaybe<TitleUpdate>;
}>;


export type UpdateMediaTitleMutation = { __typename?: 'Mutation', updateMediaTitle?: { __typename?: 'Media', id: string, title?: string | null, type?: string | null, location: string, filename?: string | null, mimetype?: string | null, encoding?: string | null } | null };

export type AddNoteMutationVariables = Exact<{
  input?: InputMaybe<AddNoteInput>;
}>;


export type AddNoteMutation = { __typename?: 'Mutation', addNote?: { __typename?: 'Note', id: string, subject?: string | null, note: string, type?: NoteType | null, sender?: string | null, recipient?: string | null, sentAt?: any | null, externalRef?: string | null, updatedAt: any, updatedBy: { __typename?: 'Broker', id: string, firstName?: string | null, lastName?: string | null } } | null };

export type RetrieveNotesMutationVariables = Exact<{
  dealId: Scalars['String'];
}>;


export type RetrieveNotesMutation = { __typename?: 'Mutation', retrieveNotes: Array<{ __typename?: 'Note', id: string, subject?: string | null, note: string, type?: NoteType | null, sender?: string | null, recipient?: string | null, sentAt?: any | null, externalRef?: string | null, updatedAt: any, updatedBy: { __typename?: 'Broker', id: string, firstName?: string | null, lastName?: string | null } }> };

export type SetAvailabilityMutationVariables = Exact<{
  input?: InputMaybe<AvailibilityInput>;
}>;


export type SetAvailabilityMutation = { __typename?: 'Mutation', setAvailability?: { __typename?: 'Office', id: string, name: string, available: Availability } | null };

export type SetNuggetMutationVariables = Exact<{
  input?: InputMaybe<NuggetInput>;
}>;


export type SetNuggetMutation = { __typename?: 'Mutation', setNugget?: { __typename?: 'Office', id: string, name: string, nuggetedAt?: any | null, nuggetedBy?: { __typename?: 'Broker', id: string, firstName?: string | null, lastName?: string | null } | null } | null };

export type OfficesQueryVariables = Exact<{
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
}>;


export type OfficesQuery = { __typename?: 'Query', offices: Array<{ __typename?: 'Office', id: string, officeType: OfficeType, name: string, desks?: number | null, size?: number | null, sizeUnit: SizeUnit, floor?: number | null, availableFrom?: any | null, availableUntil?: any | null, leadTime?: number | null, leadTimeUnit?: LeadTimeUnit | null, description?: string | null, price?: number | null, groundRent?: number | null, rates?: number | null, totalCost?: number | null, estateCharge?: number | null, nuggetedAt?: any | null, minimumTerm?: number | null, minimumTermUnit: TermUnit, available: Availability, fitted: Fitted, updatedAt?: any | null, note?: Array<{ __typename?: 'Note', id: string, note: string, updatedAt: any, updatedBy: { __typename?: 'Broker', id: string, firstName?: string | null, lastName?: string | null } } | null> | null, amenity: Array<{ __typename?: 'Amenity', id: string, name: string }>, featureImage?: { __typename?: 'Media', id: string, location: string, title?: string | null, filename?: string | null, type?: string | null, mimetype?: string | null, position?: number | null } | null, floorplan: Array<{ __typename?: 'Media', id: string, location: string, title?: string | null, filename?: string | null, type?: string | null, mimetype?: string | null, position?: number | null }>, image: Array<{ __typename?: 'Media', id: string, location: string, title?: string | null, filename?: string | null, type?: string | null, mimetype?: string | null, position?: number | null }>, tour: Array<{ __typename?: 'Media', id: string, location: string, title?: string | null, filename?: string | null, type?: string | null, mimetype?: string | null, position?: number | null }>, updatedBy?: { __typename?: 'Broker', firstName?: string | null, lastName?: string | null } | null, property: { __typename?: 'Property', id: string, name: string, propertyType: PropertyType, region: { __typename?: 'Region', id: string, name: string, currency: { __typename?: 'Currency', id: string, name: string } }, provider: { __typename?: 'Provider', id: string, name: string } } }> };

export type OfficesOfficeFragment = { __typename?: 'Office', id: string, officeType: OfficeType, name: string, desks?: number | null, size?: number | null, sizeUnit: SizeUnit, floor?: number | null, availableFrom?: any | null, availableUntil?: any | null, leadTime?: number | null, leadTimeUnit?: LeadTimeUnit | null, description?: string | null, price?: number | null, groundRent?: number | null, rates?: number | null, totalCost?: number | null, estateCharge?: number | null, nuggetedAt?: any | null, minimumTerm?: number | null, minimumTermUnit: TermUnit, available: Availability, fitted: Fitted, updatedAt?: any | null, note?: Array<{ __typename?: 'Note', id: string, note: string, updatedAt: any, updatedBy: { __typename?: 'Broker', id: string, firstName?: string | null, lastName?: string | null } } | null> | null, amenity: Array<{ __typename?: 'Amenity', id: string, name: string }>, featureImage?: { __typename?: 'Media', id: string, location: string, title?: string | null, filename?: string | null, type?: string | null, mimetype?: string | null, position?: number | null } | null, floorplan: Array<{ __typename?: 'Media', id: string, location: string, title?: string | null, filename?: string | null, type?: string | null, mimetype?: string | null, position?: number | null }>, image: Array<{ __typename?: 'Media', id: string, location: string, title?: string | null, filename?: string | null, type?: string | null, mimetype?: string | null, position?: number | null }>, tour: Array<{ __typename?: 'Media', id: string, location: string, title?: string | null, filename?: string | null, type?: string | null, mimetype?: string | null, position?: number | null }>, updatedBy?: { __typename?: 'Broker', firstName?: string | null, lastName?: string | null } | null, property: { __typename?: 'Property', id: string, name: string, propertyType: PropertyType, region: { __typename?: 'Region', id: string, name: string, currency: { __typename?: 'Currency', id: string, name: string } }, provider: { __typename?: 'Provider', id: string, name: string } } };

export type CreateScheduleOfficesMutationVariables = Exact<{
  input?: InputMaybe<Array<InputMaybe<ScheduleOfficeCreateInput>> | InputMaybe<ScheduleOfficeCreateInput>>;
}>;


export type CreateScheduleOfficesMutation = { __typename?: 'Mutation', createScheduleOffices?: Array<{ __typename?: 'ScheduleOffice', id: string, status: ScheduleOfficeStatus } | null> | null };

export type DealListQueryVariables = Exact<{ [key: string]: never; }>;


export type DealListQuery = { __typename?: 'Query', dealList: Array<{ __typename?: 'Deal', id: string, name: string, createdAt?: any | null, schedule: { __typename?: 'Schedule', id: string }, leadBroker: { __typename?: 'Broker', id: string, firstName?: string | null, lastName?: string | null } }> };

export type DealListFragment = { __typename?: 'Deal', id: string, name: string, createdAt?: any | null, schedule: { __typename?: 'Schedule', id: string }, leadBroker: { __typename?: 'Broker', id: string, firstName?: string | null, lastName?: string | null } };

export type ProviderRegisterDataQueryVariables = Exact<{ [key: string]: never; }>;


export type ProviderRegisterDataQuery = { __typename?: 'Query', providerRegisterData?: { __typename?: 'ProviderRegisterData', providers: Array<{ __typename?: 'PartialProvider', id: string, name: string, providerRegion?: Array<{ __typename?: 'ProviderRegion', id: string, regionId: string, region: { __typename?: 'Region', id: string, name: string } }> | null }>, amenities: Array<{ __typename?: 'PartialAmenity', id: string, name: string }> } | null };

export type ProviderRegisterDataProviderFragment = { __typename?: 'PartialProvider', id: string, name: string, providerRegion?: Array<{ __typename?: 'ProviderRegion', id: string, regionId: string, region: { __typename?: 'Region', id: string, name: string } }> | null };

export type CreateProviderRegistrationMutationVariables = Exact<{
  input?: InputMaybe<ProviderRegistrationInput>;
}>;


export type CreateProviderRegistrationMutation = { __typename?: 'Mutation', createProviderRegistration?: Array<{ __typename?: 'ProviderRegistration', id: string } | null> | null };

export type CreateProviderContactMutationVariables = Exact<{
  input?: InputMaybe<ProviderContactCreateInput>;
}>;


export type CreateProviderContactMutation = { __typename?: 'Mutation', createProviderContact?: { __typename?: 'ContactToProvider', contact: { __typename?: 'Contact', id: string } } | null };

export type FavouriteScheduleOfficeMutationVariables = Exact<{
  id?: InputMaybe<Scalars['String']>;
}>;


export type FavouriteScheduleOfficeMutation = { __typename?: 'Mutation', favouriteScheduleOffice?: { __typename?: 'FavouriteUpdate', id: string, status: ScheduleOfficeStatus, favouriteCount: number } | null };

export type UpdateScheduleOfficesStatusMutationVariables = Exact<{
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  status?: InputMaybe<ScheduleOfficeStatus>;
  statusDetail?: InputMaybe<Scalars['String']>;
}>;


export type UpdateScheduleOfficesStatusMutation = { __typename?: 'Mutation', updateScheduleOfficesStatus?: Array<{ __typename?: 'ScheduleOffice', id: string, name: string, status: ScheduleOfficeStatus, statusDetail?: string | null } | null> | null };

export type NotificationsQueryVariables = Exact<{ [key: string]: never; }>;


export type NotificationsQuery = { __typename?: 'Query', notifications: Array<{ __typename?: 'Notification', id?: string | null, createdAt?: any | null, subject?: string | null, message?: string | null, readAt?: any | null, recipient?: { __typename?: 'Broker', id: string, firstName?: string | null, lastName?: string | null, email: string } | null }> };

export type UpdateNotificationMutationVariables = Exact<{
  input?: InputMaybe<UpdateNotificationInput>;
}>;


export type UpdateNotificationMutation = { __typename?: 'Mutation', updateNotification: Array<{ __typename?: 'Notification', id?: string | null, createdAt?: any | null, subject?: string | null, message?: string | null, readAt?: any | null, recipient?: { __typename?: 'Broker', id: string, firstName?: string | null, lastName?: string | null, email: string } | null }> };

export type CreateNotificationMutationVariables = Exact<{
  input?: InputMaybe<CreateNotificationInput>;
}>;


export type CreateNotificationMutation = { __typename?: 'Mutation', createNotification?: { __typename?: 'Notification', id?: string | null, createdAt?: any | null, subject?: string | null, message?: string | null, readAt?: any | null, recipient?: { __typename?: 'Broker', id: string, firstName?: string | null, lastName?: string | null, email: string } | null } | null };

export type NotificationFragment = { __typename?: 'Notification', id?: string | null, createdAt?: any | null, subject?: string | null, message?: string | null, readAt?: any | null, recipient?: { __typename?: 'Broker', id: string, firstName?: string | null, lastName?: string | null, email: string } | null };

export type MediaItemFragment = { __typename?: 'Media', id: string, location: string, title?: string | null, filename?: string | null, type?: string | null, mimetype?: string | null, position?: number | null };

export type PropertyLandmarkFragment = { __typename?: 'Landmark', name: string, distance?: number | null, distanceText?: string | null, type?: string | null, address?: { __typename?: 'Address', id?: string | null, latitude?: number | null, longitude?: number | null } | null };

export type PropertyNoteFragment = { __typename?: 'Note', id: string, subject?: string | null, note: string, type?: NoteType | null, sender?: string | null, recipient?: string | null, sentAt?: any | null, externalRef?: string | null, updatedAt: any, updatedBy: { __typename?: 'Broker', id: string, firstName?: string | null, lastName?: string | null } };

export type PropertyOfficeFragment = { __typename?: 'Office', id: string, officeType: OfficeType, name: string, desks?: number | null, size?: number | null, sizeUnit: SizeUnit, floor?: number | null, availableFrom?: any | null, availableUntil?: any | null, leadTime?: number | null, leadTimeUnit?: LeadTimeUnit | null, description?: string | null, price?: number | null, groundRent?: number | null, rates?: number | null, totalCost?: number | null, estateCharge?: number | null, minimumTerm?: number | null, minimumTermUnit: TermUnit, nuggetedAt?: any | null, available: Availability, fitted: Fitted, updatedAt?: any | null, disposalComments?: string | null, instructedOffice: boolean, property: { __typename?: 'Property', id: string, region: { __typename?: 'Region', id: string, name: string, currency: { __typename?: 'Currency', id: string, symbol: string }, parentRegion?: { __typename?: 'Region', id: string, name: string } | null } }, note?: Array<{ __typename?: 'Note', id: string, subject?: string | null, note: string, type?: NoteType | null, sender?: string | null, recipient?: string | null, sentAt?: any | null, externalRef?: string | null, updatedAt: any, updatedBy: { __typename?: 'Broker', id: string, firstName?: string | null, lastName?: string | null } } | null> | null, amenity: Array<{ __typename?: 'Amenity', id: string, name: string }>, featureImage?: { __typename?: 'Media', id: string, location: string, title?: string | null, filename?: string | null, type?: string | null, mimetype?: string | null, position?: number | null } | null, floorplan: Array<{ __typename?: 'Media', id: string, location: string, title?: string | null, filename?: string | null, type?: string | null, mimetype?: string | null, position?: number | null }>, image: Array<{ __typename?: 'Media', id: string, location: string, title?: string | null, filename?: string | null, type?: string | null, mimetype?: string | null, position?: number | null }>, tour: Array<{ __typename?: 'Media', id: string, location: string, title?: string | null, filename?: string | null, type?: string | null, mimetype?: string | null, position?: number | null }>, updatedBy?: { __typename?: 'Broker', firstName?: string | null, lastName?: string | null } | null };

export type SinglePropertyFragment = { __typename?: 'Property', id: string, name: string, description?: string | null, shortDescription?: string | null, isActive?: boolean | null, propertyType: PropertyType, serviceType: ServiceType, wholeBuildingOnly?: boolean | null, region: { __typename?: 'Region', id: string, name: string, currency: { __typename?: 'Currency', id: string, symbol: string } }, landmark: Array<{ __typename?: 'Landmark', name: string, distance?: number | null, distanceText?: string | null, type?: string | null, address?: { __typename?: 'Address', id?: string | null, latitude?: number | null, longitude?: number | null } | null }>, amenity: Array<{ __typename?: 'Amenity', id: string, name: string }>, provider: { __typename?: 'Provider', id: string, name: string, defaultOfficeType?: string | null, logo?: { __typename?: 'Media', id: string, location: string } | null }, contact?: Array<{ __typename?: 'Contact', id: string, firstName?: string | null, lastName?: string | null, email?: string | null, phone?: string | null }> | null, address: { __typename?: 'Address', id?: string | null, name?: string | null, line1?: string | null, line2?: string | null, suburb?: string | null, city?: string | null, county?: string | null, country?: string | null, postcode?: string | null, latitude?: number | null, longitude?: number | null }, featureImage?: { __typename?: 'Media', id: string, location: string } | null, image: Array<{ __typename?: 'Media', id: string, location: string, title?: string | null, filename?: string | null, type?: string | null, mimetype?: string | null, position?: number | null }>, floorplan: Array<{ __typename?: 'Media', id: string, location: string, title?: string | null, filename?: string | null, type?: string | null, mimetype?: string | null, position?: number | null }>, tour: Array<{ __typename?: 'Media', id: string, location: string, title?: string | null, filename?: string | null, type?: string | null, mimetype?: string | null, position?: number | null }>, brochure: Array<{ __typename?: 'Media', id: string, location: string, title?: string | null, filename?: string | null, type?: string | null, mimetype?: string | null, position?: number | null }>, particular: Array<{ __typename?: 'Media', id: string, location: string, title?: string | null, filename?: string | null, type?: string | null, mimetype?: string | null, position?: number | null }>, note: Array<{ __typename?: 'Note', id: string, subject?: string | null, note: string, type?: NoteType | null, sender?: string | null, recipient?: string | null, sentAt?: any | null, externalRef?: string | null, updatedAt: any, updatedBy: { __typename?: 'Broker', id: string, firstName?: string | null, lastName?: string | null } }>, providerRegion: { __typename?: 'ProviderRegion', id: string, region: { __typename?: 'Region', id: string, name: string } }, office: Array<{ __typename?: 'Office', id: string, officeType: OfficeType, name: string, desks?: number | null, size?: number | null, sizeUnit: SizeUnit, floor?: number | null, availableFrom?: any | null, availableUntil?: any | null, leadTime?: number | null, leadTimeUnit?: LeadTimeUnit | null, description?: string | null, price?: number | null, groundRent?: number | null, rates?: number | null, totalCost?: number | null, estateCharge?: number | null, minimumTerm?: number | null, minimumTermUnit: TermUnit, nuggetedAt?: any | null, available: Availability, fitted: Fitted, updatedAt?: any | null, disposalComments?: string | null, instructedOffice: boolean, property: { __typename?: 'Property', id: string, region: { __typename?: 'Region', id: string, name: string, currency: { __typename?: 'Currency', id: string, symbol: string }, parentRegion?: { __typename?: 'Region', id: string, name: string } | null } }, note?: Array<{ __typename?: 'Note', id: string, subject?: string | null, note: string, type?: NoteType | null, sender?: string | null, recipient?: string | null, sentAt?: any | null, externalRef?: string | null, updatedAt: any, updatedBy: { __typename?: 'Broker', id: string, firstName?: string | null, lastName?: string | null } } | null> | null, amenity: Array<{ __typename?: 'Amenity', id: string, name: string }>, featureImage?: { __typename?: 'Media', id: string, location: string, title?: string | null, filename?: string | null, type?: string | null, mimetype?: string | null, position?: number | null } | null, floorplan: Array<{ __typename?: 'Media', id: string, location: string, title?: string | null, filename?: string | null, type?: string | null, mimetype?: string | null, position?: number | null }>, image: Array<{ __typename?: 'Media', id: string, location: string, title?: string | null, filename?: string | null, type?: string | null, mimetype?: string | null, position?: number | null }>, tour: Array<{ __typename?: 'Media', id: string, location: string, title?: string | null, filename?: string | null, type?: string | null, mimetype?: string | null, position?: number | null }>, updatedBy?: { __typename?: 'Broker', firstName?: string | null, lastName?: string | null } | null }>, instruction?: { __typename?: 'Instruction', id: string, broker: Array<{ __typename?: 'Broker', id: string, firstName?: string | null, lastName?: string | null, email: string }> } | null };

export type ClientDealDealFragment = { __typename?: 'Deal', id: string, name: string, showProviderFilter?: boolean | null, showAvailableFrom?: boolean | null, showMatchingToggle?: boolean | null, canFavourite?: boolean | null, client: { __typename?: 'Client', name: string }, schedule: { __typename?: 'Schedule', id: string, favouritesSent: number }, contact: { __typename?: 'Contact', id: string, firstName?: string | null, lastName?: string | null }, currentAddress?: { __typename?: 'Address', id?: string | null, line1?: string | null, latitude?: number | null, longitude?: number | null } | null };

export type ClientDealBrokerFragment = { __typename?: 'Broker', id: string, firstName?: string | null, lastName?: string | null, email: string, phone?: string | null, bookingLink?: string | null, brokerImage?: { __typename?: 'Media', id: string, location: string, title?: string | null, filename?: string | null, type?: string | null, mimetype?: string | null, position?: number | null } | null };

export type ClientDealPropertyFragment = { __typename?: 'Property', id: string, name: string, position?: number | null, description?: string | null, propertyType: PropertyType, wholeBuildingOnly?: boolean | null, region: { __typename?: 'Region', id: string, name: string, currency: { __typename?: 'Currency', id: string }, parentRegion?: { __typename?: 'Region', id: string, name: string } | null }, provider: { __typename?: 'Provider', id: string, name: string }, amenity: Array<{ __typename?: 'Amenity', id: string, name: string }>, featureImage?: { __typename?: 'Media', id: string, location: string, title?: string | null, filename?: string | null, type?: string | null, mimetype?: string | null, position?: number | null } | null, image: Array<{ __typename?: 'Media', id: string, location: string, title?: string | null, filename?: string | null, type?: string | null, mimetype?: string | null, position?: number | null }>, floorplan: Array<{ __typename?: 'Media', id: string, location: string, title?: string | null, filename?: string | null, type?: string | null, mimetype?: string | null, position?: number | null }>, tour: Array<{ __typename?: 'Media', id: string, location: string, title?: string | null, filename?: string | null, type?: string | null, mimetype?: string | null, position?: number | null }>, brochure: Array<{ __typename?: 'Media', id: string, location: string, title?: string | null, filename?: string | null, type?: string | null, mimetype?: string | null, position?: number | null }>, address: { __typename?: 'Address', id?: string | null, name?: string | null, line1?: string | null, suburb?: string | null, city?: string | null, county?: string | null, postcode?: string | null, latitude?: number | null, longitude?: number | null }, scheduleOffice: Array<{ __typename?: 'ScheduleOffice', id: string, name: string, description?: string | null, totalCost?: number | null, desks?: number | null, size?: number | null, sizeUnit: SizeUnit, floor?: number | null, price?: number | null, groundRent?: number | null, estateCharge?: number | null, rates?: number | null, availableFrom?: any | null, availableUntil?: any | null, available: Availability, leadTime?: number | null, leadTimeUnit?: LeadTimeUnit | null, minimumTerm?: number | null, minimumTermUnit: TermUnit, rentFreePeriod?: number | null, rentFreePeriodUnit: TermUnit, officeType: OfficeType, status: ScheduleOfficeStatus, fitted: Fitted, createdAt?: any | null, linkedToOffice: Array<{ __typename?: 'ScheduleOffice', id: string, name: string, desks?: number | null, size?: number | null, sizeUnit: SizeUnit, totalCost?: number | null, minimumTerm?: number | null, minimumTermUnit: TermUnit, price?: number | null, groundRent?: number | null, rates?: number | null, floor?: number | null, status: ScheduleOfficeStatus, fitted: Fitted }>, linkedByOffice: Array<{ __typename?: 'ScheduleOffice', id: string, name: string, desks?: number | null, size?: number | null, sizeUnit: SizeUnit, totalCost?: number | null, minimumTerm?: number | null, minimumTermUnit: TermUnit, price?: number | null, groundRent?: number | null, rates?: number | null, floor?: number | null, status: ScheduleOfficeStatus, fitted: Fitted }>, property: { __typename?: 'Property', id: string, region: { __typename?: 'Region', id: string, name: string, currency: { __typename?: 'Currency', id: string }, parentRegion?: { __typename?: 'Region', id: string, name: string } | null } }, amenity: Array<{ __typename?: 'Amenity', id: string, name: string }>, note?: Array<{ __typename?: 'Note', id: string, note: string, createdBy: { __typename?: 'Broker', id: string, firstName?: string | null, lastName?: string | null, brokerImage?: { __typename?: 'Media', id: string, location: string } | null } } | null> | null, featureImage?: { __typename?: 'Media', id: string, location: string, title?: string | null, filename?: string | null, type?: string | null, mimetype?: string | null, position?: number | null } | null, image: Array<{ __typename?: 'Media', id: string, location: string, title?: string | null, filename?: string | null, type?: string | null, mimetype?: string | null, position?: number | null }>, floorplan: Array<{ __typename?: 'Media', id: string, location: string, title?: string | null, filename?: string | null, type?: string | null, mimetype?: string | null, position?: number | null }>, tour: Array<{ __typename?: 'Media', id: string, location: string, title?: string | null, filename?: string | null, type?: string | null, mimetype?: string | null, position?: number | null }> }>, landmark: Array<{ __typename?: 'Landmark', id: string, type?: string | null, name: string, distance?: number | null, distanceText?: string | null, durationText?: string | null }> };

export type ClientDealOtherPropertyFragment = { __typename?: 'OtherProperty', id: string, name: string, hasAvailableOffices?: boolean | null, region: { __typename?: 'Region', id: string, name: string, currency: { __typename?: 'Currency', id: string }, parentRegion?: { __typename?: 'Region', id: string, name: string } | null }, featureImage?: { __typename?: 'Media', id: string, location: string, title?: string | null, filename?: string | null, type?: string | null, mimetype?: string | null, position?: number | null } | null, address: { __typename?: 'Address', id?: string | null, latitude?: number | null, longitude?: number | null } };

export type ClientDealLandmarkFragment = { __typename?: 'Landmark', id: string, type?: string | null, name: string, distance?: number | null, distanceText?: string | null, durationText?: string | null };

export type ClientDealOfficeFragment = { __typename?: 'ScheduleOffice', id: string, name: string, description?: string | null, totalCost?: number | null, desks?: number | null, size?: number | null, sizeUnit: SizeUnit, floor?: number | null, price?: number | null, groundRent?: number | null, estateCharge?: number | null, rates?: number | null, availableFrom?: any | null, availableUntil?: any | null, available: Availability, leadTime?: number | null, leadTimeUnit?: LeadTimeUnit | null, minimumTerm?: number | null, minimumTermUnit: TermUnit, rentFreePeriod?: number | null, rentFreePeriodUnit: TermUnit, officeType: OfficeType, status: ScheduleOfficeStatus, fitted: Fitted, createdAt?: any | null, linkedToOffice: Array<{ __typename?: 'ScheduleOffice', id: string, name: string, desks?: number | null, size?: number | null, sizeUnit: SizeUnit, totalCost?: number | null, minimumTerm?: number | null, minimumTermUnit: TermUnit, price?: number | null, groundRent?: number | null, rates?: number | null, floor?: number | null, status: ScheduleOfficeStatus, fitted: Fitted }>, linkedByOffice: Array<{ __typename?: 'ScheduleOffice', id: string, name: string, desks?: number | null, size?: number | null, sizeUnit: SizeUnit, totalCost?: number | null, minimumTerm?: number | null, minimumTermUnit: TermUnit, price?: number | null, groundRent?: number | null, rates?: number | null, floor?: number | null, status: ScheduleOfficeStatus, fitted: Fitted }>, property: { __typename?: 'Property', id: string, region: { __typename?: 'Region', id: string, name: string, currency: { __typename?: 'Currency', id: string }, parentRegion?: { __typename?: 'Region', id: string, name: string } | null } }, amenity: Array<{ __typename?: 'Amenity', id: string, name: string }>, note?: Array<{ __typename?: 'Note', id: string, note: string, createdBy: { __typename?: 'Broker', id: string, firstName?: string | null, lastName?: string | null, brokerImage?: { __typename?: 'Media', id: string, location: string } | null } } | null> | null, featureImage?: { __typename?: 'Media', id: string, location: string, title?: string | null, filename?: string | null, type?: string | null, mimetype?: string | null, position?: number | null } | null, image: Array<{ __typename?: 'Media', id: string, location: string, title?: string | null, filename?: string | null, type?: string | null, mimetype?: string | null, position?: number | null }>, floorplan: Array<{ __typename?: 'Media', id: string, location: string, title?: string | null, filename?: string | null, type?: string | null, mimetype?: string | null, position?: number | null }>, tour: Array<{ __typename?: 'Media', id: string, location: string, title?: string | null, filename?: string | null, type?: string | null, mimetype?: string | null, position?: number | null }> };

export type AvailabilityDashboardDataQueryVariables = Exact<{ [key: string]: never; }>;


export type AvailabilityDashboardDataQuery = { __typename?: 'Query', availabilityDashboardData?: Array<{ __typename?: 'AvailabilityDashboardType', providerName?: string | null, createdOffices?: number | null, updatedOffices?: number | null, outdatedOffices?: number | null, createdAt?: any | null, createdProperties?: string | null } | null> | null };

export type ClientDealQueryVariables = Exact<{
  id?: InputMaybe<Scalars['String']>;
  showOtherProperties?: InputMaybe<Scalars['Boolean']>;
}>;


export type ClientDealQuery = { __typename?: 'Query', clientDeal?: { __typename?: 'ClientDeal', deal: { __typename?: 'Deal', id: string, name: string, showProviderFilter?: boolean | null, showAvailableFrom?: boolean | null, showMatchingToggle?: boolean | null, canFavourite?: boolean | null, client: { __typename?: 'Client', name: string }, schedule: { __typename?: 'Schedule', id: string, favouritesSent: number }, contact: { __typename?: 'Contact', id: string, firstName?: string | null, lastName?: string | null }, currentAddress?: { __typename?: 'Address', id?: string | null, line1?: string | null, latitude?: number | null, longitude?: number | null } | null }, broker: { __typename?: 'Broker', id: string, firstName?: string | null, lastName?: string | null, email: string, phone?: string | null, bookingLink?: string | null, brokerImage?: { __typename?: 'Media', id: string, location: string, title?: string | null, filename?: string | null, type?: string | null, mimetype?: string | null, position?: number | null } | null }, secondaryBroker?: { __typename?: 'Broker', id: string, firstName?: string | null, lastName?: string | null, email: string, phone?: string | null, bookingLink?: string | null, brokerImage?: { __typename?: 'Media', id: string, location: string, title?: string | null, filename?: string | null, type?: string | null, mimetype?: string | null, position?: number | null } | null } | null, properties: Array<{ __typename?: 'Property', id: string, name: string, position?: number | null, description?: string | null, propertyType: PropertyType, wholeBuildingOnly?: boolean | null, region: { __typename?: 'Region', id: string, name: string, currency: { __typename?: 'Currency', id: string }, parentRegion?: { __typename?: 'Region', id: string, name: string } | null }, provider: { __typename?: 'Provider', id: string, name: string }, amenity: Array<{ __typename?: 'Amenity', id: string, name: string }>, featureImage?: { __typename?: 'Media', id: string, location: string, title?: string | null, filename?: string | null, type?: string | null, mimetype?: string | null, position?: number | null } | null, image: Array<{ __typename?: 'Media', id: string, location: string, title?: string | null, filename?: string | null, type?: string | null, mimetype?: string | null, position?: number | null }>, floorplan: Array<{ __typename?: 'Media', id: string, location: string, title?: string | null, filename?: string | null, type?: string | null, mimetype?: string | null, position?: number | null }>, tour: Array<{ __typename?: 'Media', id: string, location: string, title?: string | null, filename?: string | null, type?: string | null, mimetype?: string | null, position?: number | null }>, brochure: Array<{ __typename?: 'Media', id: string, location: string, title?: string | null, filename?: string | null, type?: string | null, mimetype?: string | null, position?: number | null }>, address: { __typename?: 'Address', id?: string | null, name?: string | null, line1?: string | null, suburb?: string | null, city?: string | null, county?: string | null, postcode?: string | null, latitude?: number | null, longitude?: number | null }, scheduleOffice: Array<{ __typename?: 'ScheduleOffice', id: string, name: string, description?: string | null, totalCost?: number | null, desks?: number | null, size?: number | null, sizeUnit: SizeUnit, floor?: number | null, price?: number | null, groundRent?: number | null, estateCharge?: number | null, rates?: number | null, availableFrom?: any | null, availableUntil?: any | null, available: Availability, leadTime?: number | null, leadTimeUnit?: LeadTimeUnit | null, minimumTerm?: number | null, minimumTermUnit: TermUnit, rentFreePeriod?: number | null, rentFreePeriodUnit: TermUnit, officeType: OfficeType, status: ScheduleOfficeStatus, fitted: Fitted, createdAt?: any | null, linkedToOffice: Array<{ __typename?: 'ScheduleOffice', id: string, name: string, desks?: number | null, size?: number | null, sizeUnit: SizeUnit, totalCost?: number | null, minimumTerm?: number | null, minimumTermUnit: TermUnit, price?: number | null, groundRent?: number | null, rates?: number | null, floor?: number | null, status: ScheduleOfficeStatus, fitted: Fitted }>, linkedByOffice: Array<{ __typename?: 'ScheduleOffice', id: string, name: string, desks?: number | null, size?: number | null, sizeUnit: SizeUnit, totalCost?: number | null, minimumTerm?: number | null, minimumTermUnit: TermUnit, price?: number | null, groundRent?: number | null, rates?: number | null, floor?: number | null, status: ScheduleOfficeStatus, fitted: Fitted }>, property: { __typename?: 'Property', id: string, region: { __typename?: 'Region', id: string, name: string, currency: { __typename?: 'Currency', id: string }, parentRegion?: { __typename?: 'Region', id: string, name: string } | null } }, amenity: Array<{ __typename?: 'Amenity', id: string, name: string }>, note?: Array<{ __typename?: 'Note', id: string, note: string, createdBy: { __typename?: 'Broker', id: string, firstName?: string | null, lastName?: string | null, brokerImage?: { __typename?: 'Media', id: string, location: string } | null } } | null> | null, featureImage?: { __typename?: 'Media', id: string, location: string, title?: string | null, filename?: string | null, type?: string | null, mimetype?: string | null, position?: number | null } | null, image: Array<{ __typename?: 'Media', id: string, location: string, title?: string | null, filename?: string | null, type?: string | null, mimetype?: string | null, position?: number | null }>, floorplan: Array<{ __typename?: 'Media', id: string, location: string, title?: string | null, filename?: string | null, type?: string | null, mimetype?: string | null, position?: number | null }>, tour: Array<{ __typename?: 'Media', id: string, location: string, title?: string | null, filename?: string | null, type?: string | null, mimetype?: string | null, position?: number | null }> }>, landmark: Array<{ __typename?: 'Landmark', id: string, type?: string | null, name: string, distance?: number | null, distanceText?: string | null, durationText?: string | null }> }>, otherProperties: Array<{ __typename?: 'OtherProperty', id: string, name: string, hasAvailableOffices?: boolean | null, region: { __typename?: 'Region', id: string, name: string, currency: { __typename?: 'Currency', id: string }, parentRegion?: { __typename?: 'Region', id: string, name: string } | null }, featureImage?: { __typename?: 'Media', id: string, location: string, title?: string | null, filename?: string | null, type?: string | null, mimetype?: string | null, position?: number | null } | null, address: { __typename?: 'Address', id?: string | null, latitude?: number | null, longitude?: number | null } }> } | null };

export type ConnectedDealsQueryVariables = Exact<{
  officeId: Scalars['String'];
}>;


export type ConnectedDealsQuery = { __typename?: 'Query', connectedDeals?: Array<{ __typename?: 'Deal', id: string, name: string, createdAt?: any | null, schedule: { __typename?: 'Schedule', id: string }, leadBroker: { __typename?: 'Broker', id: string, firstName?: string | null, lastName?: string | null } } | null> | null };

export type ConnectedDealsListFragment = { __typename?: 'Deal', id: string, name: string, createdAt?: any | null, schedule: { __typename?: 'Schedule', id: string }, leadBroker: { __typename?: 'Broker', id: string, firstName?: string | null, lastName?: string | null } };

export type CreateOfficeMutationVariables = Exact<{
  input?: InputMaybe<OfficeCreateInput>;
}>;


export type CreateOfficeMutation = { __typename?: 'Mutation', createOffice?: { __typename?: 'Office', id: string, name: string } | null };

export type CurrenciesQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrenciesQuery = { __typename?: 'Query', currencies: Array<{ __typename?: 'Currency', id: string, name: string, code: string, symbol: string }> };

export type SingleCurrencyFragment = { __typename?: 'Currency', id: string, name: string, code: string, symbol: string };

export type DispoDashboardQueryVariables = Exact<{ [key: string]: never; }>;


export type DispoDashboardQuery = { __typename?: 'Query', dispoDashboard?: Array<{ __typename?: 'dispoDashboardProperty', property: { __typename?: 'Property', id: string, name: string, description?: string | null, shortDescription?: string | null, propertyType: PropertyType, serviceType: ServiceType, region: { __typename?: 'Region', id: string }, address: { __typename?: 'Address', id?: string | null, streetName?: string | null } }, deals?: Array<{ __typename?: 'Deal', id: string, name: string, status: string, budget?: number | null, desks?: number | null, size?: number | null, sizeUnit: SizeUnit, locationNames: Array<string>, leadBroker: { __typename?: 'Broker', id: string, firstName?: string | null, lastName?: string | null }, secondaryBroker?: { __typename?: 'Broker', id: string, firstName?: string | null, lastName?: string | null } | null, schedule: { __typename?: 'Schedule', scheduleOffice: Array<{ __typename?: 'ScheduleOffice', id: string, name: string, desks?: number | null, size?: number | null, floor?: number | null, officeType: OfficeType, status: ScheduleOfficeStatus, totalCost?: number | null, price?: number | null, rates?: number | null, groundRent?: number | null, estateCharge?: number | null, propertyId: string, createdAt?: any | null }> } } | null> | null } | null> | null };

export type PropertyImagesQueryVariables = Exact<{
  id?: InputMaybe<Scalars['String']>;
}>;


export type PropertyImagesQuery = { __typename?: 'Query', propertyImages?: { __typename?: 'PropertyImages', images: Array<{ __typename?: 'Media', id: string, location: string, title?: string | null, filename?: string | null, type?: string | null, mimetype?: string | null, position?: number | null }>, particulars: Array<{ __typename?: 'Media', id: string, location: string, title?: string | null, filename?: string | null, type?: string | null, mimetype?: string | null, position?: number | null }>, brochures: Array<{ __typename?: 'Media', id: string, location: string, title?: string | null, filename?: string | null, type?: string | null, mimetype?: string | null, position?: number | null }>, floorplans: Array<{ __typename?: 'Media', id: string, location: string, title?: string | null, filename?: string | null, type?: string | null, mimetype?: string | null, position?: number | null }> } | null };

export type NotifyBrokerMutationVariables = Exact<{
  dealId?: InputMaybe<Scalars['String']>;
}>;


export type NotifyBrokerMutation = { __typename?: 'Mutation', notifyBroker?: boolean | null };

export type OfficeListingQueryVariables = Exact<{
  filter?: InputMaybe<OfficeInput>;
}>;


export type OfficeListingQuery = { __typename?: 'Query', officeListing?: { __typename?: 'OfficeListing', previous?: string | null, next?: string | null, total?: number | null, data: Array<{ __typename?: 'Office', id: string, officeType: OfficeType, name: string, desks?: number | null, size?: number | null, sizeUnit: SizeUnit, floor?: number | null, availableFrom?: any | null, description?: string | null, price?: number | null, groundRent?: number | null, rates?: number | null, totalCost?: number | null, minimumTerm?: number | null, minimumTermUnit: TermUnit, nuggetedAt?: any | null, available: Availability, fitted: Fitted, updatedAt?: any | null, instructedOffice: boolean, property: { __typename?: 'Property', id: string, name: string, wholeBuildingOnly?: boolean | null, region: { __typename?: 'Region', id: string, name: string, currency: { __typename?: 'Currency', id: string, symbol: string } }, address: { __typename?: 'Address', id?: string | null, suburb?: string | null }, provider: { __typename?: 'Provider', id: string, name: string } }, note?: Array<{ __typename?: 'Note', id: string, subject?: string | null, note: string, type?: NoteType | null, sender?: string | null, recipient?: string | null, sentAt?: any | null, externalRef?: string | null, updatedAt: any, updatedBy: { __typename?: 'Broker', id: string, firstName?: string | null, lastName?: string | null } } | null> | null, amenity: Array<{ __typename?: 'Amenity', id: string, name: string }>, featureImage?: { __typename?: 'Media', id: string, title?: string | null, location: string } | null, floorplan: Array<{ __typename?: 'Media', id: string, title?: string | null, location: string }>, image: Array<{ __typename?: 'Media', id: string, title?: string | null, location: string }>, tour: Array<{ __typename?: 'Media', id: string, title?: string | null, location: string }>, updatedBy?: { __typename?: 'Broker', firstName?: string | null, lastName?: string | null } | null }> } | null };

export type PropertiesQueryVariables = Exact<{
  input?: InputMaybe<PropertyInput>;
}>;


export type PropertiesQuery = { __typename?: 'Query', properties?: { __typename?: 'PropertyListing', previous?: string | null, next?: string | null, total?: number | null, data?: Array<{ __typename?: 'Property', id: string, name: string, wholeBuildingOnly?: boolean | null, region: { __typename?: 'Region', id: string, name: string, currency: { __typename?: 'Currency', id: string, symbol: string } }, instruction?: { __typename?: 'Instruction', id: string } | null, address: { __typename?: 'Address', id?: string | null, suburb?: string | null }, provider: { __typename?: 'Provider', id: string, name: string }, office: Array<{ __typename?: 'Office', id: string, floor?: number | null, name: string, available: Availability }> } | null> | null } | null };

export type RentmapPropertiesQueryVariables = Exact<{ [key: string]: never; }>;


export type RentmapPropertiesQuery = { __typename?: 'Query', rentmapProperties?: Array<{ __typename?: 'RentMapProperties', region: string, properties?: Array<{ __typename?: 'Property', id: string, isActive?: boolean | null, propertyType: PropertyType, address: { __typename?: 'Address', id?: string | null, latitude?: number | null, longitude?: number | null }, region: { __typename?: 'Region', id: string, name: string }, provider: { __typename?: 'Provider', id: string, name: string }, office: Array<{ __typename?: 'Office', id: string, available: Availability, officeType: OfficeType, sizeUnit: SizeUnit, price?: number | null, totalCost?: number | null, fitted: Fitted, size?: number | null, desks?: number | null }> } | null> | null } | null> | null };

export type PropertyQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type PropertyQuery = { __typename?: 'Query', property: { __typename?: 'Property', id: string, name: string, description?: string | null, shortDescription?: string | null, isActive?: boolean | null, propertyType: PropertyType, serviceType: ServiceType, wholeBuildingOnly?: boolean | null, region: { __typename?: 'Region', id: string, name: string, currency: { __typename?: 'Currency', id: string, symbol: string } }, landmark: Array<{ __typename?: 'Landmark', name: string, distance?: number | null, distanceText?: string | null, type?: string | null, address?: { __typename?: 'Address', id?: string | null, latitude?: number | null, longitude?: number | null } | null }>, amenity: Array<{ __typename?: 'Amenity', id: string, name: string }>, provider: { __typename?: 'Provider', id: string, name: string, defaultOfficeType?: string | null, logo?: { __typename?: 'Media', id: string, location: string } | null }, contact?: Array<{ __typename?: 'Contact', id: string, firstName?: string | null, lastName?: string | null, email?: string | null, phone?: string | null }> | null, address: { __typename?: 'Address', id?: string | null, name?: string | null, line1?: string | null, line2?: string | null, suburb?: string | null, city?: string | null, county?: string | null, country?: string | null, postcode?: string | null, latitude?: number | null, longitude?: number | null }, featureImage?: { __typename?: 'Media', id: string, location: string } | null, image: Array<{ __typename?: 'Media', id: string, location: string, title?: string | null, filename?: string | null, type?: string | null, mimetype?: string | null, position?: number | null }>, floorplan: Array<{ __typename?: 'Media', id: string, location: string, title?: string | null, filename?: string | null, type?: string | null, mimetype?: string | null, position?: number | null }>, tour: Array<{ __typename?: 'Media', id: string, location: string, title?: string | null, filename?: string | null, type?: string | null, mimetype?: string | null, position?: number | null }>, brochure: Array<{ __typename?: 'Media', id: string, location: string, title?: string | null, filename?: string | null, type?: string | null, mimetype?: string | null, position?: number | null }>, particular: Array<{ __typename?: 'Media', id: string, location: string, title?: string | null, filename?: string | null, type?: string | null, mimetype?: string | null, position?: number | null }>, note: Array<{ __typename?: 'Note', id: string, subject?: string | null, note: string, type?: NoteType | null, sender?: string | null, recipient?: string | null, sentAt?: any | null, externalRef?: string | null, updatedAt: any, updatedBy: { __typename?: 'Broker', id: string, firstName?: string | null, lastName?: string | null } }>, providerRegion: { __typename?: 'ProviderRegion', id: string, region: { __typename?: 'Region', id: string, name: string } }, office: Array<{ __typename?: 'Office', id: string, officeType: OfficeType, name: string, desks?: number | null, size?: number | null, sizeUnit: SizeUnit, floor?: number | null, availableFrom?: any | null, availableUntil?: any | null, leadTime?: number | null, leadTimeUnit?: LeadTimeUnit | null, description?: string | null, price?: number | null, groundRent?: number | null, rates?: number | null, totalCost?: number | null, estateCharge?: number | null, minimumTerm?: number | null, minimumTermUnit: TermUnit, nuggetedAt?: any | null, available: Availability, fitted: Fitted, updatedAt?: any | null, disposalComments?: string | null, instructedOffice: boolean, property: { __typename?: 'Property', id: string, region: { __typename?: 'Region', id: string, name: string, currency: { __typename?: 'Currency', id: string, symbol: string }, parentRegion?: { __typename?: 'Region', id: string, name: string } | null } }, note?: Array<{ __typename?: 'Note', id: string, subject?: string | null, note: string, type?: NoteType | null, sender?: string | null, recipient?: string | null, sentAt?: any | null, externalRef?: string | null, updatedAt: any, updatedBy: { __typename?: 'Broker', id: string, firstName?: string | null, lastName?: string | null } } | null> | null, amenity: Array<{ __typename?: 'Amenity', id: string, name: string }>, featureImage?: { __typename?: 'Media', id: string, location: string, title?: string | null, filename?: string | null, type?: string | null, mimetype?: string | null, position?: number | null } | null, floorplan: Array<{ __typename?: 'Media', id: string, location: string, title?: string | null, filename?: string | null, type?: string | null, mimetype?: string | null, position?: number | null }>, image: Array<{ __typename?: 'Media', id: string, location: string, title?: string | null, filename?: string | null, type?: string | null, mimetype?: string | null, position?: number | null }>, tour: Array<{ __typename?: 'Media', id: string, location: string, title?: string | null, filename?: string | null, type?: string | null, mimetype?: string | null, position?: number | null }>, updatedBy?: { __typename?: 'Broker', firstName?: string | null, lastName?: string | null } | null }>, instruction?: { __typename?: 'Instruction', id: string, broker: Array<{ __typename?: 'Broker', id: string, firstName?: string | null, lastName?: string | null, email: string }> } | null } };

export type RemoveScheduleOfficesMutationVariables = Exact<{
  input?: InputMaybe<ScheduleOfficeRemoveInput>;
}>;


export type RemoveScheduleOfficesMutation = { __typename?: 'Mutation', removeScheduleOffices?: { __typename?: 'ScheduleOfficesRemoved', count?: number | null } | null };

export type ScheduleOfficeQueryVariables = Exact<{
  id?: InputMaybe<Scalars['String']>;
}>;


export type ScheduleOfficeQuery = { __typename?: 'Query', scheduleOffice?: { __typename?: 'ScheduleOffice', id: string, officeType: OfficeType, name: string, desks?: number | null, size?: number | null, sizeUnit: SizeUnit, floor?: number | null, availableFrom?: any | null, leadTime?: number | null, leadTimeUnit?: LeadTimeUnit | null, description?: string | null, price?: number | null, groundRent?: number | null, rates?: number | null, totalCost?: number | null, nuggetedAt?: any | null, minimumTerm?: number | null, minimumTermUnit: TermUnit, available: Availability, fitted: Fitted, property: { __typename?: 'Property', id: string, region: { __typename?: 'Region', id: string, name: string, currency: { __typename?: 'Currency', id: string } } }, featureImage?: { __typename?: 'Media', id: string, location: string, title?: string | null, filename?: string | null, type?: string | null, mimetype?: string | null, position?: number | null } | null, amenity: Array<{ __typename?: 'Amenity', id: string, name: string }>, floorplan: Array<{ __typename?: 'Media', id: string, location: string, title?: string | null, filename?: string | null, type?: string | null, mimetype?: string | null, position?: number | null }>, image: Array<{ __typename?: 'Media', id: string, location: string, title?: string | null, filename?: string | null, type?: string | null, mimetype?: string | null, position?: number | null }>, tour: Array<{ __typename?: 'Media', id: string, location: string, title?: string | null, filename?: string | null, type?: string | null, mimetype?: string | null, position?: number | null }>, schedule: { __typename?: 'Schedule', dealId: string } } | null };

export type ScheduleOfficeFragment = { __typename?: 'ScheduleOffice', id: string, officeType: OfficeType, name: string, desks?: number | null, size?: number | null, sizeUnit: SizeUnit, floor?: number | null, availableFrom?: any | null, leadTime?: number | null, leadTimeUnit?: LeadTimeUnit | null, description?: string | null, price?: number | null, groundRent?: number | null, rates?: number | null, totalCost?: number | null, nuggetedAt?: any | null, minimumTerm?: number | null, minimumTermUnit: TermUnit, available: Availability, fitted: Fitted, property: { __typename?: 'Property', id: string, region: { __typename?: 'Region', id: string, name: string, currency: { __typename?: 'Currency', id: string } } }, featureImage?: { __typename?: 'Media', id: string, location: string, title?: string | null, filename?: string | null, type?: string | null, mimetype?: string | null, position?: number | null } | null, amenity: Array<{ __typename?: 'Amenity', id: string, name: string }>, floorplan: Array<{ __typename?: 'Media', id: string, location: string, title?: string | null, filename?: string | null, type?: string | null, mimetype?: string | null, position?: number | null }>, image: Array<{ __typename?: 'Media', id: string, location: string, title?: string | null, filename?: string | null, type?: string | null, mimetype?: string | null, position?: number | null }>, tour: Array<{ __typename?: 'Media', id: string, location: string, title?: string | null, filename?: string | null, type?: string | null, mimetype?: string | null, position?: number | null }>, schedule: { __typename?: 'Schedule', dealId: string } };

export type SyncScheduledOfficeMutationVariables = Exact<{
  input?: InputMaybe<SyncOfficeInput>;
}>;


export type SyncScheduledOfficeMutation = { __typename?: 'Mutation', syncScheduleOffice?: { __typename?: 'ScheduleOffice', id: string } | null };

export type UpdateOfficeMutationVariables = Exact<{
  input?: InputMaybe<OfficeUpdateInput>;
}>;


export type UpdateOfficeMutation = { __typename?: 'Mutation', updateOffice?: { __typename?: 'Office', id: string, officeType: OfficeType, name: string, desks?: number | null, size?: number | null, sizeUnit: SizeUnit, floor?: number | null, availableFrom?: any | null, description?: string | null, price?: number | null, groundRent?: number | null, rates?: number | null, totalCost?: number | null, nuggetedAt?: any | null, minimumTerm?: number | null, minimumTermUnit: TermUnit, fitted: Fitted, updatedAt?: any | null, note?: Array<{ __typename?: 'Note', id: string, note: string } | null> | null, amenity: Array<{ __typename?: 'Amenity', id: string, name: string }>, featureImage?: { __typename?: 'Media', id: string, location: string } | null, floorplan: Array<{ __typename?: 'Media', id: string, title?: string | null, location: string }>, image: Array<{ __typename?: 'Media', id: string, title?: string | null, location: string }>, tour: Array<{ __typename?: 'Media', id: string, title?: string | null, location: string }>, updatedBy?: { __typename?: 'Broker', id: string, firstName?: string | null, lastName?: string | null } | null } | null };

export type UpdateOfficeMediaMutationVariables = Exact<{
  input?: InputMaybe<OfficeMediaToUpdateInput>;
}>;


export type UpdateOfficeMediaMutation = { __typename?: 'Mutation', updateOfficeMedia?: { __typename?: 'Office', id: string, name: string, image: Array<{ __typename?: 'Media', id: string, location: string, title?: string | null, filename?: string | null, type?: string | null, mimetype?: string | null, position?: number | null }>, floorplan: Array<{ __typename?: 'Media', id: string, location: string, title?: string | null, filename?: string | null, type?: string | null, mimetype?: string | null, position?: number | null }> } | null };

export type UpdatePropertyMutationVariables = Exact<{
  input?: InputMaybe<PropertyToUpdateInput>;
}>;


export type UpdatePropertyMutation = { __typename?: 'Mutation', updateProperty?: { __typename?: 'Property', id: string, name: string, isActive?: boolean | null, image: Array<{ __typename?: 'Media', id: string, location: string, title?: string | null, filename?: string | null, type?: string | null, mimetype?: string | null, position?: number | null }>, floorplan: Array<{ __typename?: 'Media', id: string, location: string, title?: string | null, filename?: string | null, type?: string | null, mimetype?: string | null, position?: number | null }> } | null };

export type UpdatePropertyMediaMutationVariables = Exact<{
  input?: InputMaybe<PropertyMediaToUpdateInput>;
}>;


export type UpdatePropertyMediaMutation = { __typename?: 'Mutation', updatePropertyMedia?: { __typename?: 'Property', id: string, name: string, isActive?: boolean | null, image: Array<{ __typename?: 'Media', id: string, location: string, title?: string | null, filename?: string | null, type?: string | null, mimetype?: string | null, position?: number | null }>, floorplan: Array<{ __typename?: 'Media', id: string, location: string, title?: string | null, filename?: string | null, type?: string | null, mimetype?: string | null, position?: number | null }> } | null };

export type UpdatePropertyScheduleOrderMutationVariables = Exact<{
  input?: InputMaybe<UpdatePropertyScheduleOrderInput>;
}>;


export type UpdatePropertyScheduleOrderMutation = { __typename?: 'Mutation', updatePropertyScheduleOrder?: Array<{ __typename?: 'ScheduleProperty', propertyId: string, position?: number | null } | null> | null };

export type UpdateScheduleOfficeMutationVariables = Exact<{
  input?: InputMaybe<ScheduleOfficeUpdateInput>;
}>;


export type UpdateScheduleOfficeMutation = { __typename?: 'Mutation', updateScheduleOffice?: { __typename?: 'ScheduleOffice', id: string, name: string, status: ScheduleOfficeStatus } | null };

export type BrokersQueryVariables = Exact<{ [key: string]: never; }>;


export type BrokersQuery = { __typename?: 'Query', brokers: Array<{ __typename?: 'Broker', id: string, externalRef?: string | null, firstName?: string | null, lastName?: string | null, email: string, phone?: string | null, isActive: boolean, role: Roles }> };

export type CreateBrokerMutationVariables = Exact<{
  input?: InputMaybe<BrokerToCreateInput>;
}>;


export type CreateBrokerMutation = { __typename?: 'Mutation', createBroker?: { __typename?: 'Broker', id: string, externalRef?: string | null, firstName?: string | null, lastName?: string | null, email: string, phone?: string | null, isActive: boolean, role: Roles } | null };

export type UpdateBrokerMutationVariables = Exact<{
  input?: InputMaybe<BrokerToUpdateInput>;
}>;


export type UpdateBrokerMutation = { __typename?: 'Mutation', updateBroker?: { __typename?: 'Broker', id: string, externalRef?: string | null, firstName?: string | null, lastName?: string | null, email: string, phone?: string | null, isActive: boolean, role: Roles } | null };

export type SingleBrokerFragment = { __typename?: 'Broker', id: string, externalRef?: string | null, firstName?: string | null, lastName?: string | null, email: string, phone?: string | null, isActive: boolean, role: Roles };

export type RegionsQueryVariables = Exact<{ [key: string]: never; }>;


export type RegionsQuery = { __typename?: 'Query', regions: Array<{ __typename?: 'Region', id: string, name: string, parentRegionId?: string | null, currency: { __typename?: 'Currency', id: string, code: string, symbol: string } }> };

export type CreateRegionMutationVariables = Exact<{
  input?: InputMaybe<RegionCreateInput>;
}>;


export type CreateRegionMutation = { __typename?: 'Mutation', createRegion?: { __typename?: 'Region', id: string, name: string, parentRegionId?: string | null, currency: { __typename?: 'Currency', id: string, code: string, symbol: string } } | null };

export type UpdateRegionMutationVariables = Exact<{
  input?: InputMaybe<RegionUpdateInput>;
}>;


export type UpdateRegionMutation = { __typename?: 'Mutation', updateRegion?: { __typename?: 'Region', id: string, name: string, parentRegionId?: string | null, currency: { __typename?: 'Currency', id: string, code: string, symbol: string } } | null };

export type RegionWithCurrencyFragment = { __typename?: 'Region', id: string, name: string, parentRegionId?: string | null, currency: { __typename?: 'Currency', id: string, code: string, symbol: string } };

export type RunScraperMutationVariables = Exact<{
  input?: InputMaybe<ScraperInput>;
}>;


export type RunScraperMutation = { __typename?: 'Mutation', runScraper?: { __typename?: 'IdsReturn', result?: string | null } | null };

export type CheckScraperMutationVariables = Exact<{
  id?: InputMaybe<Scalars['String']>;
}>;


export type CheckScraperMutation = { __typename?: 'Mutation', checkScraper?: { __typename?: 'ScraperReturn', progress?: number | null, completed?: string | null, limitReached?: boolean | null, result?: { __typename?: 'OfficeReturn', loggedIn?: string | null, returnOffice?: Array<{ __typename?: 'ItemsToReturn', name: string, address: string, lat: string, lng: string, images?: Array<string> | null, leaseType: PropertyType, description?: string | null, ameneties?: Array<string> | null, floorplan?: Array<{ __typename?: 'FloorplanDataToReturn', type: string, url: string }> | null, brouchure?: Array<{ __typename?: 'BrochureDataToReturn', url: string, name: string }> | null, offices?: Array<{ __typename?: 'ItemOfficeToReturn', name: string, sqft: string, rentSqft: string, ratesPay: string, service: string, estate: string, totalMonth: string, sqm: string, available: Availability, fitted: Fitted, property: string }> | null }> | null } | null } | null };

export type AddItemsToDatabaseMutationVariables = Exact<{
  input?: InputMaybe<ItemstoAdd>;
}>;


export type AddItemsToDatabaseMutation = { __typename?: 'Mutation', addItemsToDatabase?: { __typename?: 'AddItemsReturn', addItemsReturn?: Array<string> | null } | null };

export type DealQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type DealQuery = { __typename?: 'Query', deal?: { __typename?: 'DealOutput', deal: { __typename?: 'Deal', id: string, name: string, budget?: number | null, location?: string | null, locationNames: Array<string>, desks?: number | null, size?: number | null, sizeUnit: SizeUnit, providerRegion?: string | null, showProviderFilter?: boolean | null, showAvailableFrom?: boolean | null, showMatchingToggle?: boolean | null, canFavourite?: boolean | null, status: string, externalRef?: string | null, client: { __typename?: 'Client', id: string, name: string }, leadBroker: { __typename?: 'Broker', id: string, firstName?: string | null, lastName?: string | null, email: string, isActive: boolean }, secondaryBroker?: { __typename?: 'Broker', id: string, firstName?: string | null, lastName?: string | null, email: string } | null, contact: { __typename?: 'Contact', id: string, firstName?: string | null, lastName?: string | null, email?: string | null, phone?: string | null }, note: Array<{ __typename?: 'Note', id: string, subject?: string | null, note: string, type?: NoteType | null, sender?: string | null, recipient?: string | null, sentAt?: any | null, externalRef?: string | null, updatedAt: any, updatedBy: { __typename?: 'Broker', id: string, firstName?: string | null, lastName?: string | null } }>, amenity: Array<{ __typename?: 'Amenity', id: string, name: string }>, providerRegistration: Array<{ __typename?: 'ProviderRegistration', id: string, createdAt: any, status: RegistrationStatus, provider: { __typename?: 'Provider', id: string, name: string } }>, schedule: { __typename?: 'Schedule', id: string, scheduleOffice: Array<{ __typename?: 'ScheduleOffice', id: string, officeId: string, scheduleId: string, officeType: OfficeType, name: string, status: ScheduleOfficeStatus, statusDetail?: string | null, desks?: number | null, size?: number | null, sizeUnit: SizeUnit, floor?: number | null, availableFrom?: any | null, availableUntil?: any | null, leadTime?: number | null, leadTimeUnit?: LeadTimeUnit | null, description?: string | null, price?: number | null, groundRent?: number | null, rates?: number | null, totalCost?: number | null, estateCharge?: number | null, minimumTerm?: number | null, minimumTermUnit: TermUnit, rentFreePeriod?: number | null, rentFreePeriodUnit: TermUnit, nuggetedAt?: any | null, available: Availability, fitted: Fitted, updatedAt?: any | null, disposalComments?: string | null, instructedOffice?: boolean | null, property: { __typename?: 'Property', id: string, name: string, propertyType: PropertyType, region: { __typename?: 'Region', id: string, name: string, parentRegion?: { __typename?: 'Region', name: string } | null, currency: { __typename?: 'Currency', id: string } }, featureImage?: { __typename?: 'Media', id: string, location: string } | null, image: Array<{ __typename?: 'Media', id: string, title?: string | null, location: string }>, provider: { __typename?: 'Provider', id: string, name: string }, address: { __typename?: 'Address', id?: string | null, line1?: string | null, suburb?: string | null }, landmark: Array<{ __typename?: 'Landmark', name: string, type?: string | null, distance?: number | null, distanceText?: string | null }> }, linkedToOffice: Array<{ __typename?: 'ScheduleOffice', id: string, name: string, desks?: number | null, size?: number | null, sizeUnit: SizeUnit, totalCost?: number | null, minimumTerm?: number | null, minimumTermUnit: TermUnit, price?: number | null, groundRent?: number | null, rates?: number | null, floor?: number | null, status: ScheduleOfficeStatus, fitted: Fitted }>, linkedByOffice: Array<{ __typename?: 'ScheduleOffice', id: string, name: string, desks?: number | null, size?: number | null, sizeUnit: SizeUnit, totalCost?: number | null, minimumTerm?: number | null, minimumTermUnit: TermUnit, price?: number | null, groundRent?: number | null, rates?: number | null, floor?: number | null, status: ScheduleOfficeStatus, fitted: Fitted }>, note?: Array<{ __typename?: 'Note', id: string, note: string, updatedAt: any, updatedBy: { __typename?: 'Broker', id: string, firstName?: string | null, lastName?: string | null } } | null> | null, amenity: Array<{ __typename?: 'Amenity', id: string, name: string }>, featureImage?: { __typename?: 'Media', id: string, title?: string | null, location: string } | null, floorplan: Array<{ __typename?: 'Media', id: string, title?: string | null, location: string }>, image: Array<{ __typename?: 'Media', id: string, title?: string | null, location: string }>, tour: Array<{ __typename?: 'Media', id: string, title?: string | null, location: string }>, updatedBy?: { __typename?: 'Broker', firstName?: string | null, lastName?: string | null } | null }> } }, orderedProperties: Array<{ __typename?: 'ScheduleProperty', id: string, propertyId: string, position?: number | null }> } | null };

export type SelectedDealFragment = { __typename?: 'Deal', id: string, name: string, budget?: number | null, location?: string | null, locationNames: Array<string>, desks?: number | null, size?: number | null, sizeUnit: SizeUnit, providerRegion?: string | null, showProviderFilter?: boolean | null, showAvailableFrom?: boolean | null, showMatchingToggle?: boolean | null, canFavourite?: boolean | null, status: string, externalRef?: string | null, client: { __typename?: 'Client', id: string, name: string }, leadBroker: { __typename?: 'Broker', id: string, firstName?: string | null, lastName?: string | null, email: string, isActive: boolean }, secondaryBroker?: { __typename?: 'Broker', id: string, firstName?: string | null, lastName?: string | null, email: string } | null, contact: { __typename?: 'Contact', id: string, firstName?: string | null, lastName?: string | null, email?: string | null, phone?: string | null }, note: Array<{ __typename?: 'Note', id: string, subject?: string | null, note: string, type?: NoteType | null, sender?: string | null, recipient?: string | null, sentAt?: any | null, externalRef?: string | null, updatedAt: any, updatedBy: { __typename?: 'Broker', id: string, firstName?: string | null, lastName?: string | null } }>, amenity: Array<{ __typename?: 'Amenity', id: string, name: string }>, providerRegistration: Array<{ __typename?: 'ProviderRegistration', id: string, createdAt: any, status: RegistrationStatus, provider: { __typename?: 'Provider', id: string, name: string } }>, schedule: { __typename?: 'Schedule', id: string, scheduleOffice: Array<{ __typename?: 'ScheduleOffice', id: string, officeId: string, scheduleId: string, officeType: OfficeType, name: string, status: ScheduleOfficeStatus, statusDetail?: string | null, desks?: number | null, size?: number | null, sizeUnit: SizeUnit, floor?: number | null, availableFrom?: any | null, availableUntil?: any | null, leadTime?: number | null, leadTimeUnit?: LeadTimeUnit | null, description?: string | null, price?: number | null, groundRent?: number | null, rates?: number | null, totalCost?: number | null, estateCharge?: number | null, minimumTerm?: number | null, minimumTermUnit: TermUnit, rentFreePeriod?: number | null, rentFreePeriodUnit: TermUnit, nuggetedAt?: any | null, available: Availability, fitted: Fitted, updatedAt?: any | null, disposalComments?: string | null, instructedOffice?: boolean | null, property: { __typename?: 'Property', id: string, name: string, propertyType: PropertyType, region: { __typename?: 'Region', id: string, name: string, parentRegion?: { __typename?: 'Region', name: string } | null, currency: { __typename?: 'Currency', id: string } }, featureImage?: { __typename?: 'Media', id: string, location: string } | null, image: Array<{ __typename?: 'Media', id: string, title?: string | null, location: string }>, provider: { __typename?: 'Provider', id: string, name: string }, address: { __typename?: 'Address', id?: string | null, line1?: string | null, suburb?: string | null }, landmark: Array<{ __typename?: 'Landmark', name: string, type?: string | null, distance?: number | null, distanceText?: string | null }> }, linkedToOffice: Array<{ __typename?: 'ScheduleOffice', id: string, name: string, desks?: number | null, size?: number | null, sizeUnit: SizeUnit, totalCost?: number | null, minimumTerm?: number | null, minimumTermUnit: TermUnit, price?: number | null, groundRent?: number | null, rates?: number | null, floor?: number | null, status: ScheduleOfficeStatus, fitted: Fitted }>, linkedByOffice: Array<{ __typename?: 'ScheduleOffice', id: string, name: string, desks?: number | null, size?: number | null, sizeUnit: SizeUnit, totalCost?: number | null, minimumTerm?: number | null, minimumTermUnit: TermUnit, price?: number | null, groundRent?: number | null, rates?: number | null, floor?: number | null, status: ScheduleOfficeStatus, fitted: Fitted }>, note?: Array<{ __typename?: 'Note', id: string, note: string, updatedAt: any, updatedBy: { __typename?: 'Broker', id: string, firstName?: string | null, lastName?: string | null } } | null> | null, amenity: Array<{ __typename?: 'Amenity', id: string, name: string }>, featureImage?: { __typename?: 'Media', id: string, title?: string | null, location: string } | null, floorplan: Array<{ __typename?: 'Media', id: string, title?: string | null, location: string }>, image: Array<{ __typename?: 'Media', id: string, title?: string | null, location: string }>, tour: Array<{ __typename?: 'Media', id: string, title?: string | null, location: string }>, updatedBy?: { __typename?: 'Broker', firstName?: string | null, lastName?: string | null } | null }> } };

export type DealSchedulePropertyFragment = { __typename?: 'ScheduleProperty', id: string, propertyId: string, position?: number | null };

export type DealScheduleOfficeFragment = { __typename?: 'ScheduleOffice', id: string, officeId: string, scheduleId: string, officeType: OfficeType, name: string, status: ScheduleOfficeStatus, statusDetail?: string | null, desks?: number | null, size?: number | null, sizeUnit: SizeUnit, floor?: number | null, availableFrom?: any | null, availableUntil?: any | null, leadTime?: number | null, leadTimeUnit?: LeadTimeUnit | null, description?: string | null, price?: number | null, groundRent?: number | null, rates?: number | null, totalCost?: number | null, estateCharge?: number | null, minimumTerm?: number | null, minimumTermUnit: TermUnit, rentFreePeriod?: number | null, rentFreePeriodUnit: TermUnit, nuggetedAt?: any | null, available: Availability, fitted: Fitted, updatedAt?: any | null, disposalComments?: string | null, instructedOffice?: boolean | null, property: { __typename?: 'Property', id: string, name: string, propertyType: PropertyType, region: { __typename?: 'Region', id: string, name: string, parentRegion?: { __typename?: 'Region', name: string } | null, currency: { __typename?: 'Currency', id: string } }, featureImage?: { __typename?: 'Media', id: string, location: string } | null, image: Array<{ __typename?: 'Media', id: string, title?: string | null, location: string }>, provider: { __typename?: 'Provider', id: string, name: string }, address: { __typename?: 'Address', id?: string | null, line1?: string | null, suburb?: string | null }, landmark: Array<{ __typename?: 'Landmark', name: string, type?: string | null, distance?: number | null, distanceText?: string | null }> }, linkedToOffice: Array<{ __typename?: 'ScheduleOffice', id: string, name: string, desks?: number | null, size?: number | null, sizeUnit: SizeUnit, totalCost?: number | null, minimumTerm?: number | null, minimumTermUnit: TermUnit, price?: number | null, groundRent?: number | null, rates?: number | null, floor?: number | null, status: ScheduleOfficeStatus, fitted: Fitted }>, linkedByOffice: Array<{ __typename?: 'ScheduleOffice', id: string, name: string, desks?: number | null, size?: number | null, sizeUnit: SizeUnit, totalCost?: number | null, minimumTerm?: number | null, minimumTermUnit: TermUnit, price?: number | null, groundRent?: number | null, rates?: number | null, floor?: number | null, status: ScheduleOfficeStatus, fitted: Fitted }>, note?: Array<{ __typename?: 'Note', id: string, note: string, updatedAt: any, updatedBy: { __typename?: 'Broker', id: string, firstName?: string | null, lastName?: string | null } } | null> | null, amenity: Array<{ __typename?: 'Amenity', id: string, name: string }>, featureImage?: { __typename?: 'Media', id: string, title?: string | null, location: string } | null, floorplan: Array<{ __typename?: 'Media', id: string, title?: string | null, location: string }>, image: Array<{ __typename?: 'Media', id: string, title?: string | null, location: string }>, tour: Array<{ __typename?: 'Media', id: string, title?: string | null, location: string }>, updatedBy?: { __typename?: 'Broker', firstName?: string | null, lastName?: string | null } | null };

export type LinkedOfficeFragment = { __typename?: 'ScheduleOffice', id: string, name: string, desks?: number | null, size?: number | null, sizeUnit: SizeUnit, totalCost?: number | null, minimumTerm?: number | null, minimumTermUnit: TermUnit, price?: number | null, groundRent?: number | null, rates?: number | null, floor?: number | null, status: ScheduleOfficeStatus, fitted: Fitted };

export type DealScheduleOfficePropertyFragment = { __typename?: 'Property', id: string, name: string, propertyType: PropertyType, featureImage?: { __typename?: 'Media', id: string, location: string } | null, image: Array<{ __typename?: 'Media', id: string, title?: string | null, location: string }>, provider: { __typename?: 'Provider', id: string, name: string }, address: { __typename?: 'Address', id?: string | null, line1?: string | null, suburb?: string | null }, region: { __typename?: 'Region', id: string, name: string, currency: { __typename?: 'Currency', id: string } }, landmark: Array<{ __typename?: 'Landmark', name: string, type?: string | null, distance?: number | null, distanceText?: string | null }> };

export type UpdateProviderRegistrationMutationVariables = Exact<{
  input?: InputMaybe<ProviderRegistrationUpdate>;
}>;


export type UpdateProviderRegistrationMutation = { __typename?: 'Mutation', updateProviderRegistration?: { __typename?: 'ProviderRegistration', id: string, status: RegistrationStatus } | null };

export type SetScheduleOfficeStatusMutationVariables = Exact<{
  input?: InputMaybe<SetScheduleOfficeStatusInput>;
}>;


export type SetScheduleOfficeStatusMutation = { __typename?: 'Mutation', setScheduleOfficeStatus?: { __typename?: 'ScheduleOffice', id: string, status: ScheduleOfficeStatus } | null };

export type AddSecondaryBrokerMutationVariables = Exact<{
  input?: InputMaybe<BrokerToAddInput>;
}>;


export type AddSecondaryBrokerMutation = { __typename?: 'Mutation', addSecondaryBroker?: { __typename?: 'Deal', secondaryBroker?: { __typename?: 'Broker', id: string, externalRef?: string | null, firstName?: string | null, lastName?: string | null, email: string, phone?: string | null, isActive: boolean, role: Roles } | null } | null };

export type ToggleShowProviderFilterMutationVariables = Exact<{
  input?: InputMaybe<ToggleShowProviderFilterInput>;
}>;


export type ToggleShowProviderFilterMutation = { __typename?: 'Mutation', toggleShowProviderFilter?: { __typename?: 'Deal', showProviderFilter?: boolean | null } | null };

export type ToggleShowAvailableFromMutationVariables = Exact<{
  input?: InputMaybe<ToggleShowAvailableFromInput>;
}>;


export type ToggleShowAvailableFromMutation = { __typename?: 'Mutation', toggleShowAvailableFrom?: { __typename?: 'Deal', showAvailableFrom?: boolean | null } | null };

export type ToggleShowMatchingMutationVariables = Exact<{
  input?: InputMaybe<ToggleShowMatchingFromInput>;
}>;


export type ToggleShowMatchingMutation = { __typename?: 'Mutation', toggleShowMatching?: { __typename?: 'Deal', showMatchingToggle?: boolean | null } | null };

export type ToggleCanFavouriteMutationVariables = Exact<{
  input?: InputMaybe<ToggleCanFavouriteFromInput>;
}>;


export type ToggleCanFavouriteMutation = { __typename?: 'Mutation', toggleCanFavourite?: { __typename?: 'Deal', canFavourite?: boolean | null } | null };

export type DealsQueryVariables = Exact<{
  input?: InputMaybe<DealsInput>;
}>;


export type DealsQuery = { __typename?: 'Query', deals: { __typename?: 'DealListing', total: number, next: string, previous: string, data: Array<{ __typename?: 'Deal', id: string, name: string, desks?: number | null, size?: number | null, sizeUnit: SizeUnit, budget?: number | null, location?: string | null, status: string, client: { __typename?: 'Client', id: string, name: string }, leadBroker: { __typename?: 'Broker', id: string, firstName?: string | null, lastName?: string | null }, contact: { __typename?: 'Contact', id: string, firstName?: string | null, lastName?: string | null, email?: string | null } }> } };

export type OfficeSearchDataQueryVariables = Exact<{ [key: string]: never; }>;


export type OfficeSearchDataQuery = { __typename?: 'Query', officeSearchData?: { __typename?: 'OfficeSearchData', amenities: Array<{ __typename?: 'PartialAmenity', id: string, name: string }>, providers: Array<{ __typename?: 'PartialProvider', id: string, name: string }>, regions: Array<{ __typename?: 'PartialRegion', id: string, name: string, parentRegionId?: string | null }> } | null };

export type OfficeSearchPropertyQueryVariables = Exact<{
  filter?: InputMaybe<FindOfficePropertyFiltersInput>;
}>;


export type OfficeSearchPropertyQuery = { __typename?: 'Query', officeSearchProperty: { __typename?: 'OfficeSearchProperty', property?: { __typename?: 'Property', id: string, name: string, isActive?: boolean | null, description?: string | null, propertyType: PropertyType, serviceType: ServiceType, wholeBuildingOnly?: boolean | null, region: { __typename?: 'Region', id: string, name: string, currency: { __typename?: 'Currency', id: string } }, featureImage?: { __typename?: 'Media', id: string, type?: string | null, title?: string | null, location: string } | null, image: Array<{ __typename?: 'Media', id: string, type?: string | null, title?: string | null, location: string }>, address: { __typename?: 'Address', id?: string | null, line1?: string | null, line2?: string | null, city?: string | null, postcode?: string | null, latitude?: number | null, longitude?: number | null }, providerRegion: { __typename?: 'ProviderRegion', id: string, providerId?: string | null, region: { __typename?: 'Region', id: string, name: string } }, provider: { __typename?: 'Provider', id: string, name: string, isActive?: boolean | null, alwaysAvailable: boolean, logo?: { __typename?: 'Media', id: string, type?: string | null, title?: string | null, location: string } | null }, landmark: Array<{ __typename?: 'Landmark', id: string, name: string, type?: string | null, description?: string | null, distance?: number | null, duration?: number | null, distanceText?: string | null, durationText?: string | null, address?: { __typename?: 'Address', id?: string | null, latitude?: number | null, longitude?: number | null } | null }>, office: Array<{ __typename?: 'Office', id: string, propertyId: string, name: string, description?: string | null, desks?: number | null, size?: number | null, sizeUnit: SizeUnit, totalCost?: number | null, minimumTerm?: number | null, minimumTermUnit: TermUnit, leadTime?: number | null, leadTimeUnit?: LeadTimeUnit | null, officeType: OfficeType, floor?: number | null, price?: number | null, groundRent?: number | null, rates?: number | null, availableFrom?: any | null, availableUntil?: any | null, available: Availability, fitted: Fitted, nuggetedAt?: any | null, updatedAt?: any | null, property: { __typename?: 'Property', id: string, region: { __typename?: 'Region', id: string, name: string, currency: { __typename?: 'Currency', id: string } } } }> } | null } };

export type OfficeSearchPropertiesQueryVariables = Exact<{
  filter?: InputMaybe<FindOfficeFiltersInput>;
}>;


export type OfficeSearchPropertiesQuery = { __typename?: 'Query', officeSearchProperties: { __typename?: 'OfficeSearchProperties', properties: Array<{ __typename?: 'Property', id: string, name: string, filteredOfficeCount?: number | null, region: { __typename?: 'Region', id: string, name: string, currency: { __typename?: 'Currency', id: string } }, featureImage?: { __typename?: 'Media', id: string, type?: string | null, title?: string | null, location: string } | null, address: { __typename?: 'Address', id?: string | null, line1?: string | null, line2?: string | null, city?: string | null, postcode?: string | null, latitude?: number | null, longitude?: number | null }, provider: { __typename?: 'Provider', id: string, name: string, alwaysAvailable: boolean, logo?: { __typename?: 'Media', id: string, type?: string | null, title?: string | null, location: string } | null } }> } };

export type MapOfficeFragment = { __typename?: 'Office', id: string, propertyId: string, name: string, description?: string | null, desks?: number | null, size?: number | null, sizeUnit: SizeUnit, totalCost?: number | null, minimumTerm?: number | null, minimumTermUnit: TermUnit, leadTime?: number | null, leadTimeUnit?: LeadTimeUnit | null, officeType: OfficeType, floor?: number | null, price?: number | null, groundRent?: number | null, rates?: number | null, availableFrom?: any | null, availableUntil?: any | null, available: Availability, fitted: Fitted, nuggetedAt?: any | null, updatedAt?: any | null, property: { __typename?: 'Property', id: string, region: { __typename?: 'Region', id: string, name: string, currency: { __typename?: 'Currency', id: string } } } };

export type MapPropertiesFragment = { __typename?: 'Property', id: string, name: string, filteredOfficeCount?: number | null, region: { __typename?: 'Region', id: string, name: string, currency: { __typename?: 'Currency', id: string } }, featureImage?: { __typename?: 'Media', id: string, type?: string | null, title?: string | null, location: string } | null, address: { __typename?: 'Address', id?: string | null, line1?: string | null, line2?: string | null, city?: string | null, postcode?: string | null, latitude?: number | null, longitude?: number | null }, provider: { __typename?: 'Provider', id: string, name: string, alwaysAvailable: boolean, logo?: { __typename?: 'Media', id: string, type?: string | null, title?: string | null, location: string } | null } };

export type MapPropertyFragment = { __typename?: 'Property', id: string, name: string, isActive?: boolean | null, description?: string | null, propertyType: PropertyType, serviceType: ServiceType, wholeBuildingOnly?: boolean | null, region: { __typename?: 'Region', id: string, name: string, currency: { __typename?: 'Currency', id: string } }, featureImage?: { __typename?: 'Media', id: string, type?: string | null, title?: string | null, location: string } | null, image: Array<{ __typename?: 'Media', id: string, type?: string | null, title?: string | null, location: string }>, address: { __typename?: 'Address', id?: string | null, line1?: string | null, line2?: string | null, city?: string | null, postcode?: string | null, latitude?: number | null, longitude?: number | null }, providerRegion: { __typename?: 'ProviderRegion', id: string, providerId?: string | null, region: { __typename?: 'Region', id: string, name: string } }, provider: { __typename?: 'Provider', id: string, name: string, isActive?: boolean | null, alwaysAvailable: boolean, logo?: { __typename?: 'Media', id: string, type?: string | null, title?: string | null, location: string } | null }, landmark: Array<{ __typename?: 'Landmark', id: string, name: string, type?: string | null, description?: string | null, distance?: number | null, duration?: number | null, distanceText?: string | null, durationText?: string | null, address?: { __typename?: 'Address', id?: string | null, latitude?: number | null, longitude?: number | null } | null }>, office: Array<{ __typename?: 'Office', id: string, propertyId: string, name: string, description?: string | null, desks?: number | null, size?: number | null, sizeUnit: SizeUnit, totalCost?: number | null, minimumTerm?: number | null, minimumTermUnit: TermUnit, leadTime?: number | null, leadTimeUnit?: LeadTimeUnit | null, officeType: OfficeType, floor?: number | null, price?: number | null, groundRent?: number | null, rates?: number | null, availableFrom?: any | null, availableUntil?: any | null, available: Availability, fitted: Fitted, nuggetedAt?: any | null, updatedAt?: any | null, property: { __typename?: 'Property', id: string, region: { __typename?: 'Region', id: string, name: string, currency: { __typename?: 'Currency', id: string } } } }> };

export type ProviderQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type ProviderQuery = { __typename?: 'Query', provider?: { __typename?: 'Provider', id: string, name: string, website?: string | null, isActive?: boolean | null, description?: string | null, alwaysAvailable: boolean, headquarters?: string | null, contactCount?: number | null, propertyCount?: number | null, officeCount?: number | null, officeAvailableCount?: number | null, providerContact: Array<{ __typename?: 'ContactToProvider', contactType: ProviderContactType, contact: { __typename?: 'Contact', id: string, name?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null, phone?: string | null } }>, logo?: { __typename?: 'Media', id: string, location: string } | null, address?: { __typename?: 'Address', id?: string | null, line1?: string | null, line2?: string | null, suburb?: string | null, city?: string | null, county?: string | null, country?: string | null, postcode?: string | null, latitude?: number | null, longitude?: number | null } | null, providerRegion?: Array<{ __typename?: 'ProviderRegion', id: string, region: { __typename?: 'Region', id: string, name: string } }> | null, property?: Array<{ __typename?: 'Property', id: string, name: string, office: Array<{ __typename?: 'Office', id: string, available: Availability, updatedAt?: any | null }>, landmark: Array<{ __typename?: 'Landmark', name: string, type?: string | null, distance?: number | null, distanceText?: string | null }>, address: { __typename?: 'Address', id?: string | null, suburb?: string | null, line1?: string | null, city?: string | null }, featureImage?: { __typename?: 'Media', id: string, location: string } | null, image: Array<{ __typename?: 'Media', id: string, location: string, title?: string | null }>, providerRegion: { __typename?: 'ProviderRegion', id: string }, amenity: Array<{ __typename?: 'Amenity', id: string, name: string }>, region: { __typename?: 'Region', id: string, name: string } }> | null } | null };

export type SingleProviderFragment = { __typename?: 'Provider', id: string, name: string, website?: string | null, isActive?: boolean | null, description?: string | null, alwaysAvailable: boolean, headquarters?: string | null, contactCount?: number | null, propertyCount?: number | null, officeCount?: number | null, officeAvailableCount?: number | null, providerContact: Array<{ __typename?: 'ContactToProvider', contactType: ProviderContactType, contact: { __typename?: 'Contact', id: string, name?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null, phone?: string | null } }>, logo?: { __typename?: 'Media', id: string, location: string } | null, address?: { __typename?: 'Address', id?: string | null, line1?: string | null, line2?: string | null, suburb?: string | null, city?: string | null, county?: string | null, country?: string | null, postcode?: string | null, latitude?: number | null, longitude?: number | null } | null, providerRegion?: Array<{ __typename?: 'ProviderRegion', id: string, region: { __typename?: 'Region', id: string, name: string } }> | null, property?: Array<{ __typename?: 'Property', id: string, name: string, office: Array<{ __typename?: 'Office', id: string, available: Availability, updatedAt?: any | null }>, landmark: Array<{ __typename?: 'Landmark', name: string, type?: string | null, distance?: number | null, distanceText?: string | null }>, address: { __typename?: 'Address', id?: string | null, suburb?: string | null, line1?: string | null, city?: string | null }, featureImage?: { __typename?: 'Media', id: string, location: string } | null, image: Array<{ __typename?: 'Media', id: string, location: string, title?: string | null }>, providerRegion: { __typename?: 'ProviderRegion', id: string }, amenity: Array<{ __typename?: 'Amenity', id: string, name: string }>, region: { __typename?: 'Region', id: string, name: string } }> | null };

export type ProviderContactFragment = { __typename?: 'ContactToProvider', contactType: ProviderContactType, contact: { __typename?: 'Contact', id: string, name?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null, phone?: string | null } };

export type SingleContactFragment = { __typename?: 'Contact', id: string, name?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null, phone?: string | null };

export type ProviderPropertyFragment = { __typename?: 'Property', id: string, name: string, office: Array<{ __typename?: 'Office', id: string, available: Availability, updatedAt?: any | null }>, landmark: Array<{ __typename?: 'Landmark', name: string, type?: string | null, distance?: number | null, distanceText?: string | null }>, address: { __typename?: 'Address', id?: string | null, suburb?: string | null, line1?: string | null, city?: string | null }, featureImage?: { __typename?: 'Media', id: string, location: string } | null, image: Array<{ __typename?: 'Media', id: string, location: string, title?: string | null }>, providerRegion: { __typename?: 'ProviderRegion', id: string }, amenity: Array<{ __typename?: 'Amenity', id: string, name: string }>, region: { __typename?: 'Region', id: string, name: string } };

export type ProviderLogoFragment = { __typename?: 'Media', id: string, location: string };

export type UpdateProviderMutationVariables = Exact<{
  input?: InputMaybe<ProviderUpdateInput>;
}>;


export type UpdateProviderMutation = { __typename?: 'Mutation', updateProvider?: { __typename?: 'Provider', id: string, name: string, isActive?: boolean | null, website?: string | null, description?: string | null, headquarters?: string | null, logo?: { __typename?: 'Media', id: string, location: string } | null, address?: { __typename?: 'Address', id?: string | null, line1?: string | null, line2?: string | null, suburb?: string | null, city?: string | null, county?: string | null, country?: string | null, postcode?: string | null, latitude?: number | null, longitude?: number | null } | null, providerContact: Array<{ __typename?: 'ContactToProvider', contact: { __typename?: 'Contact', id: string, firstName?: string | null, lastName?: string | null, email?: string | null, phone?: string | null } }> } | null };

export type RemoveProviderRegionMutationVariables = Exact<{
  input?: InputMaybe<RemoveProviderRegionInput>;
}>;


export type RemoveProviderRegionMutation = { __typename?: 'Mutation', removeProviderRegion?: { __typename?: 'Provider', id: string, name: string, providerRegion?: Array<{ __typename?: 'ProviderRegion', id: string, region: { __typename?: 'Region', id: string, name: string } }> | null } | null };

export type AddProviderRegionMutationVariables = Exact<{
  input?: InputMaybe<AddProviderRegionInput>;
}>;


export type AddProviderRegionMutation = { __typename?: 'Mutation', addProviderRegion?: { __typename?: 'Provider', id: string, name: string, providerRegion?: Array<{ __typename?: 'ProviderRegion', id: string, region: { __typename?: 'Region', id: string, name: string } }> | null } | null };

export type AddProviderContactMutationVariables = Exact<{
  input?: InputMaybe<ProviderContactUpdateInput>;
}>;


export type AddProviderContactMutation = { __typename?: 'Mutation', addProviderContact?: { __typename?: 'ContactToProvider', contactId: string, providerId: string, contactType: ProviderContactType } | null };

export type UpdateProviderContactMutationVariables = Exact<{
  input?: InputMaybe<ProviderContactUpdateInput>;
}>;


export type UpdateProviderContactMutation = { __typename?: 'Mutation', updateProviderContact?: { __typename?: 'ContactToProvider', contactId: string, providerId: string, contactType: ProviderContactType } | null };

export type RemoveProviderContactMutationVariables = Exact<{
  input?: InputMaybe<ProviderContactUpdateInput>;
}>;


export type RemoveProviderContactMutation = { __typename?: 'Mutation', removeProviderContact?: { __typename?: 'ContactToProvider', contactId: string, providerId: string, contactType: ProviderContactType } | null };

export type ProviderContactStubFragment = { __typename?: 'ContactToProvider', contactId: string, providerId: string, contactType: ProviderContactType };

export type AvailablePropertyOfficeFragment = { __typename?: 'Office', id: string, name: string, description?: string | null, totalCost?: number | null, desks?: number | null, size?: number | null, sizeUnit: SizeUnit, floor?: number | null, price?: number | null, rates?: number | null, groundRent?: number | null, officeType: OfficeType, fitted: Fitted, available: Availability, instructedOffice: boolean, disposalComments?: string | null, amenity: Array<{ __typename?: 'Amenity', id: string, name: string }> };

export type AvailablePropertyFragment = { __typename?: 'Property', id: string, name: string, position?: number | null, description?: string | null, shortDescription?: string | null, propertyType: PropertyType, updatedAt?: any | null, wholeBuildingOnly?: boolean | null, region: { __typename?: 'Region', id: string, name: string, currency: { __typename?: 'Currency', id: string }, parentRegion?: { __typename?: 'Region', id: string, name: string } | null }, amenity: Array<{ __typename?: 'Amenity', id: string, name: string }>, featureImage?: { __typename?: 'Media', id: string, location: string, title?: string | null, filename?: string | null, type?: string | null, mimetype?: string | null, position?: number | null } | null, image: Array<{ __typename?: 'Media', id: string, location: string, title?: string | null, filename?: string | null, type?: string | null, mimetype?: string | null, position?: number | null }>, floorplan: Array<{ __typename?: 'Media', id: string, location: string, title?: string | null, filename?: string | null, type?: string | null, mimetype?: string | null, position?: number | null }>, tour: Array<{ __typename?: 'Media', id: string, location: string, title?: string | null, filename?: string | null, type?: string | null, mimetype?: string | null, position?: number | null }>, brochure: Array<{ __typename?: 'Media', id: string, location: string, title?: string | null, filename?: string | null, type?: string | null, mimetype?: string | null, position?: number | null }>, particular: Array<{ __typename?: 'Media', id: string, location: string, title?: string | null, filename?: string | null, type?: string | null, mimetype?: string | null, position?: number | null }>, address: { __typename?: 'Address', id?: string | null, line1?: string | null, line2?: string | null, city?: string | null, postcode?: string | null, latitude?: number | null, longitude?: number | null }, landmark: Array<{ __typename?: 'Landmark', name: string, distance?: number | null, distanceText?: string | null, type?: string | null, address?: { __typename?: 'Address', id?: string | null, latitude?: number | null, longitude?: number | null } | null }>, instruction?: { __typename?: 'Instruction', id: string, broker: Array<{ __typename?: 'Broker', id: string, firstName?: string | null, lastName?: string | null, email: string, phone?: string | null }> } | null, office: Array<{ __typename?: 'Office', id: string, name: string, description?: string | null, totalCost?: number | null, desks?: number | null, size?: number | null, sizeUnit: SizeUnit, floor?: number | null, price?: number | null, rates?: number | null, groundRent?: number | null, officeType: OfficeType, fitted: Fitted, available: Availability, instructedOffice: boolean, disposalComments?: string | null, amenity: Array<{ __typename?: 'Amenity', id: string, name: string }> }> };

export type AvailablePropertiesQueryVariables = Exact<{
  filter?: InputMaybe<FindOfficeFiltersInput>;
}>;


export type AvailablePropertiesQuery = { __typename?: 'Query', availableProperties: Array<{ __typename?: 'Property', id: string, name: string, position?: number | null, description?: string | null, shortDescription?: string | null, propertyType: PropertyType, updatedAt?: any | null, wholeBuildingOnly?: boolean | null, region: { __typename?: 'Region', id: string, name: string, currency: { __typename?: 'Currency', id: string }, parentRegion?: { __typename?: 'Region', id: string, name: string } | null }, amenity: Array<{ __typename?: 'Amenity', id: string, name: string }>, featureImage?: { __typename?: 'Media', id: string, location: string, title?: string | null, filename?: string | null, type?: string | null, mimetype?: string | null, position?: number | null } | null, image: Array<{ __typename?: 'Media', id: string, location: string, title?: string | null, filename?: string | null, type?: string | null, mimetype?: string | null, position?: number | null }>, floorplan: Array<{ __typename?: 'Media', id: string, location: string, title?: string | null, filename?: string | null, type?: string | null, mimetype?: string | null, position?: number | null }>, tour: Array<{ __typename?: 'Media', id: string, location: string, title?: string | null, filename?: string | null, type?: string | null, mimetype?: string | null, position?: number | null }>, brochure: Array<{ __typename?: 'Media', id: string, location: string, title?: string | null, filename?: string | null, type?: string | null, mimetype?: string | null, position?: number | null }>, particular: Array<{ __typename?: 'Media', id: string, location: string, title?: string | null, filename?: string | null, type?: string | null, mimetype?: string | null, position?: number | null }>, address: { __typename?: 'Address', id?: string | null, line1?: string | null, line2?: string | null, city?: string | null, postcode?: string | null, latitude?: number | null, longitude?: number | null }, landmark: Array<{ __typename?: 'Landmark', name: string, distance?: number | null, distanceText?: string | null, type?: string | null, address?: { __typename?: 'Address', id?: string | null, latitude?: number | null, longitude?: number | null } | null }>, instruction?: { __typename?: 'Instruction', id: string, broker: Array<{ __typename?: 'Broker', id: string, firstName?: string | null, lastName?: string | null, email: string, phone?: string | null }> } | null, office: Array<{ __typename?: 'Office', id: string, name: string, description?: string | null, totalCost?: number | null, desks?: number | null, size?: number | null, sizeUnit: SizeUnit, floor?: number | null, price?: number | null, rates?: number | null, groundRent?: number | null, officeType: OfficeType, fitted: Fitted, available: Availability, instructedOffice: boolean, disposalComments?: string | null, amenity: Array<{ __typename?: 'Amenity', id: string, name: string }> }> }> };

export type AvailablePropertyQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type AvailablePropertyQuery = { __typename?: 'Query', availableProperty?: { __typename?: 'Property', id: string, name: string, position?: number | null, description?: string | null, shortDescription?: string | null, propertyType: PropertyType, updatedAt?: any | null, wholeBuildingOnly?: boolean | null, region: { __typename?: 'Region', id: string, name: string, currency: { __typename?: 'Currency', id: string }, parentRegion?: { __typename?: 'Region', id: string, name: string } | null }, amenity: Array<{ __typename?: 'Amenity', id: string, name: string }>, featureImage?: { __typename?: 'Media', id: string, location: string, title?: string | null, filename?: string | null, type?: string | null, mimetype?: string | null, position?: number | null } | null, image: Array<{ __typename?: 'Media', id: string, location: string, title?: string | null, filename?: string | null, type?: string | null, mimetype?: string | null, position?: number | null }>, floorplan: Array<{ __typename?: 'Media', id: string, location: string, title?: string | null, filename?: string | null, type?: string | null, mimetype?: string | null, position?: number | null }>, tour: Array<{ __typename?: 'Media', id: string, location: string, title?: string | null, filename?: string | null, type?: string | null, mimetype?: string | null, position?: number | null }>, brochure: Array<{ __typename?: 'Media', id: string, location: string, title?: string | null, filename?: string | null, type?: string | null, mimetype?: string | null, position?: number | null }>, particular: Array<{ __typename?: 'Media', id: string, location: string, title?: string | null, filename?: string | null, type?: string | null, mimetype?: string | null, position?: number | null }>, address: { __typename?: 'Address', id?: string | null, line1?: string | null, line2?: string | null, city?: string | null, postcode?: string | null, latitude?: number | null, longitude?: number | null }, landmark: Array<{ __typename?: 'Landmark', name: string, distance?: number | null, distanceText?: string | null, type?: string | null, address?: { __typename?: 'Address', id?: string | null, latitude?: number | null, longitude?: number | null } | null }>, instruction?: { __typename?: 'Instruction', id: string, broker: Array<{ __typename?: 'Broker', id: string, firstName?: string | null, lastName?: string | null, email: string, phone?: string | null }> } | null, office: Array<{ __typename?: 'Office', id: string, name: string, description?: string | null, totalCost?: number | null, desks?: number | null, size?: number | null, sizeUnit: SizeUnit, floor?: number | null, price?: number | null, rates?: number | null, groundRent?: number | null, officeType: OfficeType, fitted: Fitted, available: Availability, instructedOffice: boolean, disposalComments?: string | null, amenity: Array<{ __typename?: 'Amenity', id: string, name: string }> }> } | null };

export const PlaceItemFragmentDoc = gql`
    fragment PlaceItem on Place {
  placeId
  name
  lat
  lng
  distance
  duration
  distanceText
  durationText
}
    `;
export const NearbyPlaceItemFragmentDoc = gql`
    fragment NearbyPlaceItem on NearbyPlaces {
  placeId
  name
  lat
  lng
  distance
  duration
  distanceText
  durationText
  position
}
    `;
export const RegionItemFragmentDoc = gql`
    fragment RegionItem on Region {
  id
  name
  parentRegionId
}
    `;
export const CreateDataRegionFragmentDoc = gql`
    fragment CreateDataRegion on RegionItem {
  id
  name
  parentRegionId
}
    `;
export const UploadedMediaFragmentDoc = gql`
    fragment UploadedMedia on Media {
  id
  title
  type
  location
  filename
  mimetype
  encoding
}
    `;
export const MediaItemFragmentDoc = gql`
    fragment MediaItem on Media {
  id
  location
  title
  filename
  type
  mimetype
  position
}
    `;
export const OfficesOfficeFragmentDoc = gql`
    fragment OfficesOffice on Office {
  id
  officeType
  name
  desks
  size
  sizeUnit
  floor
  availableFrom
  availableUntil
  leadTime
  leadTimeUnit
  description
  price
  groundRent
  rates
  totalCost
  estateCharge
  nuggetedAt
  minimumTerm
  minimumTermUnit
  nuggetedAt
  available
  fitted
  note {
    id
    note
    updatedAt
    updatedBy {
      id
      firstName
      lastName
    }
  }
  amenity {
    id
    name
  }
  featureImage {
    ...MediaItem
  }
  floorplan {
    ...MediaItem
  }
  image {
    ...MediaItem
  }
  tour {
    ...MediaItem
  }
  updatedAt
  updatedBy {
    firstName
    lastName
  }
  property {
    id
    name
    propertyType
    region {
      id
      name
      currency {
        id
        name
      }
    }
    provider {
      id
      name
    }
    propertyType
  }
}
    ${MediaItemFragmentDoc}`;
export const DealListFragmentDoc = gql`
    fragment DealList on Deal {
  id
  name
  createdAt
  schedule {
    id
  }
  leadBroker {
    id
    firstName
    lastName
  }
}
    `;
export const ProviderRegisterDataProviderFragmentDoc = gql`
    fragment ProviderRegisterDataProvider on PartialProvider {
  id
  name
  providerRegion {
    id
    regionId
    region {
      id
      name
    }
  }
}
    `;
export const NotificationFragmentDoc = gql`
    fragment Notification on Notification {
  id
  createdAt
  subject
  message
  recipient {
    id
    firstName
    lastName
    email
  }
  readAt
}
    `;
export const PropertyLandmarkFragmentDoc = gql`
    fragment PropertyLandmark on Landmark {
  name
  distance
  distanceText
  type
  address {
    id
    latitude
    longitude
  }
}
    `;
export const PropertyNoteFragmentDoc = gql`
    fragment PropertyNote on Note {
  id
  subject
  note
  type
  sender
  recipient
  sentAt
  externalRef
  updatedAt
  updatedBy {
    id
    firstName
    lastName
  }
}
    `;
export const PropertyOfficeFragmentDoc = gql`
    fragment PropertyOffice on Office {
  id
  officeType
  name
  desks
  size
  sizeUnit
  floor
  availableFrom
  availableUntil
  leadTime
  leadTimeUnit
  description
  price
  groundRent
  rates
  totalCost
  estateCharge
  minimumTerm
  minimumTermUnit
  nuggetedAt
  available
  fitted
  property {
    id
    region {
      id
      name
      currency {
        id
        symbol
      }
      parentRegion {
        id
        name
      }
    }
  }
  note {
    ...PropertyNote
  }
  amenity {
    id
    name
  }
  featureImage {
    ...MediaItem
  }
  floorplan {
    ...MediaItem
  }
  image {
    ...MediaItem
  }
  tour {
    ...MediaItem
  }
  updatedAt
  updatedBy {
    firstName
    lastName
  }
  disposalComments
  instructedOffice
}
    ${PropertyNoteFragmentDoc}
${MediaItemFragmentDoc}`;
export const SinglePropertyFragmentDoc = gql`
    fragment SingleProperty on Property {
  id
  name
  description
  shortDescription
  isActive
  region {
    id
    name
    currency {
      id
      symbol
    }
  }
  propertyType
  serviceType
  landmark {
    ...PropertyLandmark
  }
  amenity {
    id
    name
  }
  provider {
    id
    name
    logo {
      id
      location
    }
    defaultOfficeType
  }
  contact {
    id
    firstName
    lastName
    email
    phone
  }
  address {
    id
    name
    line1
    line2
    suburb
    city
    county
    country
    postcode
    latitude
    longitude
  }
  featureImage {
    id
    location
  }
  image {
    ...MediaItem
  }
  floorplan {
    ...MediaItem
  }
  tour {
    ...MediaItem
  }
  brochure {
    ...MediaItem
  }
  particular {
    ...MediaItem
  }
  note {
    ...PropertyNote
  }
  providerRegion {
    id
    region {
      id
      name
    }
  }
  office {
    ...PropertyOffice
  }
  wholeBuildingOnly
  instruction {
    id
    broker {
      id
      firstName
      lastName
      email
    }
  }
}
    ${PropertyLandmarkFragmentDoc}
${MediaItemFragmentDoc}
${PropertyNoteFragmentDoc}
${PropertyOfficeFragmentDoc}`;
export const ClientDealDealFragmentDoc = gql`
    fragment ClientDealDeal on Deal {
  id
  name
  showProviderFilter
  showAvailableFrom
  showMatchingToggle
  canFavourite
  client {
    name
  }
  schedule {
    id
    favouritesSent
  }
  contact {
    id
    firstName
    lastName
  }
  currentAddress {
    id
    line1
    latitude
    longitude
  }
}
    `;
export const ClientDealBrokerFragmentDoc = gql`
    fragment ClientDealBroker on Broker {
  id
  firstName
  lastName
  email
  phone
  bookingLink
  brokerImage {
    ...MediaItem
  }
}
    ${MediaItemFragmentDoc}`;
export const LinkedOfficeFragmentDoc = gql`
    fragment LinkedOffice on ScheduleOffice {
  id
  name
  desks
  size
  sizeUnit
  totalCost
  minimumTerm
  minimumTermUnit
  price
  groundRent
  rates
  floor
  status
  fitted
}
    `;
export const ClientDealOfficeFragmentDoc = gql`
    fragment ClientDealOffice on ScheduleOffice {
  id
  name
  description
  totalCost
  desks
  size
  sizeUnit
  floor
  price
  groundRent
  estateCharge
  linkedToOffice {
    ...LinkedOffice
  }
  linkedByOffice {
    ...LinkedOffice
  }
  rates
  availableFrom
  availableUntil
  available
  leadTime
  leadTimeUnit
  minimumTerm
  minimumTermUnit
  rentFreePeriod
  rentFreePeriodUnit
  officeType
  status
  fitted
  createdAt
  property {
    id
    region {
      id
      name
      currency {
        id
      }
      parentRegion {
        id
        name
      }
    }
  }
  amenity {
    id
    name
  }
  note {
    id
    note
    createdBy {
      id
      firstName
      lastName
      brokerImage {
        id
        location
      }
    }
  }
  featureImage {
    ...MediaItem
  }
  image {
    ...MediaItem
  }
  floorplan {
    ...MediaItem
  }
  tour {
    ...MediaItem
  }
}
    ${LinkedOfficeFragmentDoc}
${MediaItemFragmentDoc}`;
export const ClientDealLandmarkFragmentDoc = gql`
    fragment ClientDealLandmark on Landmark {
  id
  type
  name
  distance
  distanceText
  durationText
}
    `;
export const ClientDealPropertyFragmentDoc = gql`
    fragment ClientDealProperty on Property {
  id
  name
  position
  region {
    id
    name
    currency {
      id
    }
    parentRegion {
      id
      name
    }
  }
  description
  propertyType
  provider {
    id
    name
  }
  amenity {
    id
    name
  }
  featureImage {
    ...MediaItem
  }
  image {
    ...MediaItem
  }
  floorplan {
    ...MediaItem
  }
  tour {
    ...MediaItem
  }
  brochure {
    ...MediaItem
  }
  address {
    id
    name
    line1
    suburb
    city
    county
    postcode
    latitude
    longitude
  }
  scheduleOffice {
    ...ClientDealOffice
  }
  landmark {
    ...ClientDealLandmark
  }
  wholeBuildingOnly
}
    ${MediaItemFragmentDoc}
${ClientDealOfficeFragmentDoc}
${ClientDealLandmarkFragmentDoc}`;
export const ClientDealOtherPropertyFragmentDoc = gql`
    fragment ClientDealOtherProperty on OtherProperty {
  id
  name
  region {
    id
    name
    currency {
      id
    }
    parentRegion {
      id
      name
    }
  }
  featureImage {
    ...MediaItem
  }
  address {
    id
    latitude
    longitude
  }
  hasAvailableOffices
}
    ${MediaItemFragmentDoc}`;
export const ConnectedDealsListFragmentDoc = gql`
    fragment connectedDealsList on Deal {
  id
  name
  createdAt
  schedule {
    id
  }
  leadBroker {
    id
    firstName
    lastName
  }
}
    `;
export const SingleCurrencyFragmentDoc = gql`
    fragment SingleCurrency on Currency {
  id
  name
  code
  symbol
}
    `;
export const ScheduleOfficeFragmentDoc = gql`
    fragment ScheduleOffice on ScheduleOffice {
  id
  officeType
  name
  desks
  size
  sizeUnit
  floor
  availableFrom
  leadTime
  leadTimeUnit
  description
  price
  groundRent
  rates
  totalCost
  nuggetedAt
  minimumTerm
  minimumTermUnit
  nuggetedAt
  available
  fitted
  property {
    id
    region {
      id
      name
      currency {
        id
      }
    }
  }
  featureImage {
    ...MediaItem
  }
  amenity {
    id
    name
  }
  floorplan {
    ...MediaItem
  }
  image {
    ...MediaItem
  }
  tour {
    ...MediaItem
  }
  schedule {
    dealId
  }
}
    ${MediaItemFragmentDoc}`;
export const SingleBrokerFragmentDoc = gql`
    fragment SingleBroker on Broker {
  id
  externalRef
  firstName
  lastName
  email
  phone
  isActive
  role
}
    `;
export const RegionWithCurrencyFragmentDoc = gql`
    fragment RegionWithCurrency on Region {
  id
  name
  currency {
    id
    code
    symbol
  }
  parentRegionId
}
    `;
export const DealScheduleOfficePropertyFragmentDoc = gql`
    fragment DealScheduleOfficeProperty on Property {
  id
  name
  propertyType
  featureImage {
    id
    location
  }
  image {
    id
    title
    location
  }
  provider {
    id
    name
  }
  address {
    id
    line1
    suburb
  }
  region {
    id
    name
    currency {
      id
    }
  }
  landmark {
    name
    type
    distance
    distanceText
  }
}
    `;
export const DealScheduleOfficeFragmentDoc = gql`
    fragment DealScheduleOffice on ScheduleOffice {
  id
  officeId
  scheduleId
  property {
    ...DealScheduleOfficeProperty
  }
  officeType
  name
  status
  statusDetail
  desks
  size
  sizeUnit
  floor
  availableFrom
  availableUntil
  leadTime
  leadTimeUnit
  description
  price
  groundRent
  rates
  totalCost
  estateCharge
  minimumTerm
  minimumTermUnit
  rentFreePeriod
  rentFreePeriodUnit
  nuggetedAt
  available
  fitted
  property {
    region {
      id
      name
      parentRegion {
        name
      }
    }
  }
  linkedToOffice {
    ...LinkedOffice
  }
  linkedByOffice {
    ...LinkedOffice
  }
  note {
    id
    note
    updatedAt
    updatedBy {
      id
      firstName
      lastName
    }
  }
  amenity {
    id
    name
  }
  featureImage {
    id
    title
    location
  }
  floorplan {
    id
    title
    location
  }
  image {
    id
    title
    location
  }
  tour {
    id
    title
    location
  }
  updatedAt
  updatedBy {
    firstName
    lastName
  }
  disposalComments
  instructedOffice
}
    ${DealScheduleOfficePropertyFragmentDoc}
${LinkedOfficeFragmentDoc}`;
export const SelectedDealFragmentDoc = gql`
    fragment SelectedDeal on Deal {
  id
  name
  budget
  location
  locationNames
  desks
  size
  sizeUnit
  providerRegion
  showProviderFilter
  showAvailableFrom
  showMatchingToggle
  canFavourite
  status
  externalRef
  client {
    id
    name
  }
  leadBroker {
    id
    firstName
    lastName
    email
    isActive
  }
  secondaryBroker {
    id
    firstName
    lastName
    email
  }
  contact {
    id
    firstName
    lastName
    email
    phone
  }
  note {
    ...PropertyNote
  }
  amenity {
    id
    name
  }
  providerRegistration {
    id
    createdAt
    provider {
      id
      name
    }
    status
  }
  schedule {
    id
    scheduleOffice {
      ...DealScheduleOffice
    }
  }
}
    ${PropertyNoteFragmentDoc}
${DealScheduleOfficeFragmentDoc}`;
export const DealSchedulePropertyFragmentDoc = gql`
    fragment DealScheduleProperty on ScheduleProperty {
  id
  propertyId
  position
}
    `;
export const MapPropertiesFragmentDoc = gql`
    fragment MapProperties on Property {
  id
  name
  region {
    id
    name
    currency {
      id
    }
  }
  filteredOfficeCount
  featureImage {
    id
    type
    title
    location
  }
  address {
    id
    line1
    line2
    city
    postcode
    latitude
    longitude
  }
  provider {
    id
    name
    alwaysAvailable
    logo {
      id
      type
      title
      location
    }
  }
}
    `;
export const MapOfficeFragmentDoc = gql`
    fragment MapOffice on Office {
  id
  propertyId
  name
  description
  desks
  size
  sizeUnit
  totalCost
  minimumTerm
  minimumTermUnit
  leadTime
  leadTimeUnit
  officeType
  floor
  price
  groundRent
  rates
  availableFrom
  availableUntil
  available
  fitted
  nuggetedAt
  updatedAt
  property {
    id
    region {
      id
      name
      currency {
        id
      }
    }
  }
}
    `;
export const MapPropertyFragmentDoc = gql`
    fragment MapProperty on Property {
  id
  name
  isActive
  description
  propertyType
  serviceType
  region {
    id
    name
    currency {
      id
    }
  }
  featureImage {
    id
    type
    title
    location
  }
  image {
    id
    type
    title
    location
  }
  address {
    id
    line1
    line2
    city
    postcode
    latitude
    longitude
  }
  providerRegion {
    id
    region {
      id
      name
    }
    providerId
  }
  provider {
    id
    name
    isActive
    alwaysAvailable
    logo {
      id
      type
      title
      location
    }
  }
  landmark {
    id
    address {
      id
      latitude
      longitude
    }
    name
    type
    description
    distance
    duration
    distanceText
    durationText
  }
  office {
    ...MapOffice
  }
  wholeBuildingOnly
}
    ${MapOfficeFragmentDoc}`;
export const SingleContactFragmentDoc = gql`
    fragment SingleContact on Contact {
  id
  name
  firstName
  lastName
  email
  phone
}
    `;
export const ProviderContactFragmentDoc = gql`
    fragment ProviderContact on ContactToProvider {
  contactType
  contact {
    ...SingleContact
  }
}
    ${SingleContactFragmentDoc}`;
export const ProviderLogoFragmentDoc = gql`
    fragment ProviderLogo on Media {
  id
  location
}
    `;
export const ProviderPropertyFragmentDoc = gql`
    fragment ProviderProperty on Property {
  id
  name
  office {
    id
    available
    updatedAt
  }
  landmark {
    name
    type
    distance
    distanceText
  }
  address {
    id
    suburb
    line1
    city
  }
  featureImage {
    id
    location
  }
  image {
    id
    location
    title
  }
  providerRegion {
    id
  }
  amenity {
    id
    name
  }
  region {
    id
    name
  }
}
    `;
export const SingleProviderFragmentDoc = gql`
    fragment SingleProvider on Provider {
  id
  name
  website
  isActive
  description
  alwaysAvailable
  headquarters
  contactCount
  propertyCount
  officeCount
  officeAvailableCount
  providerContact {
    ...ProviderContact
  }
  logo {
    ...ProviderLogo
  }
  address {
    id
    line1
    line2
    suburb
    city
    county
    country
    postcode
    latitude
    longitude
  }
  providerRegion {
    id
    region {
      id
      name
    }
  }
  property {
    ...ProviderProperty
  }
}
    ${ProviderContactFragmentDoc}
${ProviderLogoFragmentDoc}
${ProviderPropertyFragmentDoc}`;
export const ProviderContactStubFragmentDoc = gql`
    fragment ProviderContactStub on ContactToProvider {
  contactId
  providerId
  contactType
}
    `;
export const AvailablePropertyOfficeFragmentDoc = gql`
    fragment AvailablePropertyOffice on Office {
  id
  name
  description
  totalCost
  desks
  size
  sizeUnit
  floor
  price
  rates
  groundRent
  officeType
  fitted
  available
  instructedOffice
  amenity {
    id
    name
  }
  disposalComments
}
    `;
export const AvailablePropertyFragmentDoc = gql`
    fragment AvailableProperty on Property {
  id
  name
  position
  region {
    id
    name
    currency {
      id
    }
    parentRegion {
      id
      name
    }
  }
  description
  shortDescription
  propertyType
  amenity {
    id
    name
  }
  featureImage {
    ...MediaItem
  }
  image {
    ...MediaItem
  }
  floorplan {
    ...MediaItem
  }
  tour {
    ...MediaItem
  }
  brochure {
    ...MediaItem
  }
  particular {
    ...MediaItem
  }
  address {
    id
    line1
    line2
    city
    postcode
    latitude
    longitude
  }
  landmark {
    ...PropertyLandmark
  }
  instruction {
    id
    broker {
      id
      firstName
      lastName
      email
      phone
    }
  }
  office {
    ...AvailablePropertyOffice
  }
  updatedAt
  wholeBuildingOnly
}
    ${MediaItemFragmentDoc}
${PropertyLandmarkFragmentDoc}
${AvailablePropertyOfficeFragmentDoc}`;
export const ContactsDocument = gql`
    query contacts {
  contacts {
    ...SingleContact
  }
}
    ${SingleContactFragmentDoc}`;

/**
 * __useContactsQuery__
 *
 * To run a query within a React component, call `useContactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactsQuery({
 *   variables: {
 *   },
 * });
 */
export function useContactsQuery(baseOptions?: Apollo.QueryHookOptions<ContactsQuery, ContactsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContactsQuery, ContactsQueryVariables>(ContactsDocument, options);
      }
export function useContactsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContactsQuery, ContactsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContactsQuery, ContactsQueryVariables>(ContactsDocument, options);
        }
export type ContactsQueryHookResult = ReturnType<typeof useContactsQuery>;
export type ContactsLazyQueryHookResult = ReturnType<typeof useContactsLazyQuery>;
export type ContactsQueryResult = Apollo.QueryResult<ContactsQuery, ContactsQueryVariables>;
export const PropertyCreateDataDocument = gql`
    query propertyCreateData {
  propertyCreateData {
    providers {
      id
      name
      providerRegion {
        id
        region {
          id
          name
        }
      }
    }
    contacts {
      id
      firstName
      lastName
      email
    }
  }
}
    `;

/**
 * __usePropertyCreateDataQuery__
 *
 * To run a query within a React component, call `usePropertyCreateDataQuery` and pass it any options that fit your needs.
 * When your component renders, `usePropertyCreateDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePropertyCreateDataQuery({
 *   variables: {
 *   },
 * });
 */
export function usePropertyCreateDataQuery(baseOptions?: Apollo.QueryHookOptions<PropertyCreateDataQuery, PropertyCreateDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PropertyCreateDataQuery, PropertyCreateDataQueryVariables>(PropertyCreateDataDocument, options);
      }
export function usePropertyCreateDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PropertyCreateDataQuery, PropertyCreateDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PropertyCreateDataQuery, PropertyCreateDataQueryVariables>(PropertyCreateDataDocument, options);
        }
export type PropertyCreateDataQueryHookResult = ReturnType<typeof usePropertyCreateDataQuery>;
export type PropertyCreateDataLazyQueryHookResult = ReturnType<typeof usePropertyCreateDataLazyQuery>;
export type PropertyCreateDataQueryResult = Apollo.QueryResult<PropertyCreateDataQuery, PropertyCreateDataQueryVariables>;
export const CreatePropertyDocument = gql`
    mutation createProperty($input: PropertyToCreateInput) {
  createProperty(input: $input) {
    id
    name
  }
}
    `;
export type CreatePropertyMutationFn = Apollo.MutationFunction<CreatePropertyMutation, CreatePropertyMutationVariables>;

/**
 * __useCreatePropertyMutation__
 *
 * To run a mutation, you first call `useCreatePropertyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePropertyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPropertyMutation, { data, loading, error }] = useCreatePropertyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePropertyMutation(baseOptions?: Apollo.MutationHookOptions<CreatePropertyMutation, CreatePropertyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePropertyMutation, CreatePropertyMutationVariables>(CreatePropertyDocument, options);
      }
export type CreatePropertyMutationHookResult = ReturnType<typeof useCreatePropertyMutation>;
export type CreatePropertyMutationResult = Apollo.MutationResult<CreatePropertyMutation>;
export type CreatePropertyMutationOptions = Apollo.BaseMutationOptions<CreatePropertyMutation, CreatePropertyMutationVariables>;
export const PlacesDocument = gql`
    query places($input: placeInput) {
  places(input: $input) {
    ...PlaceItem
  }
}
    ${PlaceItemFragmentDoc}`;

/**
 * __usePlacesQuery__
 *
 * To run a query within a React component, call `usePlacesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlacesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlacesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePlacesQuery(baseOptions?: Apollo.QueryHookOptions<PlacesQuery, PlacesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlacesQuery, PlacesQueryVariables>(PlacesDocument, options);
      }
export function usePlacesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PlacesQuery, PlacesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlacesQuery, PlacesQueryVariables>(PlacesDocument, options);
        }
export type PlacesQueryHookResult = ReturnType<typeof usePlacesQuery>;
export type PlacesLazyQueryHookResult = ReturnType<typeof usePlacesLazyQuery>;
export type PlacesQueryResult = Apollo.QueryResult<PlacesQuery, PlacesQueryVariables>;
export const NearbyPlacesDocument = gql`
    query nearbyPlaces($input: placeInput) {
  nearbyPlaces(input: $input) {
    ...NearbyPlaceItem
  }
}
    ${NearbyPlaceItemFragmentDoc}`;

/**
 * __useNearbyPlacesQuery__
 *
 * To run a query within a React component, call `useNearbyPlacesQuery` and pass it any options that fit your needs.
 * When your component renders, `useNearbyPlacesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNearbyPlacesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useNearbyPlacesQuery(baseOptions?: Apollo.QueryHookOptions<NearbyPlacesQuery, NearbyPlacesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NearbyPlacesQuery, NearbyPlacesQueryVariables>(NearbyPlacesDocument, options);
      }
export function useNearbyPlacesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NearbyPlacesQuery, NearbyPlacesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NearbyPlacesQuery, NearbyPlacesQueryVariables>(NearbyPlacesDocument, options);
        }
export type NearbyPlacesQueryHookResult = ReturnType<typeof useNearbyPlacesQuery>;
export type NearbyPlacesLazyQueryHookResult = ReturnType<typeof useNearbyPlacesLazyQuery>;
export type NearbyPlacesQueryResult = Apollo.QueryResult<NearbyPlacesQuery, NearbyPlacesQueryVariables>;
export const ProviderRegionsDocument = gql`
    query providerRegions {
  regions {
    ...RegionItem
  }
}
    ${RegionItemFragmentDoc}`;

/**
 * __useProviderRegionsQuery__
 *
 * To run a query within a React component, call `useProviderRegionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProviderRegionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProviderRegionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useProviderRegionsQuery(baseOptions?: Apollo.QueryHookOptions<ProviderRegionsQuery, ProviderRegionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProviderRegionsQuery, ProviderRegionsQueryVariables>(ProviderRegionsDocument, options);
      }
export function useProviderRegionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProviderRegionsQuery, ProviderRegionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProviderRegionsQuery, ProviderRegionsQueryVariables>(ProviderRegionsDocument, options);
        }
export type ProviderRegionsQueryHookResult = ReturnType<typeof useProviderRegionsQuery>;
export type ProviderRegionsLazyQueryHookResult = ReturnType<typeof useProviderRegionsLazyQuery>;
export type ProviderRegionsQueryResult = Apollo.QueryResult<ProviderRegionsQuery, ProviderRegionsQueryVariables>;
export const ProviderCreateDataDocument = gql`
    query providerCreateData {
  providerCreateData {
    contacts {
      id
      firstName
      lastName
      email
    }
    regions {
      ...CreateDataRegion
    }
  }
}
    ${CreateDataRegionFragmentDoc}`;

/**
 * __useProviderCreateDataQuery__
 *
 * To run a query within a React component, call `useProviderCreateDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useProviderCreateDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProviderCreateDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useProviderCreateDataQuery(baseOptions?: Apollo.QueryHookOptions<ProviderCreateDataQuery, ProviderCreateDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProviderCreateDataQuery, ProviderCreateDataQueryVariables>(ProviderCreateDataDocument, options);
      }
export function useProviderCreateDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProviderCreateDataQuery, ProviderCreateDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProviderCreateDataQuery, ProviderCreateDataQueryVariables>(ProviderCreateDataDocument, options);
        }
export type ProviderCreateDataQueryHookResult = ReturnType<typeof useProviderCreateDataQuery>;
export type ProviderCreateDataLazyQueryHookResult = ReturnType<typeof useProviderCreateDataLazyQuery>;
export type ProviderCreateDataQueryResult = Apollo.QueryResult<ProviderCreateDataQuery, ProviderCreateDataQueryVariables>;
export const CreateProviderDocument = gql`
    mutation createProvider($input: ProviderCreateInput) {
  createProvider(input: $input) {
    id
    name
    isActive
    website
  }
}
    `;
export type CreateProviderMutationFn = Apollo.MutationFunction<CreateProviderMutation, CreateProviderMutationVariables>;

/**
 * __useCreateProviderMutation__
 *
 * To run a mutation, you first call `useCreateProviderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProviderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProviderMutation, { data, loading, error }] = useCreateProviderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateProviderMutation(baseOptions?: Apollo.MutationHookOptions<CreateProviderMutation, CreateProviderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProviderMutation, CreateProviderMutationVariables>(CreateProviderDocument, options);
      }
export type CreateProviderMutationHookResult = ReturnType<typeof useCreateProviderMutation>;
export type CreateProviderMutationResult = Apollo.MutationResult<CreateProviderMutation>;
export type CreateProviderMutationOptions = Apollo.BaseMutationOptions<CreateProviderMutation, CreateProviderMutationVariables>;
export const CreateTourDocument = gql`
    mutation createTour($location: String) {
  createTour(location: $location) {
    id
    type
    location
  }
}
    `;
export type CreateTourMutationFn = Apollo.MutationFunction<CreateTourMutation, CreateTourMutationVariables>;

/**
 * __useCreateTourMutation__
 *
 * To run a mutation, you first call `useCreateTourMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTourMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTourMutation, { data, loading, error }] = useCreateTourMutation({
 *   variables: {
 *      location: // value for 'location'
 *   },
 * });
 */
export function useCreateTourMutation(baseOptions?: Apollo.MutationHookOptions<CreateTourMutation, CreateTourMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTourMutation, CreateTourMutationVariables>(CreateTourDocument, options);
      }
export type CreateTourMutationHookResult = ReturnType<typeof useCreateTourMutation>;
export type CreateTourMutationResult = Apollo.MutationResult<CreateTourMutation>;
export type CreateTourMutationOptions = Apollo.BaseMutationOptions<CreateTourMutation, CreateTourMutationVariables>;
export const AmenitiesDocument = gql`
    query amenities {
  amenities {
    data {
      id
      name
    }
    previous
    next
    total
  }
}
    `;

/**
 * __useAmenitiesQuery__
 *
 * To run a query within a React component, call `useAmenitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAmenitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAmenitiesQuery({
 *   variables: {
 *   },
 * });
 */
export function useAmenitiesQuery(baseOptions?: Apollo.QueryHookOptions<AmenitiesQuery, AmenitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AmenitiesQuery, AmenitiesQueryVariables>(AmenitiesDocument, options);
      }
export function useAmenitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AmenitiesQuery, AmenitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AmenitiesQuery, AmenitiesQueryVariables>(AmenitiesDocument, options);
        }
export type AmenitiesQueryHookResult = ReturnType<typeof useAmenitiesQuery>;
export type AmenitiesLazyQueryHookResult = ReturnType<typeof useAmenitiesLazyQuery>;
export type AmenitiesQueryResult = Apollo.QueryResult<AmenitiesQuery, AmenitiesQueryVariables>;
export const CreateAmenityDocument = gql`
    mutation createAmenity($name: String) {
  createAmenity(name: $name) {
    id
    name
  }
}
    `;
export type CreateAmenityMutationFn = Apollo.MutationFunction<CreateAmenityMutation, CreateAmenityMutationVariables>;

/**
 * __useCreateAmenityMutation__
 *
 * To run a mutation, you first call `useCreateAmenityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAmenityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAmenityMutation, { data, loading, error }] = useCreateAmenityMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useCreateAmenityMutation(baseOptions?: Apollo.MutationHookOptions<CreateAmenityMutation, CreateAmenityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAmenityMutation, CreateAmenityMutationVariables>(CreateAmenityDocument, options);
      }
export type CreateAmenityMutationHookResult = ReturnType<typeof useCreateAmenityMutation>;
export type CreateAmenityMutationResult = Apollo.MutationResult<CreateAmenityMutation>;
export type CreateAmenityMutationOptions = Apollo.BaseMutationOptions<CreateAmenityMutation, CreateAmenityMutationVariables>;
export const DeleteProviderDocument = gql`
    mutation deleteProvider($input: ProviderDeleteInput) {
  deleteProvider(input: $input) {
    id
  }
}
    `;
export type DeleteProviderMutationFn = Apollo.MutationFunction<DeleteProviderMutation, DeleteProviderMutationVariables>;

/**
 * __useDeleteProviderMutation__
 *
 * To run a mutation, you first call `useDeleteProviderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProviderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProviderMutation, { data, loading, error }] = useDeleteProviderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteProviderMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProviderMutation, DeleteProviderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProviderMutation, DeleteProviderMutationVariables>(DeleteProviderDocument, options);
      }
export type DeleteProviderMutationHookResult = ReturnType<typeof useDeleteProviderMutation>;
export type DeleteProviderMutationResult = Apollo.MutationResult<DeleteProviderMutation>;
export type DeleteProviderMutationOptions = Apollo.BaseMutationOptions<DeleteProviderMutation, DeleteProviderMutationVariables>;
export const DeletePropertyDocument = gql`
    mutation deleteProperty($input: PropertyToDeleteInput) {
  deleteProperty(input: $input) {
    id
  }
}
    `;
export type DeletePropertyMutationFn = Apollo.MutationFunction<DeletePropertyMutation, DeletePropertyMutationVariables>;

/**
 * __useDeletePropertyMutation__
 *
 * To run a mutation, you first call `useDeletePropertyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePropertyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePropertyMutation, { data, loading, error }] = useDeletePropertyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeletePropertyMutation(baseOptions?: Apollo.MutationHookOptions<DeletePropertyMutation, DeletePropertyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePropertyMutation, DeletePropertyMutationVariables>(DeletePropertyDocument, options);
      }
export type DeletePropertyMutationHookResult = ReturnType<typeof useDeletePropertyMutation>;
export type DeletePropertyMutationResult = Apollo.MutationResult<DeletePropertyMutation>;
export type DeletePropertyMutationOptions = Apollo.BaseMutationOptions<DeletePropertyMutation, DeletePropertyMutationVariables>;
export const DeleteOfficeDocument = gql`
    mutation deleteOffice($input: OfficeDeleteInput) {
  deleteOffice(input: $input) {
    id
  }
}
    `;
export type DeleteOfficeMutationFn = Apollo.MutationFunction<DeleteOfficeMutation, DeleteOfficeMutationVariables>;

/**
 * __useDeleteOfficeMutation__
 *
 * To run a mutation, you first call `useDeleteOfficeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOfficeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOfficeMutation, { data, loading, error }] = useDeleteOfficeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteOfficeMutation(baseOptions?: Apollo.MutationHookOptions<DeleteOfficeMutation, DeleteOfficeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteOfficeMutation, DeleteOfficeMutationVariables>(DeleteOfficeDocument, options);
      }
export type DeleteOfficeMutationHookResult = ReturnType<typeof useDeleteOfficeMutation>;
export type DeleteOfficeMutationResult = Apollo.MutationResult<DeleteOfficeMutation>;
export type DeleteOfficeMutationOptions = Apollo.BaseMutationOptions<DeleteOfficeMutation, DeleteOfficeMutationVariables>;
export const UploadMediaDocument = gql`
    mutation uploadMedia($input: UploadMediaInput) {
  uploadMedia(input: $input) {
    ...UploadedMedia
  }
}
    ${UploadedMediaFragmentDoc}`;
export type UploadMediaMutationFn = Apollo.MutationFunction<UploadMediaMutation, UploadMediaMutationVariables>;

/**
 * __useUploadMediaMutation__
 *
 * To run a mutation, you first call `useUploadMediaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadMediaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadMediaMutation, { data, loading, error }] = useUploadMediaMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUploadMediaMutation(baseOptions?: Apollo.MutationHookOptions<UploadMediaMutation, UploadMediaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadMediaMutation, UploadMediaMutationVariables>(UploadMediaDocument, options);
      }
export type UploadMediaMutationHookResult = ReturnType<typeof useUploadMediaMutation>;
export type UploadMediaMutationResult = Apollo.MutationResult<UploadMediaMutation>;
export type UploadMediaMutationOptions = Apollo.BaseMutationOptions<UploadMediaMutation, UploadMediaMutationVariables>;
export const UpdateMediaPositionDocument = gql`
    mutation updateMediaPosition($input: UpdatePosition) {
  updateMediaPosition(input: $input) {
    id
  }
}
    `;
export type UpdateMediaPositionMutationFn = Apollo.MutationFunction<UpdateMediaPositionMutation, UpdateMediaPositionMutationVariables>;

/**
 * __useUpdateMediaPositionMutation__
 *
 * To run a mutation, you first call `useUpdateMediaPositionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMediaPositionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMediaPositionMutation, { data, loading, error }] = useUpdateMediaPositionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMediaPositionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMediaPositionMutation, UpdateMediaPositionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMediaPositionMutation, UpdateMediaPositionMutationVariables>(UpdateMediaPositionDocument, options);
      }
export type UpdateMediaPositionMutationHookResult = ReturnType<typeof useUpdateMediaPositionMutation>;
export type UpdateMediaPositionMutationResult = Apollo.MutationResult<UpdateMediaPositionMutation>;
export type UpdateMediaPositionMutationOptions = Apollo.BaseMutationOptions<UpdateMediaPositionMutation, UpdateMediaPositionMutationVariables>;
export const UpdateMediaTitleDocument = gql`
    mutation updateMediaTitle($input: TitleUpdate) {
  updateMediaTitle(input: $input) {
    id
    title
    type
    location
    filename
    mimetype
    encoding
  }
}
    `;
export type UpdateMediaTitleMutationFn = Apollo.MutationFunction<UpdateMediaTitleMutation, UpdateMediaTitleMutationVariables>;

/**
 * __useUpdateMediaTitleMutation__
 *
 * To run a mutation, you first call `useUpdateMediaTitleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMediaTitleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMediaTitleMutation, { data, loading, error }] = useUpdateMediaTitleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMediaTitleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMediaTitleMutation, UpdateMediaTitleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMediaTitleMutation, UpdateMediaTitleMutationVariables>(UpdateMediaTitleDocument, options);
      }
export type UpdateMediaTitleMutationHookResult = ReturnType<typeof useUpdateMediaTitleMutation>;
export type UpdateMediaTitleMutationResult = Apollo.MutationResult<UpdateMediaTitleMutation>;
export type UpdateMediaTitleMutationOptions = Apollo.BaseMutationOptions<UpdateMediaTitleMutation, UpdateMediaTitleMutationVariables>;
export const AddNoteDocument = gql`
    mutation addNote($input: AddNoteInput) {
  addNote(input: $input) {
    ...PropertyNote
  }
}
    ${PropertyNoteFragmentDoc}`;
export type AddNoteMutationFn = Apollo.MutationFunction<AddNoteMutation, AddNoteMutationVariables>;

/**
 * __useAddNoteMutation__
 *
 * To run a mutation, you first call `useAddNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addNoteMutation, { data, loading, error }] = useAddNoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddNoteMutation(baseOptions?: Apollo.MutationHookOptions<AddNoteMutation, AddNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddNoteMutation, AddNoteMutationVariables>(AddNoteDocument, options);
      }
export type AddNoteMutationHookResult = ReturnType<typeof useAddNoteMutation>;
export type AddNoteMutationResult = Apollo.MutationResult<AddNoteMutation>;
export type AddNoteMutationOptions = Apollo.BaseMutationOptions<AddNoteMutation, AddNoteMutationVariables>;
export const RetrieveNotesDocument = gql`
    mutation retrieveNotes($dealId: String!) {
  retrieveNotes(dealId: $dealId) {
    ...PropertyNote
  }
}
    ${PropertyNoteFragmentDoc}`;
export type RetrieveNotesMutationFn = Apollo.MutationFunction<RetrieveNotesMutation, RetrieveNotesMutationVariables>;

/**
 * __useRetrieveNotesMutation__
 *
 * To run a mutation, you first call `useRetrieveNotesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRetrieveNotesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [retrieveNotesMutation, { data, loading, error }] = useRetrieveNotesMutation({
 *   variables: {
 *      dealId: // value for 'dealId'
 *   },
 * });
 */
export function useRetrieveNotesMutation(baseOptions?: Apollo.MutationHookOptions<RetrieveNotesMutation, RetrieveNotesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RetrieveNotesMutation, RetrieveNotesMutationVariables>(RetrieveNotesDocument, options);
      }
export type RetrieveNotesMutationHookResult = ReturnType<typeof useRetrieveNotesMutation>;
export type RetrieveNotesMutationResult = Apollo.MutationResult<RetrieveNotesMutation>;
export type RetrieveNotesMutationOptions = Apollo.BaseMutationOptions<RetrieveNotesMutation, RetrieveNotesMutationVariables>;
export const SetAvailabilityDocument = gql`
    mutation setAvailability($input: AvailibilityInput) {
  setAvailability(input: $input) {
    id
    name
    available
  }
}
    `;
export type SetAvailabilityMutationFn = Apollo.MutationFunction<SetAvailabilityMutation, SetAvailabilityMutationVariables>;

/**
 * __useSetAvailabilityMutation__
 *
 * To run a mutation, you first call `useSetAvailabilityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetAvailabilityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setAvailabilityMutation, { data, loading, error }] = useSetAvailabilityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetAvailabilityMutation(baseOptions?: Apollo.MutationHookOptions<SetAvailabilityMutation, SetAvailabilityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetAvailabilityMutation, SetAvailabilityMutationVariables>(SetAvailabilityDocument, options);
      }
export type SetAvailabilityMutationHookResult = ReturnType<typeof useSetAvailabilityMutation>;
export type SetAvailabilityMutationResult = Apollo.MutationResult<SetAvailabilityMutation>;
export type SetAvailabilityMutationOptions = Apollo.BaseMutationOptions<SetAvailabilityMutation, SetAvailabilityMutationVariables>;
export const SetNuggetDocument = gql`
    mutation setNugget($input: NuggetInput) {
  setNugget(input: $input) {
    id
    name
    nuggetedBy {
      id
      firstName
      lastName
    }
    nuggetedAt
  }
}
    `;
export type SetNuggetMutationFn = Apollo.MutationFunction<SetNuggetMutation, SetNuggetMutationVariables>;

/**
 * __useSetNuggetMutation__
 *
 * To run a mutation, you first call `useSetNuggetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetNuggetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setNuggetMutation, { data, loading, error }] = useSetNuggetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetNuggetMutation(baseOptions?: Apollo.MutationHookOptions<SetNuggetMutation, SetNuggetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetNuggetMutation, SetNuggetMutationVariables>(SetNuggetDocument, options);
      }
export type SetNuggetMutationHookResult = ReturnType<typeof useSetNuggetMutation>;
export type SetNuggetMutationResult = Apollo.MutationResult<SetNuggetMutation>;
export type SetNuggetMutationOptions = Apollo.BaseMutationOptions<SetNuggetMutation, SetNuggetMutationVariables>;
export const OfficesDocument = gql`
    query offices($ids: [String]) {
  offices(ids: $ids) {
    ...OfficesOffice
  }
}
    ${OfficesOfficeFragmentDoc}`;

/**
 * __useOfficesQuery__
 *
 * To run a query within a React component, call `useOfficesQuery` and pass it any options that fit your needs.
 * When your component renders, `useOfficesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOfficesQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useOfficesQuery(baseOptions?: Apollo.QueryHookOptions<OfficesQuery, OfficesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OfficesQuery, OfficesQueryVariables>(OfficesDocument, options);
      }
export function useOfficesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OfficesQuery, OfficesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OfficesQuery, OfficesQueryVariables>(OfficesDocument, options);
        }
export type OfficesQueryHookResult = ReturnType<typeof useOfficesQuery>;
export type OfficesLazyQueryHookResult = ReturnType<typeof useOfficesLazyQuery>;
export type OfficesQueryResult = Apollo.QueryResult<OfficesQuery, OfficesQueryVariables>;
export const CreateScheduleOfficesDocument = gql`
    mutation createScheduleOffices($input: [ScheduleOfficeCreateInput]) {
  createScheduleOffices(input: $input) {
    id
    status
  }
}
    `;
export type CreateScheduleOfficesMutationFn = Apollo.MutationFunction<CreateScheduleOfficesMutation, CreateScheduleOfficesMutationVariables>;

/**
 * __useCreateScheduleOfficesMutation__
 *
 * To run a mutation, you first call `useCreateScheduleOfficesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateScheduleOfficesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createScheduleOfficesMutation, { data, loading, error }] = useCreateScheduleOfficesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateScheduleOfficesMutation(baseOptions?: Apollo.MutationHookOptions<CreateScheduleOfficesMutation, CreateScheduleOfficesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateScheduleOfficesMutation, CreateScheduleOfficesMutationVariables>(CreateScheduleOfficesDocument, options);
      }
export type CreateScheduleOfficesMutationHookResult = ReturnType<typeof useCreateScheduleOfficesMutation>;
export type CreateScheduleOfficesMutationResult = Apollo.MutationResult<CreateScheduleOfficesMutation>;
export type CreateScheduleOfficesMutationOptions = Apollo.BaseMutationOptions<CreateScheduleOfficesMutation, CreateScheduleOfficesMutationVariables>;
export const DealListDocument = gql`
    query dealList {
  dealList {
    ...DealList
  }
}
    ${DealListFragmentDoc}`;

/**
 * __useDealListQuery__
 *
 * To run a query within a React component, call `useDealListQuery` and pass it any options that fit your needs.
 * When your component renders, `useDealListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDealListQuery({
 *   variables: {
 *   },
 * });
 */
export function useDealListQuery(baseOptions?: Apollo.QueryHookOptions<DealListQuery, DealListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DealListQuery, DealListQueryVariables>(DealListDocument, options);
      }
export function useDealListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DealListQuery, DealListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DealListQuery, DealListQueryVariables>(DealListDocument, options);
        }
export type DealListQueryHookResult = ReturnType<typeof useDealListQuery>;
export type DealListLazyQueryHookResult = ReturnType<typeof useDealListLazyQuery>;
export type DealListQueryResult = Apollo.QueryResult<DealListQuery, DealListQueryVariables>;
export const ProviderRegisterDataDocument = gql`
    query providerRegisterData {
  providerRegisterData {
    providers {
      ...ProviderRegisterDataProvider
    }
    amenities {
      id
      name
    }
  }
}
    ${ProviderRegisterDataProviderFragmentDoc}`;

/**
 * __useProviderRegisterDataQuery__
 *
 * To run a query within a React component, call `useProviderRegisterDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useProviderRegisterDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProviderRegisterDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useProviderRegisterDataQuery(baseOptions?: Apollo.QueryHookOptions<ProviderRegisterDataQuery, ProviderRegisterDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProviderRegisterDataQuery, ProviderRegisterDataQueryVariables>(ProviderRegisterDataDocument, options);
      }
export function useProviderRegisterDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProviderRegisterDataQuery, ProviderRegisterDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProviderRegisterDataQuery, ProviderRegisterDataQueryVariables>(ProviderRegisterDataDocument, options);
        }
export type ProviderRegisterDataQueryHookResult = ReturnType<typeof useProviderRegisterDataQuery>;
export type ProviderRegisterDataLazyQueryHookResult = ReturnType<typeof useProviderRegisterDataLazyQuery>;
export type ProviderRegisterDataQueryResult = Apollo.QueryResult<ProviderRegisterDataQuery, ProviderRegisterDataQueryVariables>;
export const CreateProviderRegistrationDocument = gql`
    mutation createProviderRegistration($input: ProviderRegistrationInput) {
  createProviderRegistration(input: $input) {
    id
  }
}
    `;
export type CreateProviderRegistrationMutationFn = Apollo.MutationFunction<CreateProviderRegistrationMutation, CreateProviderRegistrationMutationVariables>;

/**
 * __useCreateProviderRegistrationMutation__
 *
 * To run a mutation, you first call `useCreateProviderRegistrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProviderRegistrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProviderRegistrationMutation, { data, loading, error }] = useCreateProviderRegistrationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateProviderRegistrationMutation(baseOptions?: Apollo.MutationHookOptions<CreateProviderRegistrationMutation, CreateProviderRegistrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProviderRegistrationMutation, CreateProviderRegistrationMutationVariables>(CreateProviderRegistrationDocument, options);
      }
export type CreateProviderRegistrationMutationHookResult = ReturnType<typeof useCreateProviderRegistrationMutation>;
export type CreateProviderRegistrationMutationResult = Apollo.MutationResult<CreateProviderRegistrationMutation>;
export type CreateProviderRegistrationMutationOptions = Apollo.BaseMutationOptions<CreateProviderRegistrationMutation, CreateProviderRegistrationMutationVariables>;
export const CreateProviderContactDocument = gql`
    mutation createProviderContact($input: ProviderContactCreateInput) {
  createProviderContact(input: $input) {
    contact {
      id
    }
  }
}
    `;
export type CreateProviderContactMutationFn = Apollo.MutationFunction<CreateProviderContactMutation, CreateProviderContactMutationVariables>;

/**
 * __useCreateProviderContactMutation__
 *
 * To run a mutation, you first call `useCreateProviderContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProviderContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProviderContactMutation, { data, loading, error }] = useCreateProviderContactMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateProviderContactMutation(baseOptions?: Apollo.MutationHookOptions<CreateProviderContactMutation, CreateProviderContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProviderContactMutation, CreateProviderContactMutationVariables>(CreateProviderContactDocument, options);
      }
export type CreateProviderContactMutationHookResult = ReturnType<typeof useCreateProviderContactMutation>;
export type CreateProviderContactMutationResult = Apollo.MutationResult<CreateProviderContactMutation>;
export type CreateProviderContactMutationOptions = Apollo.BaseMutationOptions<CreateProviderContactMutation, CreateProviderContactMutationVariables>;
export const FavouriteScheduleOfficeDocument = gql`
    mutation favouriteScheduleOffice($id: String) {
  favouriteScheduleOffice(id: $id) {
    id
    status
    favouriteCount
  }
}
    `;
export type FavouriteScheduleOfficeMutationFn = Apollo.MutationFunction<FavouriteScheduleOfficeMutation, FavouriteScheduleOfficeMutationVariables>;

/**
 * __useFavouriteScheduleOfficeMutation__
 *
 * To run a mutation, you first call `useFavouriteScheduleOfficeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFavouriteScheduleOfficeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [favouriteScheduleOfficeMutation, { data, loading, error }] = useFavouriteScheduleOfficeMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFavouriteScheduleOfficeMutation(baseOptions?: Apollo.MutationHookOptions<FavouriteScheduleOfficeMutation, FavouriteScheduleOfficeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FavouriteScheduleOfficeMutation, FavouriteScheduleOfficeMutationVariables>(FavouriteScheduleOfficeDocument, options);
      }
export type FavouriteScheduleOfficeMutationHookResult = ReturnType<typeof useFavouriteScheduleOfficeMutation>;
export type FavouriteScheduleOfficeMutationResult = Apollo.MutationResult<FavouriteScheduleOfficeMutation>;
export type FavouriteScheduleOfficeMutationOptions = Apollo.BaseMutationOptions<FavouriteScheduleOfficeMutation, FavouriteScheduleOfficeMutationVariables>;
export const UpdateScheduleOfficesStatusDocument = gql`
    mutation updateScheduleOfficesStatus($ids: [String], $status: ScheduleOfficeStatus, $statusDetail: String) {
  updateScheduleOfficesStatus(
    ids: $ids
    status: $status
    statusDetail: $statusDetail
  ) {
    id
    name
    status
    statusDetail
  }
}
    `;
export type UpdateScheduleOfficesStatusMutationFn = Apollo.MutationFunction<UpdateScheduleOfficesStatusMutation, UpdateScheduleOfficesStatusMutationVariables>;

/**
 * __useUpdateScheduleOfficesStatusMutation__
 *
 * To run a mutation, you first call `useUpdateScheduleOfficesStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateScheduleOfficesStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateScheduleOfficesStatusMutation, { data, loading, error }] = useUpdateScheduleOfficesStatusMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *      status: // value for 'status'
 *      statusDetail: // value for 'statusDetail'
 *   },
 * });
 */
export function useUpdateScheduleOfficesStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateScheduleOfficesStatusMutation, UpdateScheduleOfficesStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateScheduleOfficesStatusMutation, UpdateScheduleOfficesStatusMutationVariables>(UpdateScheduleOfficesStatusDocument, options);
      }
export type UpdateScheduleOfficesStatusMutationHookResult = ReturnType<typeof useUpdateScheduleOfficesStatusMutation>;
export type UpdateScheduleOfficesStatusMutationResult = Apollo.MutationResult<UpdateScheduleOfficesStatusMutation>;
export type UpdateScheduleOfficesStatusMutationOptions = Apollo.BaseMutationOptions<UpdateScheduleOfficesStatusMutation, UpdateScheduleOfficesStatusMutationVariables>;
export const NotificationsDocument = gql`
    query notifications {
  notifications {
    ...Notification
  }
}
    ${NotificationFragmentDoc}`;

/**
 * __useNotificationsQuery__
 *
 * To run a query within a React component, call `useNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotificationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useNotificationsQuery(baseOptions?: Apollo.QueryHookOptions<NotificationsQuery, NotificationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NotificationsQuery, NotificationsQueryVariables>(NotificationsDocument, options);
      }
export function useNotificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NotificationsQuery, NotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NotificationsQuery, NotificationsQueryVariables>(NotificationsDocument, options);
        }
export type NotificationsQueryHookResult = ReturnType<typeof useNotificationsQuery>;
export type NotificationsLazyQueryHookResult = ReturnType<typeof useNotificationsLazyQuery>;
export type NotificationsQueryResult = Apollo.QueryResult<NotificationsQuery, NotificationsQueryVariables>;
export const UpdateNotificationDocument = gql`
    mutation updateNotification($input: UpdateNotificationInput) {
  updateNotification(input: $input) {
    ...Notification
  }
}
    ${NotificationFragmentDoc}`;
export type UpdateNotificationMutationFn = Apollo.MutationFunction<UpdateNotificationMutation, UpdateNotificationMutationVariables>;

/**
 * __useUpdateNotificationMutation__
 *
 * To run a mutation, you first call `useUpdateNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNotificationMutation, { data, loading, error }] = useUpdateNotificationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateNotificationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateNotificationMutation, UpdateNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateNotificationMutation, UpdateNotificationMutationVariables>(UpdateNotificationDocument, options);
      }
export type UpdateNotificationMutationHookResult = ReturnType<typeof useUpdateNotificationMutation>;
export type UpdateNotificationMutationResult = Apollo.MutationResult<UpdateNotificationMutation>;
export type UpdateNotificationMutationOptions = Apollo.BaseMutationOptions<UpdateNotificationMutation, UpdateNotificationMutationVariables>;
export const CreateNotificationDocument = gql`
    mutation createNotification($input: CreateNotificationInput) {
  createNotification(input: $input) {
    ...Notification
  }
}
    ${NotificationFragmentDoc}`;
export type CreateNotificationMutationFn = Apollo.MutationFunction<CreateNotificationMutation, CreateNotificationMutationVariables>;

/**
 * __useCreateNotificationMutation__
 *
 * To run a mutation, you first call `useCreateNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNotificationMutation, { data, loading, error }] = useCreateNotificationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateNotificationMutation(baseOptions?: Apollo.MutationHookOptions<CreateNotificationMutation, CreateNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateNotificationMutation, CreateNotificationMutationVariables>(CreateNotificationDocument, options);
      }
export type CreateNotificationMutationHookResult = ReturnType<typeof useCreateNotificationMutation>;
export type CreateNotificationMutationResult = Apollo.MutationResult<CreateNotificationMutation>;
export type CreateNotificationMutationOptions = Apollo.BaseMutationOptions<CreateNotificationMutation, CreateNotificationMutationVariables>;
export const AvailabilityDashboardDataDocument = gql`
    query availabilityDashboardData {
  availabilityDashboardData {
    providerName
    createdOffices
    updatedOffices
    outdatedOffices
    createdAt
    createdProperties
  }
}
    `;

/**
 * __useAvailabilityDashboardDataQuery__
 *
 * To run a query within a React component, call `useAvailabilityDashboardDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useAvailabilityDashboardDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAvailabilityDashboardDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useAvailabilityDashboardDataQuery(baseOptions?: Apollo.QueryHookOptions<AvailabilityDashboardDataQuery, AvailabilityDashboardDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AvailabilityDashboardDataQuery, AvailabilityDashboardDataQueryVariables>(AvailabilityDashboardDataDocument, options);
      }
export function useAvailabilityDashboardDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AvailabilityDashboardDataQuery, AvailabilityDashboardDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AvailabilityDashboardDataQuery, AvailabilityDashboardDataQueryVariables>(AvailabilityDashboardDataDocument, options);
        }
export type AvailabilityDashboardDataQueryHookResult = ReturnType<typeof useAvailabilityDashboardDataQuery>;
export type AvailabilityDashboardDataLazyQueryHookResult = ReturnType<typeof useAvailabilityDashboardDataLazyQuery>;
export type AvailabilityDashboardDataQueryResult = Apollo.QueryResult<AvailabilityDashboardDataQuery, AvailabilityDashboardDataQueryVariables>;
export const ClientDealDocument = gql`
    query clientDeal($id: String, $showOtherProperties: Boolean) {
  clientDeal(id: $id, showOtherProperties: $showOtherProperties) {
    deal {
      ...ClientDealDeal
    }
    broker {
      ...ClientDealBroker
    }
    secondaryBroker {
      ...ClientDealBroker
    }
    properties {
      ...ClientDealProperty
    }
    otherProperties {
      ...ClientDealOtherProperty
    }
  }
}
    ${ClientDealDealFragmentDoc}
${ClientDealBrokerFragmentDoc}
${ClientDealPropertyFragmentDoc}
${ClientDealOtherPropertyFragmentDoc}`;

/**
 * __useClientDealQuery__
 *
 * To run a query within a React component, call `useClientDealQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientDealQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientDealQuery({
 *   variables: {
 *      id: // value for 'id'
 *      showOtherProperties: // value for 'showOtherProperties'
 *   },
 * });
 */
export function useClientDealQuery(baseOptions?: Apollo.QueryHookOptions<ClientDealQuery, ClientDealQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClientDealQuery, ClientDealQueryVariables>(ClientDealDocument, options);
      }
export function useClientDealLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClientDealQuery, ClientDealQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClientDealQuery, ClientDealQueryVariables>(ClientDealDocument, options);
        }
export type ClientDealQueryHookResult = ReturnType<typeof useClientDealQuery>;
export type ClientDealLazyQueryHookResult = ReturnType<typeof useClientDealLazyQuery>;
export type ClientDealQueryResult = Apollo.QueryResult<ClientDealQuery, ClientDealQueryVariables>;
export const ConnectedDealsDocument = gql`
    query connectedDeals($officeId: String!) {
  connectedDeals(officeId: $officeId) {
    ...connectedDealsList
  }
}
    ${ConnectedDealsListFragmentDoc}`;

/**
 * __useConnectedDealsQuery__
 *
 * To run a query within a React component, call `useConnectedDealsQuery` and pass it any options that fit your needs.
 * When your component renders, `useConnectedDealsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConnectedDealsQuery({
 *   variables: {
 *      officeId: // value for 'officeId'
 *   },
 * });
 */
export function useConnectedDealsQuery(baseOptions: Apollo.QueryHookOptions<ConnectedDealsQuery, ConnectedDealsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConnectedDealsQuery, ConnectedDealsQueryVariables>(ConnectedDealsDocument, options);
      }
export function useConnectedDealsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConnectedDealsQuery, ConnectedDealsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConnectedDealsQuery, ConnectedDealsQueryVariables>(ConnectedDealsDocument, options);
        }
export type ConnectedDealsQueryHookResult = ReturnType<typeof useConnectedDealsQuery>;
export type ConnectedDealsLazyQueryHookResult = ReturnType<typeof useConnectedDealsLazyQuery>;
export type ConnectedDealsQueryResult = Apollo.QueryResult<ConnectedDealsQuery, ConnectedDealsQueryVariables>;
export const CreateOfficeDocument = gql`
    mutation createOffice($input: OfficeCreateInput) {
  createOffice(input: $input) {
    id
    name
  }
}
    `;
export type CreateOfficeMutationFn = Apollo.MutationFunction<CreateOfficeMutation, CreateOfficeMutationVariables>;

/**
 * __useCreateOfficeMutation__
 *
 * To run a mutation, you first call `useCreateOfficeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOfficeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOfficeMutation, { data, loading, error }] = useCreateOfficeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOfficeMutation(baseOptions?: Apollo.MutationHookOptions<CreateOfficeMutation, CreateOfficeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOfficeMutation, CreateOfficeMutationVariables>(CreateOfficeDocument, options);
      }
export type CreateOfficeMutationHookResult = ReturnType<typeof useCreateOfficeMutation>;
export type CreateOfficeMutationResult = Apollo.MutationResult<CreateOfficeMutation>;
export type CreateOfficeMutationOptions = Apollo.BaseMutationOptions<CreateOfficeMutation, CreateOfficeMutationVariables>;
export const CurrenciesDocument = gql`
    query currencies {
  currencies {
    ...SingleCurrency
  }
}
    ${SingleCurrencyFragmentDoc}`;

/**
 * __useCurrenciesQuery__
 *
 * To run a query within a React component, call `useCurrenciesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrenciesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrenciesQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrenciesQuery(baseOptions?: Apollo.QueryHookOptions<CurrenciesQuery, CurrenciesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrenciesQuery, CurrenciesQueryVariables>(CurrenciesDocument, options);
      }
export function useCurrenciesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrenciesQuery, CurrenciesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrenciesQuery, CurrenciesQueryVariables>(CurrenciesDocument, options);
        }
export type CurrenciesQueryHookResult = ReturnType<typeof useCurrenciesQuery>;
export type CurrenciesLazyQueryHookResult = ReturnType<typeof useCurrenciesLazyQuery>;
export type CurrenciesQueryResult = Apollo.QueryResult<CurrenciesQuery, CurrenciesQueryVariables>;
export const DispoDashboardDocument = gql`
    query dispoDashboard {
  dispoDashboard {
    property {
      id
      name
      description
      shortDescription
      region {
        id
      }
      propertyType
      serviceType
      address {
        id
        streetName
      }
    }
    deals {
      id
      leadBroker {
        id
        firstName
        lastName
      }
      secondaryBroker {
        id
        firstName
        lastName
      }
      name
      status
      budget
      desks
      size
      sizeUnit
      locationNames
      schedule {
        scheduleOffice {
          id
          name
          desks
          size
          floor
          officeType
          status
          totalCost
          price
          rates
          groundRent
          estateCharge
          propertyId
          createdAt
        }
      }
    }
  }
}
    `;

/**
 * __useDispoDashboardQuery__
 *
 * To run a query within a React component, call `useDispoDashboardQuery` and pass it any options that fit your needs.
 * When your component renders, `useDispoDashboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDispoDashboardQuery({
 *   variables: {
 *   },
 * });
 */
export function useDispoDashboardQuery(baseOptions?: Apollo.QueryHookOptions<DispoDashboardQuery, DispoDashboardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DispoDashboardQuery, DispoDashboardQueryVariables>(DispoDashboardDocument, options);
      }
export function useDispoDashboardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DispoDashboardQuery, DispoDashboardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DispoDashboardQuery, DispoDashboardQueryVariables>(DispoDashboardDocument, options);
        }
export type DispoDashboardQueryHookResult = ReturnType<typeof useDispoDashboardQuery>;
export type DispoDashboardLazyQueryHookResult = ReturnType<typeof useDispoDashboardLazyQuery>;
export type DispoDashboardQueryResult = Apollo.QueryResult<DispoDashboardQuery, DispoDashboardQueryVariables>;
export const PropertyImagesDocument = gql`
    query propertyImages($id: String) {
  propertyImages(id: $id) {
    images {
      id
      location
      title
      filename
      type
      mimetype
      position
    }
    particulars {
      id
      location
      title
      filename
      type
      mimetype
      position
    }
    brochures {
      id
      location
      title
      filename
      type
      mimetype
      position
    }
    floorplans {
      id
      location
      title
      filename
      type
      mimetype
      position
    }
  }
}
    `;

/**
 * __usePropertyImagesQuery__
 *
 * To run a query within a React component, call `usePropertyImagesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePropertyImagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePropertyImagesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePropertyImagesQuery(baseOptions?: Apollo.QueryHookOptions<PropertyImagesQuery, PropertyImagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PropertyImagesQuery, PropertyImagesQueryVariables>(PropertyImagesDocument, options);
      }
export function usePropertyImagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PropertyImagesQuery, PropertyImagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PropertyImagesQuery, PropertyImagesQueryVariables>(PropertyImagesDocument, options);
        }
export type PropertyImagesQueryHookResult = ReturnType<typeof usePropertyImagesQuery>;
export type PropertyImagesLazyQueryHookResult = ReturnType<typeof usePropertyImagesLazyQuery>;
export type PropertyImagesQueryResult = Apollo.QueryResult<PropertyImagesQuery, PropertyImagesQueryVariables>;
export const NotifyBrokerDocument = gql`
    mutation notifyBroker($dealId: String) {
  notifyBroker(dealId: $dealId)
}
    `;
export type NotifyBrokerMutationFn = Apollo.MutationFunction<NotifyBrokerMutation, NotifyBrokerMutationVariables>;

/**
 * __useNotifyBrokerMutation__
 *
 * To run a mutation, you first call `useNotifyBrokerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNotifyBrokerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [notifyBrokerMutation, { data, loading, error }] = useNotifyBrokerMutation({
 *   variables: {
 *      dealId: // value for 'dealId'
 *   },
 * });
 */
export function useNotifyBrokerMutation(baseOptions?: Apollo.MutationHookOptions<NotifyBrokerMutation, NotifyBrokerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<NotifyBrokerMutation, NotifyBrokerMutationVariables>(NotifyBrokerDocument, options);
      }
export type NotifyBrokerMutationHookResult = ReturnType<typeof useNotifyBrokerMutation>;
export type NotifyBrokerMutationResult = Apollo.MutationResult<NotifyBrokerMutation>;
export type NotifyBrokerMutationOptions = Apollo.BaseMutationOptions<NotifyBrokerMutation, NotifyBrokerMutationVariables>;
export const OfficeListingDocument = gql`
    query officeListing($filter: OfficeInput) {
  officeListing(filter: $filter) {
    data {
      id
      officeType
      name
      desks
      size
      sizeUnit
      floor
      availableFrom
      description
      price
      groundRent
      rates
      totalCost
      minimumTerm
      minimumTermUnit
      nuggetedAt
      available
      fitted
      property {
        id
        name
        region {
          id
          name
          currency {
            id
            symbol
          }
        }
        address {
          id
          suburb
        }
        provider {
          id
          name
        }
        wholeBuildingOnly
      }
      note {
        ...PropertyNote
      }
      amenity {
        id
        name
      }
      featureImage {
        id
        title
        location
      }
      floorplan {
        id
        title
        location
      }
      image {
        id
        title
        location
      }
      tour {
        id
        title
        location
      }
      updatedAt
      updatedBy {
        firstName
        lastName
      }
      instructedOffice
    }
    previous
    next
    total
  }
}
    ${PropertyNoteFragmentDoc}`;

/**
 * __useOfficeListingQuery__
 *
 * To run a query within a React component, call `useOfficeListingQuery` and pass it any options that fit your needs.
 * When your component renders, `useOfficeListingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOfficeListingQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useOfficeListingQuery(baseOptions?: Apollo.QueryHookOptions<OfficeListingQuery, OfficeListingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OfficeListingQuery, OfficeListingQueryVariables>(OfficeListingDocument, options);
      }
export function useOfficeListingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OfficeListingQuery, OfficeListingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OfficeListingQuery, OfficeListingQueryVariables>(OfficeListingDocument, options);
        }
export type OfficeListingQueryHookResult = ReturnType<typeof useOfficeListingQuery>;
export type OfficeListingLazyQueryHookResult = ReturnType<typeof useOfficeListingLazyQuery>;
export type OfficeListingQueryResult = Apollo.QueryResult<OfficeListingQuery, OfficeListingQueryVariables>;
export const PropertiesDocument = gql`
    query properties($input: PropertyInput) {
  properties(input: $input) {
    data {
      id
      name
      region {
        id
        name
        currency {
          id
          symbol
        }
      }
      instruction {
        id
      }
      address {
        id
        suburb
      }
      provider {
        id
        name
      }
      office {
        id
        floor
        name
        available
      }
      wholeBuildingOnly
    }
    previous
    next
    total
  }
}
    `;

/**
 * __usePropertiesQuery__
 *
 * To run a query within a React component, call `usePropertiesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePropertiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePropertiesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePropertiesQuery(baseOptions?: Apollo.QueryHookOptions<PropertiesQuery, PropertiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PropertiesQuery, PropertiesQueryVariables>(PropertiesDocument, options);
      }
export function usePropertiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PropertiesQuery, PropertiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PropertiesQuery, PropertiesQueryVariables>(PropertiesDocument, options);
        }
export type PropertiesQueryHookResult = ReturnType<typeof usePropertiesQuery>;
export type PropertiesLazyQueryHookResult = ReturnType<typeof usePropertiesLazyQuery>;
export type PropertiesQueryResult = Apollo.QueryResult<PropertiesQuery, PropertiesQueryVariables>;
export const RentmapPropertiesDocument = gql`
    query rentmapProperties {
  rentmapProperties {
    region
    properties {
      id
      isActive
      address {
        id
        latitude
        longitude
      }
      region {
        id
        name
      }
      propertyType
      provider {
        id
        name
      }
      office {
        id
        available
        officeType
        sizeUnit
        price
        totalCost
        fitted
        size
        desks
      }
    }
  }
}
    `;

/**
 * __useRentmapPropertiesQuery__
 *
 * To run a query within a React component, call `useRentmapPropertiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useRentmapPropertiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRentmapPropertiesQuery({
 *   variables: {
 *   },
 * });
 */
export function useRentmapPropertiesQuery(baseOptions?: Apollo.QueryHookOptions<RentmapPropertiesQuery, RentmapPropertiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RentmapPropertiesQuery, RentmapPropertiesQueryVariables>(RentmapPropertiesDocument, options);
      }
export function useRentmapPropertiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RentmapPropertiesQuery, RentmapPropertiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RentmapPropertiesQuery, RentmapPropertiesQueryVariables>(RentmapPropertiesDocument, options);
        }
export type RentmapPropertiesQueryHookResult = ReturnType<typeof useRentmapPropertiesQuery>;
export type RentmapPropertiesLazyQueryHookResult = ReturnType<typeof useRentmapPropertiesLazyQuery>;
export type RentmapPropertiesQueryResult = Apollo.QueryResult<RentmapPropertiesQuery, RentmapPropertiesQueryVariables>;
export const PropertyDocument = gql`
    query property($id: String!) {
  property(id: $id) {
    ...SingleProperty
  }
}
    ${SinglePropertyFragmentDoc}`;

/**
 * __usePropertyQuery__
 *
 * To run a query within a React component, call `usePropertyQuery` and pass it any options that fit your needs.
 * When your component renders, `usePropertyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePropertyQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePropertyQuery(baseOptions: Apollo.QueryHookOptions<PropertyQuery, PropertyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PropertyQuery, PropertyQueryVariables>(PropertyDocument, options);
      }
export function usePropertyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PropertyQuery, PropertyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PropertyQuery, PropertyQueryVariables>(PropertyDocument, options);
        }
export type PropertyQueryHookResult = ReturnType<typeof usePropertyQuery>;
export type PropertyLazyQueryHookResult = ReturnType<typeof usePropertyLazyQuery>;
export type PropertyQueryResult = Apollo.QueryResult<PropertyQuery, PropertyQueryVariables>;
export const RemoveScheduleOfficesDocument = gql`
    mutation removeScheduleOffices($input: ScheduleOfficeRemoveInput) {
  removeScheduleOffices(input: $input) {
    count
  }
}
    `;
export type RemoveScheduleOfficesMutationFn = Apollo.MutationFunction<RemoveScheduleOfficesMutation, RemoveScheduleOfficesMutationVariables>;

/**
 * __useRemoveScheduleOfficesMutation__
 *
 * To run a mutation, you first call `useRemoveScheduleOfficesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveScheduleOfficesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeScheduleOfficesMutation, { data, loading, error }] = useRemoveScheduleOfficesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveScheduleOfficesMutation(baseOptions?: Apollo.MutationHookOptions<RemoveScheduleOfficesMutation, RemoveScheduleOfficesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveScheduleOfficesMutation, RemoveScheduleOfficesMutationVariables>(RemoveScheduleOfficesDocument, options);
      }
export type RemoveScheduleOfficesMutationHookResult = ReturnType<typeof useRemoveScheduleOfficesMutation>;
export type RemoveScheduleOfficesMutationResult = Apollo.MutationResult<RemoveScheduleOfficesMutation>;
export type RemoveScheduleOfficesMutationOptions = Apollo.BaseMutationOptions<RemoveScheduleOfficesMutation, RemoveScheduleOfficesMutationVariables>;
export const ScheduleOfficeDocument = gql`
    query scheduleOffice($id: String) {
  scheduleOffice(id: $id) {
    ...ScheduleOffice
  }
}
    ${ScheduleOfficeFragmentDoc}`;

/**
 * __useScheduleOfficeQuery__
 *
 * To run a query within a React component, call `useScheduleOfficeQuery` and pass it any options that fit your needs.
 * When your component renders, `useScheduleOfficeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScheduleOfficeQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useScheduleOfficeQuery(baseOptions?: Apollo.QueryHookOptions<ScheduleOfficeQuery, ScheduleOfficeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ScheduleOfficeQuery, ScheduleOfficeQueryVariables>(ScheduleOfficeDocument, options);
      }
export function useScheduleOfficeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ScheduleOfficeQuery, ScheduleOfficeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ScheduleOfficeQuery, ScheduleOfficeQueryVariables>(ScheduleOfficeDocument, options);
        }
export type ScheduleOfficeQueryHookResult = ReturnType<typeof useScheduleOfficeQuery>;
export type ScheduleOfficeLazyQueryHookResult = ReturnType<typeof useScheduleOfficeLazyQuery>;
export type ScheduleOfficeQueryResult = Apollo.QueryResult<ScheduleOfficeQuery, ScheduleOfficeQueryVariables>;
export const SyncScheduledOfficeDocument = gql`
    mutation syncScheduledOffice($input: SyncOfficeInput) {
  syncScheduleOffice(input: $input) {
    id
  }
}
    `;
export type SyncScheduledOfficeMutationFn = Apollo.MutationFunction<SyncScheduledOfficeMutation, SyncScheduledOfficeMutationVariables>;

/**
 * __useSyncScheduledOfficeMutation__
 *
 * To run a mutation, you first call `useSyncScheduledOfficeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncScheduledOfficeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncScheduledOfficeMutation, { data, loading, error }] = useSyncScheduledOfficeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSyncScheduledOfficeMutation(baseOptions?: Apollo.MutationHookOptions<SyncScheduledOfficeMutation, SyncScheduledOfficeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SyncScheduledOfficeMutation, SyncScheduledOfficeMutationVariables>(SyncScheduledOfficeDocument, options);
      }
export type SyncScheduledOfficeMutationHookResult = ReturnType<typeof useSyncScheduledOfficeMutation>;
export type SyncScheduledOfficeMutationResult = Apollo.MutationResult<SyncScheduledOfficeMutation>;
export type SyncScheduledOfficeMutationOptions = Apollo.BaseMutationOptions<SyncScheduledOfficeMutation, SyncScheduledOfficeMutationVariables>;
export const UpdateOfficeDocument = gql`
    mutation updateOffice($input: OfficeUpdateInput) {
  updateOffice(input: $input) {
    id
    officeType
    name
    desks
    size
    sizeUnit
    floor
    availableFrom
    description
    price
    groundRent
    rates
    totalCost
    nuggetedAt
    minimumTerm
    minimumTermUnit
    nuggetedAt
    fitted
    note {
      id
      note
    }
    amenity {
      id
      name
    }
    featureImage {
      id
      location
    }
    floorplan {
      id
      title
      location
    }
    image {
      id
      title
      location
    }
    tour {
      id
      title
      location
    }
    updatedAt
    updatedBy {
      id
      firstName
      lastName
    }
  }
}
    `;
export type UpdateOfficeMutationFn = Apollo.MutationFunction<UpdateOfficeMutation, UpdateOfficeMutationVariables>;

/**
 * __useUpdateOfficeMutation__
 *
 * To run a mutation, you first call `useUpdateOfficeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOfficeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOfficeMutation, { data, loading, error }] = useUpdateOfficeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOfficeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOfficeMutation, UpdateOfficeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOfficeMutation, UpdateOfficeMutationVariables>(UpdateOfficeDocument, options);
      }
export type UpdateOfficeMutationHookResult = ReturnType<typeof useUpdateOfficeMutation>;
export type UpdateOfficeMutationResult = Apollo.MutationResult<UpdateOfficeMutation>;
export type UpdateOfficeMutationOptions = Apollo.BaseMutationOptions<UpdateOfficeMutation, UpdateOfficeMutationVariables>;
export const UpdateOfficeMediaDocument = gql`
    mutation updateOfficeMedia($input: OfficeMediaToUpdateInput) {
  updateOfficeMedia(input: $input) {
    id
    name
    image {
      ...MediaItem
    }
    floorplan {
      ...MediaItem
    }
  }
}
    ${MediaItemFragmentDoc}`;
export type UpdateOfficeMediaMutationFn = Apollo.MutationFunction<UpdateOfficeMediaMutation, UpdateOfficeMediaMutationVariables>;

/**
 * __useUpdateOfficeMediaMutation__
 *
 * To run a mutation, you first call `useUpdateOfficeMediaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOfficeMediaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOfficeMediaMutation, { data, loading, error }] = useUpdateOfficeMediaMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOfficeMediaMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOfficeMediaMutation, UpdateOfficeMediaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOfficeMediaMutation, UpdateOfficeMediaMutationVariables>(UpdateOfficeMediaDocument, options);
      }
export type UpdateOfficeMediaMutationHookResult = ReturnType<typeof useUpdateOfficeMediaMutation>;
export type UpdateOfficeMediaMutationResult = Apollo.MutationResult<UpdateOfficeMediaMutation>;
export type UpdateOfficeMediaMutationOptions = Apollo.BaseMutationOptions<UpdateOfficeMediaMutation, UpdateOfficeMediaMutationVariables>;
export const UpdatePropertyDocument = gql`
    mutation updateProperty($input: PropertyToUpdateInput) {
  updateProperty(input: $input) {
    id
    name
    isActive
    image {
      ...MediaItem
    }
    floorplan {
      ...MediaItem
    }
  }
}
    ${MediaItemFragmentDoc}`;
export type UpdatePropertyMutationFn = Apollo.MutationFunction<UpdatePropertyMutation, UpdatePropertyMutationVariables>;

/**
 * __useUpdatePropertyMutation__
 *
 * To run a mutation, you first call `useUpdatePropertyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePropertyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePropertyMutation, { data, loading, error }] = useUpdatePropertyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePropertyMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePropertyMutation, UpdatePropertyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePropertyMutation, UpdatePropertyMutationVariables>(UpdatePropertyDocument, options);
      }
export type UpdatePropertyMutationHookResult = ReturnType<typeof useUpdatePropertyMutation>;
export type UpdatePropertyMutationResult = Apollo.MutationResult<UpdatePropertyMutation>;
export type UpdatePropertyMutationOptions = Apollo.BaseMutationOptions<UpdatePropertyMutation, UpdatePropertyMutationVariables>;
export const UpdatePropertyMediaDocument = gql`
    mutation updatePropertyMedia($input: PropertyMediaToUpdateInput) {
  updatePropertyMedia(input: $input) {
    id
    name
    isActive
    image {
      ...MediaItem
    }
    floorplan {
      ...MediaItem
    }
  }
}
    ${MediaItemFragmentDoc}`;
export type UpdatePropertyMediaMutationFn = Apollo.MutationFunction<UpdatePropertyMediaMutation, UpdatePropertyMediaMutationVariables>;

/**
 * __useUpdatePropertyMediaMutation__
 *
 * To run a mutation, you first call `useUpdatePropertyMediaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePropertyMediaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePropertyMediaMutation, { data, loading, error }] = useUpdatePropertyMediaMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePropertyMediaMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePropertyMediaMutation, UpdatePropertyMediaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePropertyMediaMutation, UpdatePropertyMediaMutationVariables>(UpdatePropertyMediaDocument, options);
      }
export type UpdatePropertyMediaMutationHookResult = ReturnType<typeof useUpdatePropertyMediaMutation>;
export type UpdatePropertyMediaMutationResult = Apollo.MutationResult<UpdatePropertyMediaMutation>;
export type UpdatePropertyMediaMutationOptions = Apollo.BaseMutationOptions<UpdatePropertyMediaMutation, UpdatePropertyMediaMutationVariables>;
export const UpdatePropertyScheduleOrderDocument = gql`
    mutation updatePropertyScheduleOrder($input: updatePropertyScheduleOrderInput) {
  updatePropertyScheduleOrder(input: $input) {
    propertyId
    position
  }
}
    `;
export type UpdatePropertyScheduleOrderMutationFn = Apollo.MutationFunction<UpdatePropertyScheduleOrderMutation, UpdatePropertyScheduleOrderMutationVariables>;

/**
 * __useUpdatePropertyScheduleOrderMutation__
 *
 * To run a mutation, you first call `useUpdatePropertyScheduleOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePropertyScheduleOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePropertyScheduleOrderMutation, { data, loading, error }] = useUpdatePropertyScheduleOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePropertyScheduleOrderMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePropertyScheduleOrderMutation, UpdatePropertyScheduleOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePropertyScheduleOrderMutation, UpdatePropertyScheduleOrderMutationVariables>(UpdatePropertyScheduleOrderDocument, options);
      }
export type UpdatePropertyScheduleOrderMutationHookResult = ReturnType<typeof useUpdatePropertyScheduleOrderMutation>;
export type UpdatePropertyScheduleOrderMutationResult = Apollo.MutationResult<UpdatePropertyScheduleOrderMutation>;
export type UpdatePropertyScheduleOrderMutationOptions = Apollo.BaseMutationOptions<UpdatePropertyScheduleOrderMutation, UpdatePropertyScheduleOrderMutationVariables>;
export const UpdateScheduleOfficeDocument = gql`
    mutation updateScheduleOffice($input: ScheduleOfficeUpdateInput) {
  updateScheduleOffice(input: $input) {
    id
    name
    status
  }
}
    `;
export type UpdateScheduleOfficeMutationFn = Apollo.MutationFunction<UpdateScheduleOfficeMutation, UpdateScheduleOfficeMutationVariables>;

/**
 * __useUpdateScheduleOfficeMutation__
 *
 * To run a mutation, you first call `useUpdateScheduleOfficeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateScheduleOfficeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateScheduleOfficeMutation, { data, loading, error }] = useUpdateScheduleOfficeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateScheduleOfficeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateScheduleOfficeMutation, UpdateScheduleOfficeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateScheduleOfficeMutation, UpdateScheduleOfficeMutationVariables>(UpdateScheduleOfficeDocument, options);
      }
export type UpdateScheduleOfficeMutationHookResult = ReturnType<typeof useUpdateScheduleOfficeMutation>;
export type UpdateScheduleOfficeMutationResult = Apollo.MutationResult<UpdateScheduleOfficeMutation>;
export type UpdateScheduleOfficeMutationOptions = Apollo.BaseMutationOptions<UpdateScheduleOfficeMutation, UpdateScheduleOfficeMutationVariables>;
export const BrokersDocument = gql`
    query brokers {
  brokers {
    ...SingleBroker
  }
}
    ${SingleBrokerFragmentDoc}`;

/**
 * __useBrokersQuery__
 *
 * To run a query within a React component, call `useBrokersQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrokersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBrokersQuery({
 *   variables: {
 *   },
 * });
 */
export function useBrokersQuery(baseOptions?: Apollo.QueryHookOptions<BrokersQuery, BrokersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BrokersQuery, BrokersQueryVariables>(BrokersDocument, options);
      }
export function useBrokersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BrokersQuery, BrokersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BrokersQuery, BrokersQueryVariables>(BrokersDocument, options);
        }
export type BrokersQueryHookResult = ReturnType<typeof useBrokersQuery>;
export type BrokersLazyQueryHookResult = ReturnType<typeof useBrokersLazyQuery>;
export type BrokersQueryResult = Apollo.QueryResult<BrokersQuery, BrokersQueryVariables>;
export const CreateBrokerDocument = gql`
    mutation createBroker($input: BrokerToCreateInput) {
  createBroker(input: $input) {
    ...SingleBroker
  }
}
    ${SingleBrokerFragmentDoc}`;
export type CreateBrokerMutationFn = Apollo.MutationFunction<CreateBrokerMutation, CreateBrokerMutationVariables>;

/**
 * __useCreateBrokerMutation__
 *
 * To run a mutation, you first call `useCreateBrokerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBrokerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBrokerMutation, { data, loading, error }] = useCreateBrokerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateBrokerMutation(baseOptions?: Apollo.MutationHookOptions<CreateBrokerMutation, CreateBrokerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBrokerMutation, CreateBrokerMutationVariables>(CreateBrokerDocument, options);
      }
export type CreateBrokerMutationHookResult = ReturnType<typeof useCreateBrokerMutation>;
export type CreateBrokerMutationResult = Apollo.MutationResult<CreateBrokerMutation>;
export type CreateBrokerMutationOptions = Apollo.BaseMutationOptions<CreateBrokerMutation, CreateBrokerMutationVariables>;
export const UpdateBrokerDocument = gql`
    mutation updateBroker($input: BrokerToUpdateInput) {
  updateBroker(input: $input) {
    ...SingleBroker
  }
}
    ${SingleBrokerFragmentDoc}`;
export type UpdateBrokerMutationFn = Apollo.MutationFunction<UpdateBrokerMutation, UpdateBrokerMutationVariables>;

/**
 * __useUpdateBrokerMutation__
 *
 * To run a mutation, you first call `useUpdateBrokerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBrokerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBrokerMutation, { data, loading, error }] = useUpdateBrokerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateBrokerMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBrokerMutation, UpdateBrokerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBrokerMutation, UpdateBrokerMutationVariables>(UpdateBrokerDocument, options);
      }
export type UpdateBrokerMutationHookResult = ReturnType<typeof useUpdateBrokerMutation>;
export type UpdateBrokerMutationResult = Apollo.MutationResult<UpdateBrokerMutation>;
export type UpdateBrokerMutationOptions = Apollo.BaseMutationOptions<UpdateBrokerMutation, UpdateBrokerMutationVariables>;
export const RegionsDocument = gql`
    query regions {
  regions {
    ...RegionWithCurrency
  }
}
    ${RegionWithCurrencyFragmentDoc}`;

/**
 * __useRegionsQuery__
 *
 * To run a query within a React component, call `useRegionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRegionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRegionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useRegionsQuery(baseOptions?: Apollo.QueryHookOptions<RegionsQuery, RegionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RegionsQuery, RegionsQueryVariables>(RegionsDocument, options);
      }
export function useRegionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RegionsQuery, RegionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RegionsQuery, RegionsQueryVariables>(RegionsDocument, options);
        }
export type RegionsQueryHookResult = ReturnType<typeof useRegionsQuery>;
export type RegionsLazyQueryHookResult = ReturnType<typeof useRegionsLazyQuery>;
export type RegionsQueryResult = Apollo.QueryResult<RegionsQuery, RegionsQueryVariables>;
export const CreateRegionDocument = gql`
    mutation createRegion($input: RegionCreateInput) {
  createRegion(input: $input) {
    ...RegionWithCurrency
  }
}
    ${RegionWithCurrencyFragmentDoc}`;
export type CreateRegionMutationFn = Apollo.MutationFunction<CreateRegionMutation, CreateRegionMutationVariables>;

/**
 * __useCreateRegionMutation__
 *
 * To run a mutation, you first call `useCreateRegionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRegionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRegionMutation, { data, loading, error }] = useCreateRegionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateRegionMutation(baseOptions?: Apollo.MutationHookOptions<CreateRegionMutation, CreateRegionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateRegionMutation, CreateRegionMutationVariables>(CreateRegionDocument, options);
      }
export type CreateRegionMutationHookResult = ReturnType<typeof useCreateRegionMutation>;
export type CreateRegionMutationResult = Apollo.MutationResult<CreateRegionMutation>;
export type CreateRegionMutationOptions = Apollo.BaseMutationOptions<CreateRegionMutation, CreateRegionMutationVariables>;
export const UpdateRegionDocument = gql`
    mutation updateRegion($input: RegionUpdateInput) {
  updateRegion(input: $input) {
    ...RegionWithCurrency
  }
}
    ${RegionWithCurrencyFragmentDoc}`;
export type UpdateRegionMutationFn = Apollo.MutationFunction<UpdateRegionMutation, UpdateRegionMutationVariables>;

/**
 * __useUpdateRegionMutation__
 *
 * To run a mutation, you first call `useUpdateRegionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRegionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRegionMutation, { data, loading, error }] = useUpdateRegionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateRegionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRegionMutation, UpdateRegionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRegionMutation, UpdateRegionMutationVariables>(UpdateRegionDocument, options);
      }
export type UpdateRegionMutationHookResult = ReturnType<typeof useUpdateRegionMutation>;
export type UpdateRegionMutationResult = Apollo.MutationResult<UpdateRegionMutation>;
export type UpdateRegionMutationOptions = Apollo.BaseMutationOptions<UpdateRegionMutation, UpdateRegionMutationVariables>;
export const RunScraperDocument = gql`
    mutation runScraper($input: ScraperInput) {
  runScraper(input: $input) {
    result
  }
}
    `;
export type RunScraperMutationFn = Apollo.MutationFunction<RunScraperMutation, RunScraperMutationVariables>;

/**
 * __useRunScraperMutation__
 *
 * To run a mutation, you first call `useRunScraperMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRunScraperMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [runScraperMutation, { data, loading, error }] = useRunScraperMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRunScraperMutation(baseOptions?: Apollo.MutationHookOptions<RunScraperMutation, RunScraperMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RunScraperMutation, RunScraperMutationVariables>(RunScraperDocument, options);
      }
export type RunScraperMutationHookResult = ReturnType<typeof useRunScraperMutation>;
export type RunScraperMutationResult = Apollo.MutationResult<RunScraperMutation>;
export type RunScraperMutationOptions = Apollo.BaseMutationOptions<RunScraperMutation, RunScraperMutationVariables>;
export const CheckScraperDocument = gql`
    mutation checkScraper($id: String) {
  checkScraper(id: $id) {
    progress
    completed
    limitReached
    result {
      loggedIn
      returnOffice {
        name
        address
        lat
        lng
        images
        leaseType
        description
        floorplan {
          type
          url
        }
        brouchure {
          url
          name
        }
        offices {
          name
          sqft
          rentSqft
          ratesPay
          service
          estate
          totalMonth
          sqm
          available
          fitted
          property
        }
        ameneties
      }
    }
  }
}
    `;
export type CheckScraperMutationFn = Apollo.MutationFunction<CheckScraperMutation, CheckScraperMutationVariables>;

/**
 * __useCheckScraperMutation__
 *
 * To run a mutation, you first call `useCheckScraperMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCheckScraperMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [checkScraperMutation, { data, loading, error }] = useCheckScraperMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCheckScraperMutation(baseOptions?: Apollo.MutationHookOptions<CheckScraperMutation, CheckScraperMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CheckScraperMutation, CheckScraperMutationVariables>(CheckScraperDocument, options);
      }
export type CheckScraperMutationHookResult = ReturnType<typeof useCheckScraperMutation>;
export type CheckScraperMutationResult = Apollo.MutationResult<CheckScraperMutation>;
export type CheckScraperMutationOptions = Apollo.BaseMutationOptions<CheckScraperMutation, CheckScraperMutationVariables>;
export const AddItemsToDatabaseDocument = gql`
    mutation addItemsToDatabase($input: ItemstoAdd) {
  addItemsToDatabase(input: $input) {
    addItemsReturn
  }
}
    `;
export type AddItemsToDatabaseMutationFn = Apollo.MutationFunction<AddItemsToDatabaseMutation, AddItemsToDatabaseMutationVariables>;

/**
 * __useAddItemsToDatabaseMutation__
 *
 * To run a mutation, you first call `useAddItemsToDatabaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddItemsToDatabaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addItemsToDatabaseMutation, { data, loading, error }] = useAddItemsToDatabaseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddItemsToDatabaseMutation(baseOptions?: Apollo.MutationHookOptions<AddItemsToDatabaseMutation, AddItemsToDatabaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddItemsToDatabaseMutation, AddItemsToDatabaseMutationVariables>(AddItemsToDatabaseDocument, options);
      }
export type AddItemsToDatabaseMutationHookResult = ReturnType<typeof useAddItemsToDatabaseMutation>;
export type AddItemsToDatabaseMutationResult = Apollo.MutationResult<AddItemsToDatabaseMutation>;
export type AddItemsToDatabaseMutationOptions = Apollo.BaseMutationOptions<AddItemsToDatabaseMutation, AddItemsToDatabaseMutationVariables>;
export const DealDocument = gql`
    query deal($id: String!) {
  deal(id: $id) {
    deal {
      ...SelectedDeal
    }
    orderedProperties {
      ...DealScheduleProperty
    }
  }
}
    ${SelectedDealFragmentDoc}
${DealSchedulePropertyFragmentDoc}`;

/**
 * __useDealQuery__
 *
 * To run a query within a React component, call `useDealQuery` and pass it any options that fit your needs.
 * When your component renders, `useDealQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDealQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDealQuery(baseOptions: Apollo.QueryHookOptions<DealQuery, DealQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DealQuery, DealQueryVariables>(DealDocument, options);
      }
export function useDealLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DealQuery, DealQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DealQuery, DealQueryVariables>(DealDocument, options);
        }
export type DealQueryHookResult = ReturnType<typeof useDealQuery>;
export type DealLazyQueryHookResult = ReturnType<typeof useDealLazyQuery>;
export type DealQueryResult = Apollo.QueryResult<DealQuery, DealQueryVariables>;
export const UpdateProviderRegistrationDocument = gql`
    mutation updateProviderRegistration($input: ProviderRegistrationUpdate) {
  updateProviderRegistration(input: $input) {
    id
    status
  }
}
    `;
export type UpdateProviderRegistrationMutationFn = Apollo.MutationFunction<UpdateProviderRegistrationMutation, UpdateProviderRegistrationMutationVariables>;

/**
 * __useUpdateProviderRegistrationMutation__
 *
 * To run a mutation, you first call `useUpdateProviderRegistrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProviderRegistrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProviderRegistrationMutation, { data, loading, error }] = useUpdateProviderRegistrationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProviderRegistrationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProviderRegistrationMutation, UpdateProviderRegistrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProviderRegistrationMutation, UpdateProviderRegistrationMutationVariables>(UpdateProviderRegistrationDocument, options);
      }
export type UpdateProviderRegistrationMutationHookResult = ReturnType<typeof useUpdateProviderRegistrationMutation>;
export type UpdateProviderRegistrationMutationResult = Apollo.MutationResult<UpdateProviderRegistrationMutation>;
export type UpdateProviderRegistrationMutationOptions = Apollo.BaseMutationOptions<UpdateProviderRegistrationMutation, UpdateProviderRegistrationMutationVariables>;
export const SetScheduleOfficeStatusDocument = gql`
    mutation setScheduleOfficeStatus($input: SetScheduleOfficeStatusInput) {
  setScheduleOfficeStatus(input: $input) {
    id
    status
  }
}
    `;
export type SetScheduleOfficeStatusMutationFn = Apollo.MutationFunction<SetScheduleOfficeStatusMutation, SetScheduleOfficeStatusMutationVariables>;

/**
 * __useSetScheduleOfficeStatusMutation__
 *
 * To run a mutation, you first call `useSetScheduleOfficeStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetScheduleOfficeStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setScheduleOfficeStatusMutation, { data, loading, error }] = useSetScheduleOfficeStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetScheduleOfficeStatusMutation(baseOptions?: Apollo.MutationHookOptions<SetScheduleOfficeStatusMutation, SetScheduleOfficeStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetScheduleOfficeStatusMutation, SetScheduleOfficeStatusMutationVariables>(SetScheduleOfficeStatusDocument, options);
      }
export type SetScheduleOfficeStatusMutationHookResult = ReturnType<typeof useSetScheduleOfficeStatusMutation>;
export type SetScheduleOfficeStatusMutationResult = Apollo.MutationResult<SetScheduleOfficeStatusMutation>;
export type SetScheduleOfficeStatusMutationOptions = Apollo.BaseMutationOptions<SetScheduleOfficeStatusMutation, SetScheduleOfficeStatusMutationVariables>;
export const AddSecondaryBrokerDocument = gql`
    mutation addSecondaryBroker($input: BrokerToAddInput) {
  addSecondaryBroker(input: $input) {
    secondaryBroker {
      ...SingleBroker
    }
  }
}
    ${SingleBrokerFragmentDoc}`;
export type AddSecondaryBrokerMutationFn = Apollo.MutationFunction<AddSecondaryBrokerMutation, AddSecondaryBrokerMutationVariables>;

/**
 * __useAddSecondaryBrokerMutation__
 *
 * To run a mutation, you first call `useAddSecondaryBrokerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddSecondaryBrokerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addSecondaryBrokerMutation, { data, loading, error }] = useAddSecondaryBrokerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddSecondaryBrokerMutation(baseOptions?: Apollo.MutationHookOptions<AddSecondaryBrokerMutation, AddSecondaryBrokerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddSecondaryBrokerMutation, AddSecondaryBrokerMutationVariables>(AddSecondaryBrokerDocument, options);
      }
export type AddSecondaryBrokerMutationHookResult = ReturnType<typeof useAddSecondaryBrokerMutation>;
export type AddSecondaryBrokerMutationResult = Apollo.MutationResult<AddSecondaryBrokerMutation>;
export type AddSecondaryBrokerMutationOptions = Apollo.BaseMutationOptions<AddSecondaryBrokerMutation, AddSecondaryBrokerMutationVariables>;
export const ToggleShowProviderFilterDocument = gql`
    mutation toggleShowProviderFilter($input: ToggleShowProviderFilterInput) {
  toggleShowProviderFilter(input: $input) {
    showProviderFilter
  }
}
    `;
export type ToggleShowProviderFilterMutationFn = Apollo.MutationFunction<ToggleShowProviderFilterMutation, ToggleShowProviderFilterMutationVariables>;

/**
 * __useToggleShowProviderFilterMutation__
 *
 * To run a mutation, you first call `useToggleShowProviderFilterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleShowProviderFilterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleShowProviderFilterMutation, { data, loading, error }] = useToggleShowProviderFilterMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useToggleShowProviderFilterMutation(baseOptions?: Apollo.MutationHookOptions<ToggleShowProviderFilterMutation, ToggleShowProviderFilterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleShowProviderFilterMutation, ToggleShowProviderFilterMutationVariables>(ToggleShowProviderFilterDocument, options);
      }
export type ToggleShowProviderFilterMutationHookResult = ReturnType<typeof useToggleShowProviderFilterMutation>;
export type ToggleShowProviderFilterMutationResult = Apollo.MutationResult<ToggleShowProviderFilterMutation>;
export type ToggleShowProviderFilterMutationOptions = Apollo.BaseMutationOptions<ToggleShowProviderFilterMutation, ToggleShowProviderFilterMutationVariables>;
export const ToggleShowAvailableFromDocument = gql`
    mutation toggleShowAvailableFrom($input: ToggleShowAvailableFromInput) {
  toggleShowAvailableFrom(input: $input) {
    showAvailableFrom
  }
}
    `;
export type ToggleShowAvailableFromMutationFn = Apollo.MutationFunction<ToggleShowAvailableFromMutation, ToggleShowAvailableFromMutationVariables>;

/**
 * __useToggleShowAvailableFromMutation__
 *
 * To run a mutation, you first call `useToggleShowAvailableFromMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleShowAvailableFromMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleShowAvailableFromMutation, { data, loading, error }] = useToggleShowAvailableFromMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useToggleShowAvailableFromMutation(baseOptions?: Apollo.MutationHookOptions<ToggleShowAvailableFromMutation, ToggleShowAvailableFromMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleShowAvailableFromMutation, ToggleShowAvailableFromMutationVariables>(ToggleShowAvailableFromDocument, options);
      }
export type ToggleShowAvailableFromMutationHookResult = ReturnType<typeof useToggleShowAvailableFromMutation>;
export type ToggleShowAvailableFromMutationResult = Apollo.MutationResult<ToggleShowAvailableFromMutation>;
export type ToggleShowAvailableFromMutationOptions = Apollo.BaseMutationOptions<ToggleShowAvailableFromMutation, ToggleShowAvailableFromMutationVariables>;
export const ToggleShowMatchingDocument = gql`
    mutation toggleShowMatching($input: ToggleShowMatchingFromInput) {
  toggleShowMatching(input: $input) {
    showMatchingToggle
  }
}
    `;
export type ToggleShowMatchingMutationFn = Apollo.MutationFunction<ToggleShowMatchingMutation, ToggleShowMatchingMutationVariables>;

/**
 * __useToggleShowMatchingMutation__
 *
 * To run a mutation, you first call `useToggleShowMatchingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleShowMatchingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleShowMatchingMutation, { data, loading, error }] = useToggleShowMatchingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useToggleShowMatchingMutation(baseOptions?: Apollo.MutationHookOptions<ToggleShowMatchingMutation, ToggleShowMatchingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleShowMatchingMutation, ToggleShowMatchingMutationVariables>(ToggleShowMatchingDocument, options);
      }
export type ToggleShowMatchingMutationHookResult = ReturnType<typeof useToggleShowMatchingMutation>;
export type ToggleShowMatchingMutationResult = Apollo.MutationResult<ToggleShowMatchingMutation>;
export type ToggleShowMatchingMutationOptions = Apollo.BaseMutationOptions<ToggleShowMatchingMutation, ToggleShowMatchingMutationVariables>;
export const ToggleCanFavouriteDocument = gql`
    mutation toggleCanFavourite($input: ToggleCanFavouriteFromInput) {
  toggleCanFavourite(input: $input) {
    canFavourite
  }
}
    `;
export type ToggleCanFavouriteMutationFn = Apollo.MutationFunction<ToggleCanFavouriteMutation, ToggleCanFavouriteMutationVariables>;

/**
 * __useToggleCanFavouriteMutation__
 *
 * To run a mutation, you first call `useToggleCanFavouriteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleCanFavouriteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleCanFavouriteMutation, { data, loading, error }] = useToggleCanFavouriteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useToggleCanFavouriteMutation(baseOptions?: Apollo.MutationHookOptions<ToggleCanFavouriteMutation, ToggleCanFavouriteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleCanFavouriteMutation, ToggleCanFavouriteMutationVariables>(ToggleCanFavouriteDocument, options);
      }
export type ToggleCanFavouriteMutationHookResult = ReturnType<typeof useToggleCanFavouriteMutation>;
export type ToggleCanFavouriteMutationResult = Apollo.MutationResult<ToggleCanFavouriteMutation>;
export type ToggleCanFavouriteMutationOptions = Apollo.BaseMutationOptions<ToggleCanFavouriteMutation, ToggleCanFavouriteMutationVariables>;
export const DealsDocument = gql`
    query deals($input: DealsInput) {
  deals(input: $input) {
    data {
      id
      name
      desks
      size
      sizeUnit
      budget
      location
      status
      client {
        id
        name
      }
      leadBroker {
        id
        firstName
        lastName
      }
      contact {
        id
        firstName
        lastName
        email
      }
    }
    total
    next
    previous
  }
}
    `;

/**
 * __useDealsQuery__
 *
 * To run a query within a React component, call `useDealsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDealsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDealsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDealsQuery(baseOptions?: Apollo.QueryHookOptions<DealsQuery, DealsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DealsQuery, DealsQueryVariables>(DealsDocument, options);
      }
export function useDealsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DealsQuery, DealsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DealsQuery, DealsQueryVariables>(DealsDocument, options);
        }
export type DealsQueryHookResult = ReturnType<typeof useDealsQuery>;
export type DealsLazyQueryHookResult = ReturnType<typeof useDealsLazyQuery>;
export type DealsQueryResult = Apollo.QueryResult<DealsQuery, DealsQueryVariables>;
export const OfficeSearchDataDocument = gql`
    query officeSearchData {
  officeSearchData {
    amenities {
      id
      name
    }
    providers {
      id
      name
    }
    regions {
      id
      name
      parentRegionId
    }
  }
}
    `;

/**
 * __useOfficeSearchDataQuery__
 *
 * To run a query within a React component, call `useOfficeSearchDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useOfficeSearchDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOfficeSearchDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useOfficeSearchDataQuery(baseOptions?: Apollo.QueryHookOptions<OfficeSearchDataQuery, OfficeSearchDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OfficeSearchDataQuery, OfficeSearchDataQueryVariables>(OfficeSearchDataDocument, options);
      }
export function useOfficeSearchDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OfficeSearchDataQuery, OfficeSearchDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OfficeSearchDataQuery, OfficeSearchDataQueryVariables>(OfficeSearchDataDocument, options);
        }
export type OfficeSearchDataQueryHookResult = ReturnType<typeof useOfficeSearchDataQuery>;
export type OfficeSearchDataLazyQueryHookResult = ReturnType<typeof useOfficeSearchDataLazyQuery>;
export type OfficeSearchDataQueryResult = Apollo.QueryResult<OfficeSearchDataQuery, OfficeSearchDataQueryVariables>;
export const OfficeSearchPropertyDocument = gql`
    query officeSearchProperty($filter: FindOfficePropertyFiltersInput) {
  officeSearchProperty(filter: $filter) {
    property {
      ...MapProperty
    }
  }
}
    ${MapPropertyFragmentDoc}`;

/**
 * __useOfficeSearchPropertyQuery__
 *
 * To run a query within a React component, call `useOfficeSearchPropertyQuery` and pass it any options that fit your needs.
 * When your component renders, `useOfficeSearchPropertyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOfficeSearchPropertyQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useOfficeSearchPropertyQuery(baseOptions?: Apollo.QueryHookOptions<OfficeSearchPropertyQuery, OfficeSearchPropertyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OfficeSearchPropertyQuery, OfficeSearchPropertyQueryVariables>(OfficeSearchPropertyDocument, options);
      }
export function useOfficeSearchPropertyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OfficeSearchPropertyQuery, OfficeSearchPropertyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OfficeSearchPropertyQuery, OfficeSearchPropertyQueryVariables>(OfficeSearchPropertyDocument, options);
        }
export type OfficeSearchPropertyQueryHookResult = ReturnType<typeof useOfficeSearchPropertyQuery>;
export type OfficeSearchPropertyLazyQueryHookResult = ReturnType<typeof useOfficeSearchPropertyLazyQuery>;
export type OfficeSearchPropertyQueryResult = Apollo.QueryResult<OfficeSearchPropertyQuery, OfficeSearchPropertyQueryVariables>;
export const OfficeSearchPropertiesDocument = gql`
    query officeSearchProperties($filter: FindOfficeFiltersInput) {
  officeSearchProperties(filter: $filter) {
    properties {
      ...MapProperties
    }
  }
}
    ${MapPropertiesFragmentDoc}`;

/**
 * __useOfficeSearchPropertiesQuery__
 *
 * To run a query within a React component, call `useOfficeSearchPropertiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useOfficeSearchPropertiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOfficeSearchPropertiesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useOfficeSearchPropertiesQuery(baseOptions?: Apollo.QueryHookOptions<OfficeSearchPropertiesQuery, OfficeSearchPropertiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OfficeSearchPropertiesQuery, OfficeSearchPropertiesQueryVariables>(OfficeSearchPropertiesDocument, options);
      }
export function useOfficeSearchPropertiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OfficeSearchPropertiesQuery, OfficeSearchPropertiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OfficeSearchPropertiesQuery, OfficeSearchPropertiesQueryVariables>(OfficeSearchPropertiesDocument, options);
        }
export type OfficeSearchPropertiesQueryHookResult = ReturnType<typeof useOfficeSearchPropertiesQuery>;
export type OfficeSearchPropertiesLazyQueryHookResult = ReturnType<typeof useOfficeSearchPropertiesLazyQuery>;
export type OfficeSearchPropertiesQueryResult = Apollo.QueryResult<OfficeSearchPropertiesQuery, OfficeSearchPropertiesQueryVariables>;
export const ProviderDocument = gql`
    query provider($id: String!) {
  provider(id: $id) {
    ...SingleProvider
  }
}
    ${SingleProviderFragmentDoc}`;

/**
 * __useProviderQuery__
 *
 * To run a query within a React component, call `useProviderQuery` and pass it any options that fit your needs.
 * When your component renders, `useProviderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProviderQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProviderQuery(baseOptions: Apollo.QueryHookOptions<ProviderQuery, ProviderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProviderQuery, ProviderQueryVariables>(ProviderDocument, options);
      }
export function useProviderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProviderQuery, ProviderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProviderQuery, ProviderQueryVariables>(ProviderDocument, options);
        }
export type ProviderQueryHookResult = ReturnType<typeof useProviderQuery>;
export type ProviderLazyQueryHookResult = ReturnType<typeof useProviderLazyQuery>;
export type ProviderQueryResult = Apollo.QueryResult<ProviderQuery, ProviderQueryVariables>;
export const UpdateProviderDocument = gql`
    mutation updateProvider($input: ProviderUpdateInput) {
  updateProvider(input: $input) {
    id
    name
    isActive
    website
    description
    headquarters
    logo {
      id
      location
    }
    address {
      id
      line1
      line2
      suburb
      city
      county
      country
      postcode
      latitude
      longitude
    }
    providerContact {
      contact {
        id
        firstName
        lastName
        email
        phone
      }
    }
  }
}
    `;
export type UpdateProviderMutationFn = Apollo.MutationFunction<UpdateProviderMutation, UpdateProviderMutationVariables>;

/**
 * __useUpdateProviderMutation__
 *
 * To run a mutation, you first call `useUpdateProviderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProviderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProviderMutation, { data, loading, error }] = useUpdateProviderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProviderMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProviderMutation, UpdateProviderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProviderMutation, UpdateProviderMutationVariables>(UpdateProviderDocument, options);
      }
export type UpdateProviderMutationHookResult = ReturnType<typeof useUpdateProviderMutation>;
export type UpdateProviderMutationResult = Apollo.MutationResult<UpdateProviderMutation>;
export type UpdateProviderMutationOptions = Apollo.BaseMutationOptions<UpdateProviderMutation, UpdateProviderMutationVariables>;
export const RemoveProviderRegionDocument = gql`
    mutation removeProviderRegion($input: RemoveProviderRegionInput) {
  removeProviderRegion(input: $input) {
    id
    name
    providerRegion {
      id
      region {
        id
        name
      }
    }
  }
}
    `;
export type RemoveProviderRegionMutationFn = Apollo.MutationFunction<RemoveProviderRegionMutation, RemoveProviderRegionMutationVariables>;

/**
 * __useRemoveProviderRegionMutation__
 *
 * To run a mutation, you first call `useRemoveProviderRegionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveProviderRegionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeProviderRegionMutation, { data, loading, error }] = useRemoveProviderRegionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveProviderRegionMutation(baseOptions?: Apollo.MutationHookOptions<RemoveProviderRegionMutation, RemoveProviderRegionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveProviderRegionMutation, RemoveProviderRegionMutationVariables>(RemoveProviderRegionDocument, options);
      }
export type RemoveProviderRegionMutationHookResult = ReturnType<typeof useRemoveProviderRegionMutation>;
export type RemoveProviderRegionMutationResult = Apollo.MutationResult<RemoveProviderRegionMutation>;
export type RemoveProviderRegionMutationOptions = Apollo.BaseMutationOptions<RemoveProviderRegionMutation, RemoveProviderRegionMutationVariables>;
export const AddProviderRegionDocument = gql`
    mutation addProviderRegion($input: AddProviderRegionInput) {
  addProviderRegion(input: $input) {
    id
    name
    providerRegion {
      id
      region {
        id
        name
      }
    }
  }
}
    `;
export type AddProviderRegionMutationFn = Apollo.MutationFunction<AddProviderRegionMutation, AddProviderRegionMutationVariables>;

/**
 * __useAddProviderRegionMutation__
 *
 * To run a mutation, you first call `useAddProviderRegionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddProviderRegionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addProviderRegionMutation, { data, loading, error }] = useAddProviderRegionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddProviderRegionMutation(baseOptions?: Apollo.MutationHookOptions<AddProviderRegionMutation, AddProviderRegionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddProviderRegionMutation, AddProviderRegionMutationVariables>(AddProviderRegionDocument, options);
      }
export type AddProviderRegionMutationHookResult = ReturnType<typeof useAddProviderRegionMutation>;
export type AddProviderRegionMutationResult = Apollo.MutationResult<AddProviderRegionMutation>;
export type AddProviderRegionMutationOptions = Apollo.BaseMutationOptions<AddProviderRegionMutation, AddProviderRegionMutationVariables>;
export const AddProviderContactDocument = gql`
    mutation addProviderContact($input: ProviderContactUpdateInput) {
  addProviderContact(input: $input) {
    ...ProviderContactStub
  }
}
    ${ProviderContactStubFragmentDoc}`;
export type AddProviderContactMutationFn = Apollo.MutationFunction<AddProviderContactMutation, AddProviderContactMutationVariables>;

/**
 * __useAddProviderContactMutation__
 *
 * To run a mutation, you first call `useAddProviderContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddProviderContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addProviderContactMutation, { data, loading, error }] = useAddProviderContactMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddProviderContactMutation(baseOptions?: Apollo.MutationHookOptions<AddProviderContactMutation, AddProviderContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddProviderContactMutation, AddProviderContactMutationVariables>(AddProviderContactDocument, options);
      }
export type AddProviderContactMutationHookResult = ReturnType<typeof useAddProviderContactMutation>;
export type AddProviderContactMutationResult = Apollo.MutationResult<AddProviderContactMutation>;
export type AddProviderContactMutationOptions = Apollo.BaseMutationOptions<AddProviderContactMutation, AddProviderContactMutationVariables>;
export const UpdateProviderContactDocument = gql`
    mutation updateProviderContact($input: ProviderContactUpdateInput) {
  updateProviderContact(input: $input) {
    ...ProviderContactStub
  }
}
    ${ProviderContactStubFragmentDoc}`;
export type UpdateProviderContactMutationFn = Apollo.MutationFunction<UpdateProviderContactMutation, UpdateProviderContactMutationVariables>;

/**
 * __useUpdateProviderContactMutation__
 *
 * To run a mutation, you first call `useUpdateProviderContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProviderContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProviderContactMutation, { data, loading, error }] = useUpdateProviderContactMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProviderContactMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProviderContactMutation, UpdateProviderContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProviderContactMutation, UpdateProviderContactMutationVariables>(UpdateProviderContactDocument, options);
      }
export type UpdateProviderContactMutationHookResult = ReturnType<typeof useUpdateProviderContactMutation>;
export type UpdateProviderContactMutationResult = Apollo.MutationResult<UpdateProviderContactMutation>;
export type UpdateProviderContactMutationOptions = Apollo.BaseMutationOptions<UpdateProviderContactMutation, UpdateProviderContactMutationVariables>;
export const RemoveProviderContactDocument = gql`
    mutation removeProviderContact($input: ProviderContactUpdateInput) {
  removeProviderContact(input: $input) {
    ...ProviderContactStub
  }
}
    ${ProviderContactStubFragmentDoc}`;
export type RemoveProviderContactMutationFn = Apollo.MutationFunction<RemoveProviderContactMutation, RemoveProviderContactMutationVariables>;

/**
 * __useRemoveProviderContactMutation__
 *
 * To run a mutation, you first call `useRemoveProviderContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveProviderContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeProviderContactMutation, { data, loading, error }] = useRemoveProviderContactMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveProviderContactMutation(baseOptions?: Apollo.MutationHookOptions<RemoveProviderContactMutation, RemoveProviderContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveProviderContactMutation, RemoveProviderContactMutationVariables>(RemoveProviderContactDocument, options);
      }
export type RemoveProviderContactMutationHookResult = ReturnType<typeof useRemoveProviderContactMutation>;
export type RemoveProviderContactMutationResult = Apollo.MutationResult<RemoveProviderContactMutation>;
export type RemoveProviderContactMutationOptions = Apollo.BaseMutationOptions<RemoveProviderContactMutation, RemoveProviderContactMutationVariables>;
export const AvailablePropertiesDocument = gql`
    query availableProperties($filter: FindOfficeFiltersInput) {
  availableProperties(filter: $filter) {
    ...AvailableProperty
  }
}
    ${AvailablePropertyFragmentDoc}`;

/**
 * __useAvailablePropertiesQuery__
 *
 * To run a query within a React component, call `useAvailablePropertiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAvailablePropertiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAvailablePropertiesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useAvailablePropertiesQuery(baseOptions?: Apollo.QueryHookOptions<AvailablePropertiesQuery, AvailablePropertiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AvailablePropertiesQuery, AvailablePropertiesQueryVariables>(AvailablePropertiesDocument, options);
      }
export function useAvailablePropertiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AvailablePropertiesQuery, AvailablePropertiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AvailablePropertiesQuery, AvailablePropertiesQueryVariables>(AvailablePropertiesDocument, options);
        }
export type AvailablePropertiesQueryHookResult = ReturnType<typeof useAvailablePropertiesQuery>;
export type AvailablePropertiesLazyQueryHookResult = ReturnType<typeof useAvailablePropertiesLazyQuery>;
export type AvailablePropertiesQueryResult = Apollo.QueryResult<AvailablePropertiesQuery, AvailablePropertiesQueryVariables>;
export const AvailablePropertyDocument = gql`
    query availableProperty($id: String!) {
  availableProperty(id: $id) {
    ...AvailableProperty
  }
}
    ${AvailablePropertyFragmentDoc}`;

/**
 * __useAvailablePropertyQuery__
 *
 * To run a query within a React component, call `useAvailablePropertyQuery` and pass it any options that fit your needs.
 * When your component renders, `useAvailablePropertyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAvailablePropertyQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAvailablePropertyQuery(baseOptions: Apollo.QueryHookOptions<AvailablePropertyQuery, AvailablePropertyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AvailablePropertyQuery, AvailablePropertyQueryVariables>(AvailablePropertyDocument, options);
      }
export function useAvailablePropertyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AvailablePropertyQuery, AvailablePropertyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AvailablePropertyQuery, AvailablePropertyQueryVariables>(AvailablePropertyDocument, options);
        }
export type AvailablePropertyQueryHookResult = ReturnType<typeof useAvailablePropertyQuery>;
export type AvailablePropertyLazyQueryHookResult = ReturnType<typeof useAvailablePropertyLazyQuery>;
export type AvailablePropertyQueryResult = Apollo.QueryResult<AvailablePropertyQuery, AvailablePropertyQueryVariables>;